export default {
  seleccionaNegocio: "Hautatu negozioa...",
  filtraPorEtiqueta: "Iragazi etiketa bidez",
  noEncontramosResultadosPara: "Ez dugu emaitzarik aurkitu ",
  mostrando: "Erakusten",
  resultado: "emaitza",
  resultados: "emaitzak",

  // ALMACÉN
  totalAlmacen: "Biltegiko Guztira",
  totalAlmacenDto: "Biltegiko Guztira Deskontuarekin",
  existenciasTeoricas: "Teorikoak diren stockak",
  diferencia: "Desberdintasuna",
  noContabilizado: "Kontabilizatu gabe",
  seleccioneUnaFechaDeInicioYUnaFechaDeFin:
    "Hautatu hasiera-data eta amaiera-data",

  // INFORMES
  inicio: "Hasiera",
  informes: "Txostenak",
  productos: "Produktua",
  ventasPorNegocio: "Salmentak negozioaren arabera",
  casas: "Etxeak",
  facturasSimplificadas: "Fakturak sinplifikatuak",
  comprasPorNegocio: "Erosketak negozioaren arabera",
  comprasPorCasas: "Erosketak etxeen arabera",
  gastosPorProveedor: "Gastuen hornitzailearen arabera",
  gastosPorSubproductos: "Gastuen lehengaiaren arabera",
  sage: "SAGE",
  sageplancuentas: "Kontuen Plana",
  sageclientes: "Bezeroak",
  sageefectos: "Emaitzak",
  sageasientos: "Kontu-sarrera",

  // CASAS
  nuevaCasa: "Etxe berria",
  casa: "Etxea",
  negocio: "Negozioa",
  desde: "Hasiera",
  hasta: "Amaiera",
  consultar: "Kontsultatu",
  infoCasas:
    "Etxe hauen kontsumoa hautatutako data-tartean sartutako gastuetatik dator",
  exportarInforme: "Txostena esportatu",
  exportarPdf: "PDF gisa esportatu",
  exportarExcel: "Excel gisa esportatu",
  exportarExcelSinSubproductos: "Excel gisa esportatu lehengaiak barne",

  // TABLA
  fecha: "Data",
  subproductos: "Lehengaiak",
  subproducto: "Lehengaia",
  unidades: "Unitateak",
  partes: "Zatiak",
  precio: "Prezioa",
  total: "Guztira",
  infoConsumo:
    "Etxe hauen kontsumoa hautatutako data-tartean sartutako gastuetatik dator",
  noHay: "Ez dago",
  gastos: "Gastuak",
  rangoDeFechas: "data-tarte honetan.",
  clickConsultarParaRealizarBusqueda: "Egin klik Kontsultatu botoian bilaketa egiteko",
  avisoDatosUltimaConsulta: "Datu hauek egindako azken kontsultakoak dira. Negozioa, TPBa edo datak aldatu badituzu, sakatu \"Kontsultatu\" eguneratzeko.",
  ultimaActualizacion: "Azken eguneratzea",
  negocioBloqueadoConsultasEnCurso: "Kontsultak martxan daude. Itxaron amaitu arte negozioz aldatzeko.",
  configuracion: "Konfigurazioa",
  datosFiscales: "Datu fiskalak",

  // DATOS FISCALES
  nombreFiscal: "Izena fiskala",

  // FORM CASA
  nombreCasa: "Etxearen izena",
  cifNif: "CIF/NIF",
  direccion: "Helbidea",
  provincia: "Probintzia",
  ciudad: "Hiria",
  codigoPostal: "Posta kodea",
  pais: "Herrialdea",
  telefono: "Telefonoa",
  correoElectronico: "Posta elektronikoa",
  iban: "IBAN",
  numeroRegistroSanitario: "Erregistro sanitario zenbakia",
  baja: "Baja",
  guardar: "Gorde",
  cancelar: "Ezeztatu",
  replicar: "Beste negozioetan errepikatu",
  replicarCasa: "Etxea beste negozioetan errepikatu",
  seleccionarTodos: "Guztiak hautatu",
  aceptar: "Onartu",
  casaMin: "etxeak",

  compras: "Erosketak",
  agregarCasa: "Etxe berria gehitu",
  email: "Email",
  acciones: "Ekintzak",
  turnos: "Txandak",
  editar: "Editatu",
  enEsteNegocio: " negozio honetan.",

  // PLACEHOLDER
  introduzcaNombre: "Sartu izena",
  introduzcaCifNif: "Sartu CIF/NIF",
  introduzcaDireccion: "Sartu helbidea",
  introduzcaProvincia: "Sartu probintzia",
  introduzcaCiudad: "Sartu hiria",
  introduzcaCodigoPostal: "Sartu posta kodea",
  introduzcaTelefono: "Sartu telefonoa",
  introduzcaCorreo: "Sartu posta elektronikoa",
  introduzcaIban: "Sartu IBAN",
  introduzcaNumeroRegistroSanitario: "Sartu erregistro sanitario zenbakia",
  buscar: "Bilatu...",

  // PROVEEDORES
  proveedores: "Hornitzaileak",
  agregarProveedor: "Hornitzaile berria gehitu",
  categoria: "Kategoria",
  proveedoresMin: "hornitzaileak",

  // FORM
  nombreProveedor: "Hornitzailearen izena",
  acreedor: "Kreditoria",
  infoAcreedor:
    "(Hornitzaile bat kreditoria bada, ez da agertuko Numier TPV-n)",
  replicarProveedor: "Hornitzailea beste negozioetan errepikatu",
  category: "Kategoria",
  replicarCategory: "Etiketa beste negozioetan errepikatu",

  // ETIQUETAS
  etiquetas: "Etiketak",
  etiqueta: "Etiketa",
  sinEtiqueta: "Etiketarik gabe",
  nuevaEtiqueta: "Etiketa berria",
  agregarEtiqueta: "Etiketa gehitu",
  tipo: "Mota",
  etiquetaPadre: "Aita etiketa",
  tipoPadre: "Aita mota",

  // FORM
  nombreEtiqueta: "Etiketaren izena",

  // SUBPRODUCTOS
  agregarSubproducto: "Lehengaia gehitu",
  precioCompra: "Erosketa-prezioa",
  escandallo: "Eskandallo",
  subproductosCreados: "Sortutako lehengaiak",
  nuevaCategoria: "Kategoria berria",
  materiaPrima: "Lehengaia",
  materiasPrimas: "Lehengaiak",

  // FORM
  nuevoProveedor: "Hornitzaile berria",
  nombreSubproducto: "Lehengaiaren izena",
  codigoBarra: "Barcode",
  descripcion: "Deskribapena",
  tipoIva: "BEZa mota",
  cuotaIVA: "BEZ kuota",
  ivaIncluido: "(BEZ barne)",
  descuentoCompra: "Erosketa deskontua",
  porcentaje: "(% Portzentajea)",
  guardarEnAlmacen: "Biltegian gorde",
  stockMinimo: "Gutxieneko stocka",
  stockOptimo: "Stock optimoa",
  gastosPorProveedoresUnidos: "Hornitzaile batzuen gastuak",
  caracteresRestantes: "Geratzen diren karaktereak",

  // INFORME SUBPRODUCTO
  referencia: "Erreferentzia",
  uds: "Uds",
  iva: "BEZa",
  importe: "Zenbatekoa",
  imp: "Zenb.",
  sinDto: "DESKONTU GABE",
  importeConIva: "Zenbatekoa BEZarekin",
  importeSinIva: "Zenbatekoa BEZ gabe",
  importeSinIvaDto: "Zenbatekoa BEZ gabe deskontuarekin",
  precioUdSinIva: "Prezioa / ud BEZ gabe",
  dto: "Desk.",
  ttal: "Guztira",

  // PRODUCTOS
  producto: "Produktua",
  precioDeCoste: "Kostu-prezioa",
  tarifa1: "Tarifa 1",
  tarifa2: "Tarifa 2",
  tarifa3: "Tarifa 3",
  tarifa4: "Tarifa 4",
  agregarProductos: "Produktua gehitu",
  noHayProductosEnEsteNegocio: "Ez dago produktuik negozio honetan",
  sinCategoria: "Kategoriarik gabe",
  cliente: "Bezeroa",

  // FORM
  nombreProducto: "Produktuen izena",
  codigoDeBarra: "Barcode",
  colorBoton: "Botoiaren kolorea",
  descuento: "Deskontua",
  precioCoste: "Kostu-prezioa",
  opcionesAlSeleccionarElArticulo: "Produktua hautatzean aukerak",
  numeroDeOpcionales: "Aukerako lehengai kopurua",
  impresoraComandasTPV: "TPV aginduen inprimagailua",
  impresoraComandasPDA: "PDA aginduen inprimagailua",
  copiaImpresoraComandasTPV: "TPV aginduen inprimagailuaren kopia",
  copiaImpresoraComandasPDA: "PDA aginduen inprimagailuaren kopia",
  impresionPlano: "Plano inprimagailua",
  impresionPlanoKDS: "Plano KDS inprimagailua",
  copiaImpresionPlano: "Plano inprimagailuaren kopia",
  copiaImpresionPlanoKDS: "Plano KDS inprimagailuaren kopia",
  impresionPlano1: "Plano 1 inprimagailua",
  impresionPlano2: "Plano 2 inprimagailua",
  impresionPlano3: "Plano 3 inprimagailua",
  impresionKDSTPV: "Agindua TPV-tik bidali",
  impresionKDSPDA: "Agindua PDA-tik bidali",
  copiaImpresionKDSTPV: "Aginduen kopia TPV-tik",
  copiaImpresionKDSPDA: "Aginduen kopia PDA-tik",
  pedirPrecio: "Prezioa eskatu",
  pedirPeso: "Pisua eskatu",
  pedirImporte: "Zenbatekoa eskatu",
  promocionable: "Promozionagarria",
  mostrarPC: "PC-n erakutsi",
  mostrarPDA: "PDA-n erakutsi",
  noImprimir: "Ez inprimatu",
  numeroPlato: "Lehentasunezko plater zenbakia",
  seleccionIngredientes: "Osagaiak hautatzeko aukera aktibatu",
  introduzcaDescripcion: "Sartu deskribapena",
  introduzcaCodigoDeBarras: "Sartu barcode-a",
  introduzcaPrecioCoste: "Sartu kostu-prezioa",
  opcion1: "Aukera 1",
  opcion2: "Aukera 2",
  opcion3: "Aukera 3",
  opcion4: "Aukera 4",
  opcion5: "Aukera 5",
  numOpcionales: "Aukerako lehengai kopurua",

  // OPERARIOS
  operarios: "Langileak",
  agregarOperario: "Langilea gehitu",
  apellido: "Abizena",
  nombreOperarios: "Langileen izena",
  pass: "Pasahitza",
  salario: "Soldata",
  passTurn: "Txandako pasahitza",
  hombre: "Gizona",
  mujer: "Emakumea",
  replicarProducto: "Produktua beste negozioetan errepikatu",
  introduzcaEscandallo: "Sartu eskandallo",
  introduzcaStockMinimo: "Sartu gutxieneko stocka",
  introduzcaStockOptimo: "Sartu stock optimoa",
  introduzcaPrecioCompra: "Sartu erosketaren prezioa",
  introduzcaApellido: "Sartu abizena",
  introduzcaPass: "Sartu pasahitza",
  introduzcaEmail: "Sartu email-a",
  introduzcaSalario: "Sartu soldata",
  introduzcapassTurn: "Sartu txandako pasahitza",
  replicarOperario: "Langilea beste negozio batean errepikatu",
  TPV: "TPV",
  precioMed: "Prezio Med.",
  precioMedSinIva: "Prezio Med BEZ gabe",
  porUnidad: "Unitate bakoitzeko",
  porImporte: "Zenbatekoaren arabera",
  contrasenya: "PDA pasahitza",
  repartidor: "Banatzailea",
  buscaRepartidor: "banatzailea bilatu",
  noMostrarEnVentas: "Ez erakutsi salmentetan",
  noHayOperariosEnEsteNegocio: "Ez dago langilerik negozio honetan",
  VerDetalles: "Xehetasunak ikusi",
  codigoTurno: "Txandako kodea",
  operarioDatosIncompletos: "Derrigorrezko eremu guztiak bete behar dira",
  enviarQR: "Bidali txanden QR",
  descargarTurnoQR: "Deskargatu PDF QR txandeekin",
  enviarEmailTurnoQR: "Bidali QR txanden posta elektronikoz",
  emailEnviado: "Posta elektronikoa behar bezala bidali da",
  enviado: "Bidalia",
  errorActualizar: "Errorea langilea eguneratzean",
  errorEnviarEmail: "Posta elektronikoa ezin izan da bidali",
  accesoDenegado: "Sarbidea debekatuta",
  noTienesPermisosParaRealizar: "Ez duzu baimenik ekintza hau burutzeko",
  emailNoValido: "Posta elektronikoak ez du formaturik zuzena",
  gestionTurnos: "Txandak langilearen arabera",
  gestionTurnosSubtitle: "Langileen fitxaketak kontsultatu eta kudeatu",
  gestionTurnosSubtitleConsulta: "Kontsultatu eta kudeatu",
  gestionTurnosSubtitleDeLos: "horien",
  gestionTurnosSubtitleFichajes: "fitxaketak",
  gestionTurnosSubtitleOperarios: "langileen",

  // CLIENTES
  clientes: "Bezeroak",
  companyia: "Kanpaina",
  agregarCliente: "Bezeroa gehitu",
  nombreCliente: "Bezeroaren izena",
  saldo: "Saldoa",
  infoCliente: "Saldo txartelak erabiltzen direnean",
  tarifa: "Tarifa",
  descuentoImporte: "Zenbateko deskontua",
  noHayClientesEnEsteNegocio: "Ez dago bezeroik negozio honetan",
  barCode: "Barcode",
  cuentaContableSocio: "Bazkidearen kontu-kontabilitatea",
  cuentaContableLevy: "Levy kontu-kontabilitatea",

  // IMPRESION
  impresionDeComandas: "Aginduen inprimaketa",
  copiaDeImpresionDeComandas: "Aginduen inprimaketaren kopia",
  impresionPorPlana: "Planoaren arabera inprimatu",
  impresionPorKDS: "KDS bidez inprimatu",
  monitorDeCocina: "Sukaldearen monitorea",

  // INFORMES
  ventas: "Salmentak",
  tarjetas: "Txartelak",
  cheque: "Txeke",
  cambio: "Aldaketa",
  recuento: "Kontaketa",
  descuadre: "Desoreka",
  siguienteDia: "Hurrengo eguna",
  incidencias: "Intzidentziak",
  recaudado: "Bilketa",
  noHayVentasEnEsteRangoDeFechas: "Ez dago salmentarik datu-tarte honetan",
  tickets: "Sarreren",
  factura: "Faktura",
  noHayFormasDePagoEnEsteRangoDeFecha:
    "Ez dago ordainbide modurik datu-tarte honetan",
  desglose: "Banaketa",
  sinBase: "Oinarri gabe",
  base: "Oinarri",
  baseTotal: "Oinarri guztira",
  impuesto: "Zergak",
  facturasEmitidas: "Faktura nominak",
  mesa: "Mahai",
  cifnif: "CIF/NIF",
  cobro: "Ordainketa",
  noHayFacturasEmitidasEnEsteRangoDeFecha:
    "Ez dago faktura igorri datu-tarte honetan",
  estadisticasAgencias: "Agentzien estatistikak",
  agencia: "Agentzia",
  comentario: "Iruz.",
  noHayEstadisticasDeAgenciaEnEsteRangoDeFechas:
    "Ez dago agentzia estatistikorik datu-tarte honetan",
  desglosesImpuestos: "Kutxaren itxierako zergak",
  desglosesImpuestosAgencia: "Agentziaren zergak",
  noHayFormasDePagoEnEsteRangoDeFechas:
    "Ez dago ordainbide modurik datu-tarte honetan",
  cuentasAparcadas: "Kreditu kontuak",
  operacion: "Operazioa",
  operario: "Langilea",
  noExisteDesgloseImpuestos: "Ez dago zergen banaketarik",
  noHayCuentasAparcadasEnEsteRangoDeFechas:
    "Ez dago kreditu konturik datu-tarte honetan",
  noHayCuentasAnuladasEnEsteRangoDeFechas:
    "Ez dago bertan behera utzitako konturik datu-tarte honetan",
  cierreCaja: "Kutxaren itxiera",
  fechaCierre: "Itxieraren data",
  venta: "Salmenta",
  totalRecaudado: "Bilketa guztira",
  noHayCierresDeCajaEnEsteRangoDeFecha:
    "Ez dago kutxaren itxierarik datu-tarte honetan",
  cierreCajaZ: "Kutxa Z itxiera",

  // MODAL
  n: "Zenb.",
  apertura: "Ireki",
  cierre: "Itxi",
  totalVenta: "Salmenta guztira",
  efectivo: "Esku-hutsa",
  tarjetaCheques: "Txartel+Txekeak",
  totalTeorico: "Guztira teorikoa",
  totalEnArqueo: "Guztira kontaketetan",
  cambioSig: "Hurrengo aldaketa",
  volver: "Itzuli",
  confirmacionImportacionHeader: "Inportazioaren baieztapena",
  confirmacionImportacionText: "Ziur zaude inportatu nahi duzula?",
  confirmar: "Baieztatu",
  registros: "erregistroak",
  headerError: "ERROREA",
  bodyError: "Mesedez, sartu 10.000 erregistro baino gutxiagoko fitxategi bat",
  en: " -en ",

  // OPERARIOS
  ventasPorOperarios: "Langilearen salmenta kontuak",
  invitaciones: "Gonbidapenak",
  horas: "Orduak",
  sueldo: "Soldata",
  categorias: "Kategoriak",

  // CLIENTES
  ventasPorClientes: "Bezeroaren salmentak",
  companya: "Enpresa",
  consumiciones: "Kontsumoak",
  media: "Bataz besteko",
  valorMedioDelTicket: "Tiketaren batez besteko balioa",
  todosLosClientes: "Bezero guztiak",
  todosLosOperarios: "Langile guztiak",
  operariosAplicar: "Aplikatuko zaien langileak",
  rentabilidadInfo: "Batez besteko prezioa ken lehengaien kostua (produktuaren kostu-prezioa)",
  sinPrecioDeCoste: "Kostu-preziorik ez: kalkulatu Tresnetatik edo produktuaren fitxan",
  buscarCliente: "Bilatu bezeroa izenaren, kodearen edo IFZren arabera…",
  clientesConVentasEnElPeriodo: "salmentekin aldian",
  noHayClientesConVentas: "Ez dago salmentak dituen bezerorik aldian",
  ningunClienteCoincide: "Ez dago bilaketarekin bat datorren bezerorik",
  seleccionados: "hautatuta",
  clientesSeleccionados: "bezero hautatuta",
  quitarFiltro: "Kendu iragazkia",
  deLosClientes: "{total} bezeroetatik",
  buscarOperario: "Bilatu langilea...",
  ninguno: "Bat ere ez",
  mas: "gehiago",
  ningunOperarioCoincide: "Ez dago bat datorren langilerik",
  ningunOperario: "Langilerik ez",
  deOperarios: "{total} langiletik",
  eligeAlMenosUnOperario: "Aukeratu gutxienez langile bat murrizketak aplikatzeko",
  mediaSesion: "Saio bataz bestekoa",

  // AGENCIAS
  noHayAgenciasEnEsteMomento: "Momentu honetan ez dago agentziarik",
  agencias: "Agentziak",
  nombreAgencia: "Agentziaren izena",
  comision: "Batzordea",
  replicarAgencias: "Agentzia errepikatu",
  agregarAgencias: "Agentzia gehitu",

  // MODIFICADORES
  nombreModificador: "Modifikatzailearen izena",
  grupos: "Taldeak",
  variacion: "Aldaketa",
  resta: "Kendu",
  suma: "Gehitu",
  modificador: "Modifikatzailea",
  modificadores: "Modifikatzaileak",
  agregarModificador: "Modifikatzailea gehitu",
  grupo: "Taldea",
  noHayModificadoresEnEsteNegocio: "Ez dago modifikatzaileik negozio honetan",
  almacen: "Biltegia",
  todos: "Denak",
  precioCompraConIva: "Erosketa prezioa BEZarekin",
  precioCompraSinIva: "Erosketa prezioa BEZ gabe",
  precioDescuentoSinIva: "Deskontuarekin prezioa BEZ gabe",
  codigoIdentificacion: "Identifikazio kodea",
  replicarModificador: "Modifikatzailea errepikatu",

  // SOPORTE ONLINE
  soporteOnline: "Lineako Laguntza",
  soporteOnlineDetails: "Lineako Laguntza - Xehetasunak",
  abierto: "Irekitua",
  esperandoRespuesta: "Erantzunaren zain",
  respondido: "Erantzuna bidalia",
  cerrado: "Itxita",
  tecnico: "Teknikoa",
  comercial: "Merkataritza",
  facturacion: "Fakturazioa",
  noTicketsEnNegocio: "Ez dago tiketerik negozio honetan",
  responderTicket: "Ticketi erantzun",
  mensaje: "Mezua",
  cerrar: "Itxi",
  enviarTicket: "Ticket bidali",
  nuevoTicket: "Ticket berria",
  asunto: "Gai",
  estado: "Egoera",
  departamento: "Sail",
  visitas: "Bisita",
  verTicket: "Ticket ikusi",
  tarjeta: "Txartela",

  // FORMAS DE PAGO
  nueva: "Berria",
  replicarFormaDePago: "Ordainbide modua errepikatu",
  nombreFormaPago: "Ordainbide modua izena",
  formaDePago: "Ordainbide modua",
  formasDePago: "Ordainbide moduak",
  agregarFormaDePago: "Ordainbide modua gehitu",
  noHayFormasDePagoEnEsteNegocio: "Ez dago ordainbide modurik negozio honetan",
  nuevo: "Berria",
  renovado: "Berritua",

  // EDICIÓN MASIVA
  transferirProductosDeCategoria: "Kategoriako produktuak transferitu",
  tranferir: "Transferitu",
  impresionDeProductosDeCategorias: "Kategoriako produktuen inprimaketa",
  impresoraComanda: "Aginduen inprimagailua",
  impresoraComandaTpv: "TPV aginduen inprimagailua",
  impresoraComandaPda: "PDA aginduen inprimagailua",
  copiaImpresionDeComanda: "Aginduen inprimaketaren kopia",
  copiaImpresoraComandasTpv: "TPV aginduen inprimagailuaren kopia",
  copiaImpresoraComandasPda: "PDA aginduen inprimagailuaren kopia",
  impresionPorPlano: "Planoaren arabera inprimatu",
  enviarComandaDesdeTpv: "Agindua TPV-tik bidali",
  enviarComandaDesdePda: "Agindua PDA-tik bidali",
  respetarOtrasImpresiones: "Beste inprimaketak errespetatu?",
  cambioDePrecioProductos: "Produktuen prezio aldaketa",
  opcion: "Aukera",
  tipoDeTarifa: "Tarifa mota",
  cambiarPrecio: "Prezioa aldatu",
  ajustes: "Ezarpenak",
  cambiarImpresionDeGrupo: "Taldearen inprimaketa aldatu",
  tranferirProductosDeUnaCategoriaAOtra:
    "Produktuak kategoriatik bestera transferitu",
  cambiarPreciosAProductos: "Produktuen prezioak aldatu",

  // WIDGETS
  consumoPorHoras: "Salmentak orduka",
  productosMasVendidos: "Salmenta gehien dituzten produktuak",
  ultimosTickets: "Azken tiketa",
  verTodos: "Denak ikusi",
  arqueoDeCaja: "Kutxaren kontaketa",
  cobrado: "Bilketa eginda",

  cajaCerrada: "Kutxa itxita",
  licenciaCaducada: "Lizentzia iraungi da",
  cajonInteligente: "Kutxa adimenduna",
  moneda: "Moneta",
  nivelReciclador: "Birziklatzaile maila",
  totalReciclador: "Birziklatzaile guztira",
  nivelCasete: "Kasetearen maila",
  totalCasete: "Kasete guztira",
  totalMonedas: "Moneta guztira",
  totalBilletes: "Diru-zorren guztira",
  totalEnDirectoPorNegocio: "Negozio bakoitzeko salmenta zuzena",
  enCuenta: "Kontuan",
  cajaOnline: "Kutxa linean",
  planoDeMesas: "Mahai planoa",
  planoDeTaquillas: "Albokien planoa",
  nombrePlano: "Plano izena",
  mesas: "Mahaik",
  taquillas: "Albokik",
  ocupacion: "Ocupazioa",
  enPlano: "Planoan",
  desgloseTicket: "Ticketaren banaketa",
  precioMedio: "Bataz besteko prezioa",
  apuntado: "Apuntatua",
  anulado: "Bertan behera utzia",
  aparcado: "Kredituan",
  indicencias: "Intzidentziak",
  filtrarOperario: "Langilea iragazi",
  situacionActualDeLosNivelesDelCajonInteligente:
    "Kutxa adimenduneko mailen egoera",
  verDetallesDeNiveles: "Mailen xehetasunak ikusi",
  noHayCajonInteligenteParaMostrar: "Ez dago kutxa adimendunik erakusteko",
  consulteConSuDistribuidor: "Kontsultatu zure banatzailearekin",
  comparativaVentasAnteriores: "Aurreko salmenten konparazioa",
  graficaDeConsumoRespectoAHistoricoDeSesiones:
    "Kontsumo grafikoa saioen historikoarekiko",
  graficaDeConsumoAgrupadaPorTramosHorarios:
    "Kontsumo grafikoa ordutegien arabera",
  situacionActualDeOcupacionDeMesas: "Mahaien okupazioaren egoera",
  situacionActualDeOcupacionDeTaquillas: "Albokien okupazioaren egoera",
  verPlanoCompleto: "Plano osoa ikusi",
  rankingDeLaSesionActual: "Uneko saioaren ranking-a",
  ultimosMovimientosDeLaCajaPorOperario:
    "Kutxako azken mugimenduak langilearen arabera",
  estadoActualDeLaCaja: "Kutxaren egoera",
  turnosDeOperarios: "Langileen txandak",
  relacionDeHorasTrabajadasYVentasRealizadasPorOperario:
    "Lanorduak eta salmentak langilearen arabera",
  horarioInicio: "Hasiera ordua",
  horaFin: "Amaiera ordua",
  horasTrabajadas: "Lanorduak",
  noHayTurnosDeOperarioParaMostrar: "Ez dago erakusteko langileen txandarik",
  propuestaDePedido: "Eskaera proposamena",
  pedidoAProveedor: "Eskaera hornitzaileari",
  atencionHayMovimientosDeAlmacenQueNoSeHanDescargadoEnElNegocio:
    "Arreta, biltegi mugimendu batzuk ez dira deskargatu negozioan",
  seleccionarNegocio: "Negozioa hautatu",
  seleccionarProveedor: "Hornitzailea hautatu",
  generarPedidoEnBlanco: "Eskaera hutsa sortu",
  generarPedido: "Eskaera sortu",
  propuestaDePedidoA: "Eskaera proposamena ",
  buscarMateriaPrimaEnElMismoProveedor:
    "Bilatu lehengai bera hornitzaile berean",
  precioIVAIncluido: "Prezioak BEZ barne",
  ref: "Erref.",
  nombre: "Izena",
  existencias: "Stock",
  pedido: "Eskaera",
  precioArticuloUnidad: "Artikuluaren prezioa / unitatea",
  precioPedido: "Eskaera prezioa",
  sinIVA: "BEZ gabe",
  porcentajeIVA: "% BEZ",
  precioIVA: "BEZ prezioa",
  porcentajeDto: "% Desk.",
  totalIVA: "BEZ guztira",
  observaciones: "Oharrak",
  noHaySubproductosEnEsteNegocioParaRealizarElPedido:
    "Ez dago subprodukturik eskaera egiteko negozio honetan",
  recuerdeQueParaQueAparezcanLosSubproductosDebenDeEstarAsociadosAUnProveedorYConfiguradosElStockMinimoYStockOptimo:
    "Gogoratu subproduktuak ager daitezen, hornitzaile bati lotuta egon behar dutela eta gutxieneko eta optimoko stocka konfiguratu behar dela",
  guardarPedido: "Eskaera gorde",
  totalIVAInc: "BEZ guztira barne",
  pedidosAProveedor: "Eskaera hornitzaileari",
  fechaInicio: "Hasiera data",
  fechaFin: "Amaiera data",
  pedidosConvertidos: "Eskaerak bihurtuak",
  nuevoPedido: "Eskaera berria",
  enviarPedidos: "Eskaerak bidali",
  convertido: "Bihurtua",
  convertirEnGasto: "Gastu bihurtu",
  modificar: "Aldatu",
  eliminar: "Ezabatu",
  descargarComoPDF: "PDF moduan deskargatu",
  descargarComoPDFSinPrecios: "PDF moduan deskargatu preziorik gabe",
  descargarComoExcel: "Excel moduan deskargatu",
  descargarComoExcelSinPrecios: "Excel moduan deskargatu preziorik gabe",
  enviarPorCorreo: "Postaz bidali",
  eliminarListaCorreo: "Posta zerrenda ezabatu",
  anyadirListaCorreo: "Posta zerrenda gehitu",
  noHayPedidosAEsteProveedorEnEsteRangoDeFecha:
    "Ez dago eskaerarik hornitzaile honi datu-tarte honetan",
  enviarPedido: "Eskaera bidali",
  enviarPedidoA: "Eskaera bidali ",
  formato: "Formatua",
  PDF: "PDF",
  excel: "Excel",
  conPrecios: "Prezioarekin",
  sinPrecios: "Preziorik gabe",
  convertirPedido: "Eskaera bihurtu",
  tipoDeDocumento: "Dokumentu mota",
  albaran: "Albarán",
  generarEntradaEnAlmacenAlVerificar: "Biltegirako sarrera sortu egiaztatzean",
  gastosDeCasas: "Etxe gastuak",
  gastosPorCasa: "Etxe bakoitzeko gastuak",
  noHayGastosPorCasasEnEsteRangoDeFechas:
    "Ez dago etxe gasturik datu-tarte honetan",
  ventasDeCategorias: "Kategoriako salmentak",
  ventasCategoriaDe: "Salmentak kategoriaren arabera ",
  volverAGeneral: "Itzuli orokorrean",
  ventasDeProductos: "Produktuen salmentak",
  filtrarPorTPV: "TPV arabera iragazi",
  filtrarTPV: "TPV iragazi",
  turnosDe: "Txandak ",
  enActivo: "Aktiboan",
  ventasDeProductosDe: "Salmenta kontuak produktuak arabera ",
  ignorarRecuentosNegativos: "Zenbaki negatiboak ez kontuan hartu",
  ventasOperarios: "Langileen salmenta kontuak",
  costesDeProductos: "Produktuen kostuak",
  totalImportesVentas: "Salmenta guztien kopurua",
  totalCoste: "Kostu guztira",
  costes: "Kostuak",
  costeUd: "Unitateko kostua",
  coste: "Kostua",
  porcentajeCosto: "% Kostua",
  varCostoMed: "Bataz besteko kostu aldaketa",
  listaDeInvitaciones: "Gonbidapen zerrenda",
  valor: "Balioa",
  volverALaLista: "Itzuli zerrendara",
  ventasDeProductosGlobal: "Produktuen salmenta orokorra",
  porUnidades: "Unitatez",
  gastosPorEtiquetas: "Gastu etiketaz",
  desgloseDeGastos: "Gastu banaketa",
  referencias: "Erreferentziak",
  concepto: "Kontzeptua",
  gastosDeProveedores: "Hornitzaileen gastuak",
  sinProveedor: "Hornitzaile gabe",
  sinCasas: "Etxe gabe",
  cierreDeCaja: "Kutxaren itxiera",
  primerTicket: "Lehen ticket",
  ultimoTicket: "Azken ticket",
  cheques: "Txekeak",
  cambioSigDia: "Hurrengo egunean aldaketa",
  ventasPorAgencias: "Agentzien arabera salmentak",
  ventasPorFormasDePago: "Ordainbide moduen arabera salmentak",
  exportarComoHTML: "HTML moduan esportatu",
  pendiente: "Zain",
  gasto: "Gastu",
  desgloseDeImpuestos: "Zergen banaketa",
  desgloseDelTicket: "Ticketaren banaketa",
  cuentasAnuladas: "Bertan behera utzitako kontuak",
  buscarPorHoras: "Orduz bilatu",
  buscarBaja: "Produktuak baja erakutsi",
  buscarSubProductoBaja: "Lehengaiak baja erakutsi",
  buscarCategoriasBaja: "Kategoriak baja erakutsi",
  buscarEtiquetasBaja: "Etiketak baja erakutsi",
  mostrarClientesBaja: "Baja-ko bezeroak erakutsi",
  deBaja: "baja-ko",
  mostrarVentasAcumuladasPorDia: "Eguneko salmenta metatuak erakutsi",
  seleccionaUnTpv: "TPV bat hautatu bere xehetasunak ikusteko",
  deshabilitarCheckboxVentasAcumuladasPorDia:
    "'Eguneko salmenta metatuak erakutsi' check box-a desgaitu xehetasunak ikusteko",
  graficas: "Grafikoak",
  dias: "Egunak",
  semanas: "Asteak",
  meses: "Hilabeteak",
  ventasPorComensales: "Bezero bakoitzeko salmentak",
  numeroDeComensales: "Bezero kopurua",
  precioMedioPorComensal: "Bataz besteko prezioa bezero bakoitzeko",
  ventasPorRangosHorarios: "Ordutegi tarteen arabera salmentak",
  ops: "Ops",
  comensales: "Bezeroak",
  detalleDeOperaciones: "Operazio xehetasunak",
  operaciones: "Operazioak",
  operacionMedia: "Bataz besteko operazioa",
  detalleDeComensales: "Bezero xehetasunak",
  comensalMedio: "Bataz besteko bezero",
  noHayVentasEnLosRangosDeFechasDefinidos:
    "Ez dago salmentarik definitutako datu-tarteen barruan",
  transferencia: "Transferentzia",
  domiciliacion: "Ordainketa automatikoa",
  fechaGasto: "Gastua data",
  generarEntradaDeAlmacenAlVerificar: "Biltegirako sarrera sortu egiaztatzean",
  listaDeMateriaPrima: "Lehengai zerrenda",
  preciosIVAIncluido: "Prezioak BEZ barne",
  precioSinIVA: "Prezioa BEZ gabe",
  precioIVAInc: "Prezioa BEZ barne",
  IVA: "BEZ",
  totalBase: "Oinarri guztira",
  totalDocumento: "Dokumentu guztira",
  seleccioneUnaCasa: "Etxe bat hautatu",
  anyadirNuevoSubproducto: "Subproduktu berri bat gehitu",
  gestionDeGastos: "Gastu kudeaketa",
  deCaja: "Kutxatik",
  fueraDeCaja: "Kutxatik kanpo",
  contabilizado: "Kontabilizatua",
  si: "Bai",
  no: "Ez",
  grafica: "Grafikoa",
  lista: "Zerrenda",
  avanzado: "Aurreratua",
  noHayVentasDeProductosEnEsteRangoDeFechas:
    "Ez dago produktuen salmentarik datu-tarte honetan",
  historicoDeProductos: "Produktuen historialak",
  volverA: "Itzuli ",
  general: "Orokorra",
  historialAlmacen: "Biltegi historialak",
  listadoDeExistencia: "Stock zerrenda",
  listadoDeAlmacen: "Biltegi zerrenda",
  listadoHastaStockOptimo: "Optimoko stockera arteko zerrenda",
  listadoExistenciaBajoMinimo: "Gutxieneko stockaren azpitik zerrenda",
  exportarValoracion: "Balorazioa esportatu",
  importeDto: "Deskontu kopurua",
  detalleDelSubproducto: "Subproduktuaren xehetasunak",
  nombreNegocio: "Negozio izena",
  noHaySubproductosConElMismoNombreEnTusOtrosNegocios:
    "Ez dago izen bereko subprodukturik zure beste negozioetan",
  detalleAlmacen: "Biltegi xehetasunak",
  entrada: "Sarrera",
  inventario: "Inbentarioa",
  salida: "Irteera",
  valorDto: "Deskontu balioa",
  noHayDatosEnEsteMovimientoDeAlmacen: "Ez dago daturik mugimendu honetan",
  historial: "Historiala",
  noHayMovimientoEnEstaMateriaPrima: "Ez dago mugimendurik lehengai honetan",
  dia: "Eguna",
  historialDeAlmacen: "Biltegi historialak",
  inventarios: "Inbentarioak",
  entradas: "Sarrerak",
  salidas: "Irteerak",
  completado: "Osatua",
  verificado: "Egiaztatua",
  descargado: "Deskargatua",
  diaActual: "Gaurko eguna",
  movimientos: "Mugimenduak",
  enEsteRangoDeFechas: "datu-tarte honetan",
  rangosHorarios: "Ordutegi tarteak",
  nuevoRangoHorario: "Ordutegi tarte berria",
  verUnInformeDeRangosHorarios: "Ordutegi tarteen txostena ikusi",
  noHayRangosHorariosEnEsteNegocio: "Ez dago ordutegi tarterik negozio honetan",
  nombreRangosHorarios: "Ordutegi tarteen izena",
  vistaMosaico: "Mosaiko ikuspegia",
  vistaLista: "Zerrenda ikuspegia",
  ordenarProductos: "Produktuen ordena",
  BAJA: "BAJA",
  frontalDeVenta: "Salmenta aurrealdea",
  agregarGasto: "Gastu bat gehitu",
  entrAlmac: "Sarrera Biltegi",
  contab: "Kontabilizatua",
  tranferencia: "Transferentzia",
  verificar: "Egiaztatu",
  entradaAlmacen: "Biltegi sarrera",
  preciosIVAInluido: "Prezioak BEZ barne",
  estaEntradaNoContieneNingunSubproducto: "Sarrera honek ez du subprodukturik",
  cajasOnline: "Kutxa lineak",
  minimo: "Gutxieneko",
  optimo: "Optimo",
  posicionGlobal: "Posizio orokorra",
  empresa: "Enpresa",
  todasLasEmpresas: "Enpresa guztiak",
  ventasSinIVA: "Salmentak BEZ gabe",
  neto: "Garbi",
  fechaDeCumpleanyos: "Urtebetetze data",
  recargoEquivalencia: "Berdintasun kargua",
  anyadirMateriaPrima: "Lehengai bat gehitu",
  partesT1: "T1 atal",
  partesT2: "T2 atal",
  partesT3: "T3 atal",
  partesT4: "T4 atal",
  costeDto: "Deskontu kostua",
  agregarMateriasPrimas: "Lehengaiak gehitu",
  frontalDeVentas: "Salmenta aurrealdea",
  unidadesEnOtroNegocios: "Beste negozioetan unitateak",
  historialMateriaPrima: "Lehengai historialak",

  borrarRangoHorario: "Ordutegi tartea ezabatu",
  detallesDeLaEntradaEnAlmacen: "Biltegiko sarreraren xehetasunak",
  desgloseHorasTrabajadas: "Lanorduak banaketa",
  verProductosVendidos: "Saldu diren produktuak ikusi",
  verTicketsDelProducto: "Produktuko tiketak ikusi",
  verTicketsDeEsasInvitaciones: "Gonbidapen horien tiketak ikusi",
  verTicketsDeEsaAgencia: "Agentzia horren tiketak ikusi",
  gastosPorMateriasPrimas: "Lehengai gastuak",
  alDarUnProductoDeBajaDesapareceEnElTPVParaSuVentaPeroSigueApareciendoEnLosInformesDeVenta:
    "Produktua baja ematen zaionean, TPV-n ez da agertzen salmentarako baina salmenta txostenetan bai",
  cuandoUnProductoEsDeTipoDescuentoSuPrecioSeDescuentaDelTotalDeLaCuenta:
    "Produktua deskontu motakoa denean, prezioa kontuaren guztitik kenduko da",
  alActivarEstaOpcionApareceLosIngredientesDelProductoParaSeleccionarlo:
    "Aukera hau aktibatzean, produktuko osagaiak hautatzeko agertuko dira",
  alActivarEstaOpcionPuedeSeleccionarElPrecioDelProductoAlMarcarlo:
    "Aukera hau aktibatzean, produktua markatzean prezioa hauta daiteke",
  alActivarEstaOpcionPuedeSeleccionarElPesoDelProductoAlMarcarlo:
    "Aukera hau aktibatzean, produktua markatzean pisua hauta daiteke",
  alActivarEstaOpcionPuedeSeleccionarElImporteDelProductoAlMarcarlo:
    "Aukera hau aktibatzean, produktua markatzean zenbatekoa hauta daiteke",
  alActivarEstaOpcionElProductoNoApareceraEnNumierTPV:
    "Aukera hau aktibatzean, produktua Numier TPV-n ez da agertuko",
  alActivarEstaOpcionElProductoNoApareceraEnLaPda:
    "Aukera hau aktibatzean, produktua Numier PDA-n ez da agertuko",
  alActivarEstaOpcionElProductoNoSeImprimiraEnElPendienteDeCobroNiEnLaFacturaSimplificada:
    "Aukera hau aktibatzean, produktua kobratzeko zain eta faktura sinplifikatutan ez da inprimatuko",
  guardarMateriaPrima: "Lehengai gorde",
  copiarMateriaPrima: "Lehengai kopiatzea",
  seleccioneQueTipoDeMateriasPrimasQuiereCopiar:
    "Hautatu zein lehengai mota kopiatu nahi duzun",
  seleccioneAQueCategoriaQuiereCopiarLasMateriasPrimas:
    "Hautatu zein kategoriatan kopiatu nahi dituzun lehengaiak",
  copiaMateriaPrima: "Lehengai kopia",
  notas: "Oharrak",
  pedidos: "Eskaerak",
  atencionLaMediaSinContarLosDiasConVentas:
    "Kontuz: Salmentarik gabeko egunak kontuan hartu gabe batez bestekoa da: ",
  verDesgloseDeImpuestos: "Zergen banaketa ikusi",
  verDetallesDetTicket: "Ticketaren xehetasunak ikusi",
  facturasNominativas: "Faktura izendatuak",
  verDetallesDeGasto: "Gastuaren xehetasunak ikusi",
  desgloseDeGastosPorEtiquetasHijas: "Gastu banaketa azpietiketen arabera",
  procedencia: "Jatorria",
  suLicenciaDeNumierOnlineEstaAPuntoDeCaducar:
    "Zure Numier Online lizentzia iraungitzeko dago",
  cajasOnlineTickets: "Kutxa Online Tiketak",
  cajasOnlineDetalles: "Kutxa Online Xehetasunak",
  cajasOnlinePlano: "Kutxa Online Planoa",
  cajasOnlineProductos: "Kutxa Online Produktuak",
  transferir: "Transferitu",
  herramientas: "Tresnak",
  ver: "Ikusi",
  detallesDeLaentradaEnAlmacen: "Biltegiko sarreraren xehetasunak",
  ups: "Ups",
  laFechaDeInicioNoPuedeSerPosteriorALaDeFin:
    "Hasiera data ez da amaiera data baino beranduago izan daiteke",
  exportarContabilidad: "Kontabilitatea esportatu",

  seleccioneUnProveedor: "Hautatu hornitzaile bat",
  detallesDelPedido: "Eskaeraren xehetasunak",
  correoEnviadoCorrectamente: "Posta zuzenean bidalia",
  atencion: "Kontuz",
  debeIntroducirUnEmailParaEnviarElPedido:
    "Posta bat sartu behar duzu eskaera bidaltzeko",
  detalles: "Xehetasunak",
  gastoVerificadoCorrectamente: "Gastu egiaztatua",
  estasSeguroDeEliminarElPedido: "Ziur zaude eskaera ezabatu nahi duzula?",

  // BUSINESS CENTRAL - MATERIAS PRIMAS
  noSeEncontraronMateriasPrimas: "Ez da lehengairik aurkitu",
  noSeEncontraronProductos: "Ez da produkturik aurkitu",
  seleccionar: "Hautatu",
  estado: "Egoera",
  noDisponible: "Ez dago eskuragarri",
  downgradedProducts: "Baja emandako produktuak",
  unknownProduct: "Produktu ezezaguna",
  affectedRecipes: "Errezeta kaltetuak",
  noRecipesAffected: "Ez dago errezeta kaltetu",
  detalle: "Xehetasunak",
  noHayBajasQueMostrar: "Ez dago bajarik erakusteko",
  resumenBajas: "Bajen laburpena",
  eliminado: "Ezabatua",
  consultarTodo: "Kontsultatu dena",
  desplegar: "Erakutsi informazioa",
  estaOperacionNoSePuedeDeshacer: "Edozein ekintza ezin da atzera bota",
  siEliminarPedido: "Bai, eskaera ezabatu",
  pedidoEliminadoCorrectamente: "Eskaera zuzen ezabatu da",
  laReferenciaEsObligatoria: "Erreferentzia derrigorrezkoa da",
  seleccioneLosNegociosParaHacerelPedido: "Hautatu eskaera egiteko negozioak",
  noTienesNingunNegocioAsignado: "Ez duzu nekozio asignatuik",
  noHayProveedoresEnEsteNegocio: "Ez dago hornitzailerik negozio honetan",
  cuentasRectificadas: "Faktura zuzenketak",
  noHayCuentasRectificadasEnEsteRangoDeFechas:
    "Ez dago zuzendutako konturik datu-tarte honetan",
  pedidosProveedor: "Hornitzaile eskaerak",
  gestionDePersonal: "Langileen kudeaketa",
  configuracionCarta: "Menuaren konfigurazioa",
  importacionExcels: "Excel inportazioa",
  carta: "Menu digitala",
  camaras: "Kamerak",
  perfil: "Profil",
  cerrarSesion: "Saioa itxi",
  desarrolladoPorNexodoDigitalSL: "Nexodo Digital S.L.-k garatua",
  totalValores: "Balio guztira",
  totalValoresDto: "Balio guztira deskontua",
  totalValoresRecuento: "Balio guztira zenbaketa",
  ultimoInventario: "Azken inbentarioa",
  filtrarEntreInventarios: "Inbentarioen artean iragazi",
  ultInventario: "Azken inbentarioa",
  primerInventario: "Lehen inbentarioa",
  marcaDosInventariosParaVerLosDetallesEntreEllos:
    "Bi inbentario markatu xehetasunak ikusteko",
  salir: "Irten",
  anadirMovimientoAlmacen: "Biltegiko mugimendua gehitu",
  nuevoInventario: "Inbentario berria",
  tienesUnInventarioSinTerminarElDia: "Egunerako inbentario amaitu gabe duzu",
  pulseElBotonRealizarInventarioPara: "Sakatu 'Inbentarioa egin' botoia",
  volverARealizarlo: "berriz egitea",
  siDeseas: "Nahi izanez gero",
  comenzarElInventarioDeNuevo: "inbentarioa berriro hasi",
  comaMarqueLaCasillaEliminarDatosDeInventarioActual:
    ", markatu 'Eguneroko inbentarioaren datuak ezabatu' aukera",
  eliminarDatosDelInventarioActual: "Eguneroko inbentarioaren datuak ezabatu",
  realizarInventario: "Inbentarioa egin",
  accesoDenegado: "Sarbidea debekatua",
  soloPuedeComprobar2InventariosAlMismoTiempo:
    "Bi inbentario soilik egiaztatu daitezke aldi berean",
  cargando: "Kargatzen...",
  configuracionAlmacen: "Biltegiko konfigurazioa",
  actualizada: "eguneratua",
  correctamente: "zuzenean",
  noSeAdmitenCamposEnBlanco: "Hutsik dauden eremuak ez dira onartzen",
  todas: "Denak",
  categoriaClientes: "Bezeroen kategoria",
  seleccionaCompania: "Enpresa hautatu",
  agregarCategoriaDeClientes: "Bezeroen kategoria gehitu",
  categoriaPadre: "Guraso kategoria",
  elCampoNombreFiscalEsObligatorio: "Izen fiskala derrigorrezkoa da",
  elCampoCifNifEsObligatorio: "CIF/NIF derrigorrezkoa da",
  datosActualizados: "Datuak eguneratu dira",
  elCampoNombreEsRequerido: "Izena derrigorrezkoa da",
  creada: "sortua",
  rangoHorario: "Ordutegi tartea",
  soloPuedeCrearUnMaximoDeXRangosHorarios:
    "Maximo 12 ordutegi tarte sortu daitezke",
  deAcuerdo: "Ados",
  eliminado: "ezabatu",
  deseaEliminarEsteRangoHorario: "Ordutegi tarte hau ezabatu nahi duzu?",
  siBorrarRangoHorario: "Bai, ordutegi tartea ezabatu",
  ordenarProductosAlfabeticamente: "Produktuen ordena alfabetikoki",
  ordenarMateriasPrimasAlfabeticamente: "Lehengaiak ordenatu alfabetikoki",
  asignarImpresorasSeleccionadasEnBlanco:
    "Hautatutako inprimagailuak hutsik ezarri",
  aplicarCambios: "Aldaketak aplikatu",
  ordenarAlfabeticamenteProductos: "Produktuen ordena alfabetikoki",
  ordenar: "Ordenatu",
  ordenarAlfabeticamenteSubproductos: "Subproduktuen ordena alfabetikoki",
  seleccioneElTipo: "Mota hautatu",
  impresionDeProductosEfectuadaCorrectamente:
    "Produktu inprimaketa zuzenean egin da",
  tienesQueSeleccionarUnaCategoria: "Kategori bat hautatu behar duzu",
  ningunaSeleccionada: "Ez da hautatutako",
  transferenciaDeProductosEfectuadaCorrectamente:
    "Produktuen transferentzia zuzenean egin da",
  relleneLosCamposObligatorios: "Derrigorrezko eremuak bete",
  vistaFrontalTpv: "TPV aurrealde ikuspegia",
  editarPrecios: "Prezioak editatu",
  cancelarEdicion: "Editaketa bertan behera utzi",
  guardarOrden: "Ordena gorde",
  bajaConBrackets: "[BAJA]",
  seleccionaUnaCategoria: "Kategori bat hautatu...",
  cambiarImpresorasAProductos: "Produktuen inprimagailuak aldatu",
  igualar: "Berdindu",
  sumar: "Gehitu",
  restar: "Kendu",
  multiplicar: "Biderkatu",
  todasLasTarifas: "Tarifa guztiak",
  productosEditadosCorrectamente: "Produktuak zuzenean editatu dira",
  ordenActualizadoCorrectamente: "Ordena zuzenean eguneratu da",
  componentesDeVenta: "Salmenta osagaiak",
  delNegocioAClientes: "negoziotik bezeroetara",
  clasificacionDe: "Klasifikazioa",
  productosPorFamilia: "produktuak familiaz",
  elementosQue: "Elementuak ",
  varianALosProductos: "produktuetan aldaketak",
  paraLaComanda: "komandarako",
  componentesComprados: "Erositako osagaiak",
  aProveedoresQueComponenProductos: "Produktuen hornitzaileei",
  empresas: "Enpresak",
  proveedorasDeMateriasPrimasYServicios: "Lehengai eta zerbitzu hornitzaileak",
  alNegocio: "negozioari",
  fabricantesDeMateriasPrimas: "Lehengai fabrikatzaileak",
  aProveedores: "Hornitzaileei",
  categoriasQueClasifican: "Kategoriak",
  materiasPrimasYProveedores: "Lehengaiak eta hornitzaileak",
  personalCon: "Langileak ",
  acceso: "sarbidea",
  alSistema: "sistemara",
  baseDeDatosDe: "Datu-basea",
  consumidores: "Kontsumitzaileak",
  enElNegocio: "negozioan",
  clasificacionDeLa: "Klasifikazioa",
  deLasVentas: "salmenten",
  metodosDeCobro: "Ordainketa metodoak",
  enElFrontalDeVenta: "salmenta aurrealdean",
  intervaloDeHorasParaConsultarVentas: "Salmentak kontsultatzeko ordu-tartea",
  configurarAlmacén: "Biltegia konfiguratu",
  relacionDeMateriasPrimasParaLaConfiguracionDelAlmacen:
    "Lehengai erlazioa biltegiko konfiguraziorako",
  herramientasGenerales: "Tresna orokorrak",
  edicionMasiva: "Editaketa masiboa",
  categoriasCarta: "Menu kategoriak",
  categoriaCarta: "menu kategoria",
  orden: "Ordena",
  editada: "editatua",
  anadirCategoria: "Kategori bat gehitu",
  esteNegocioNoTieneAccesoAEsteModulo:
    "Negozio honek ez du sarbiderik modulura",
  paraMasInformacionContacteConSu:
    "Informazio gehiago nahi izanez gero jarri harremanetan zure",
  distribuidor: "banatzaile",
  formasDePagoCarta: "Menu ordainketa modu",
  formaDePagoCarta: "menu ordainketa modu",
  informacionCarta: "Menu informazioa",
  datosDelNegocio: "Negozioaren datuak",
  nombreMostrado: "Erakutsitako izena",
  telefonoWhatsapp: "WhatsApp telefonoa",
  datosPedidos: "Eskaeren datuak",
  tiempoMedioDePreparacionRecogidaMin: "Hartu-prestatzeko denbora (min)",
  tiempoMedioDePreparacionDomicilioMin: "Etxerako prestatzeko denbora (min)",
  gastosDeEnvio: "Bidalketa gastuak",
  pedidoMinimo: "Eskaera minimoa",
  interfaz: "Interfazea",
  textoEntrega: "Entrega testua",
  textoPresentacion: "Aurkezpen testua",
  textoFormasDePago: "Ordainketa moduen testua",
  textoHorarios: "Ordutegien testua",
  datosGuardadosCorrectamente: "Datuak zuzenean gorde dira",
  materiasPrimasCarta: "Menu lehengaiak",
  materiaPrimaCarta: "menu lehengai",
  referenciaMateriasPrimasTpv: "TPV lehengai erreferentzia",
  nombreDeLaMateriaPrimaEnElTpv: "Lehengai izena TPV-n",
  disponible: "Eskaintzen da",
  replicarMateriaPrima: "Lehengai kopiatu",
  replicarMateriasPrimas: "Lehengaiak kopiatu",
  nombreTpv: "TPV izena",
  noDisponible: "Ez dago eskuragarri",
  replicarTodasLasMateriasPrimas: "Lehengai guztiak kopiatu",
  estasSeguroDeReplicarTodasLasMateriasPrimasALosNegociosSeleccionados:
    "Ziur zaude lehengai guztiak hautatutako negozioetara kopiatu nahi dituzula?",
  estaAccionNoSePuedeDeshacer: "Ekintza hau ezin da atzera bota!",
  siReplicar: "Bai, kopiatu",
  productosCarta: "Menu produktuak",
  productoCarta: "menu produktua",
  referenciaProductoTpv: "Produktua TPV erreferentzia",
  nombreDelProductoEnElTpv: "Produktua izena TPV-n",
  seleccionaCategoria: "Kategori bat hautatu",
  edicionRapida: "Edizio azkarra",
  supraCategoria: "SupraKategoria",
  supraCategoriaObligatoria: "Produktu hau gordetzeko SupraKategoria bat aukeratu behar duzu.",
  seleccionaTipo: "Mota hautatu",
  nIngredientesSinCosto: "Doako osagai kop.",
  maximoExtras: "Gehieneko extras",
  alergenos: "Alérgenoak",
  nombreTarifa1: "Tarifa 1 izena",
  precioTarifa1: "Tarifa 1 prezioa",
  nombreTarifa2: "Tarifa 2 izena",
  precioTarifa2: "Tarifa 2 prezioa",
  nombreTarifa3: "Tarifa 3 izena",
  precioTarifa3: "Tarifa 3 prezioa",
  nombreTarifa4: "Tarifa 4 izena",
  precioTarifa4: "Tarifa 4 prezioa",
  imagen: "Irudia",
  copiarMateriasPrimas: "Lehengaiak kopiatu",
  basico: "Oinarrizkoa",
  buscarNombreDeLaMateriaPrima: "Lehengai izena bilatu",
  seleccionaTipoPunto: "Mota hautatu...",
  bases: "Oinarriak",
  opcionales: "Aukerakoak",
  extras: "Extras",
  cereales: "Zerealak",
  crustaceos: "Krustazeoak",
  huevos: "Arrautzak",
  pescado: "Arraina",
  cacahuetes: "Kakahueteak",
  soja: "Soja",
  leche: "Esnea",
  frutosDeCascara: "Azaleko fruituak",
  apio: "Apioa",
  mostaza: "Mostaza",
  granosDeSesamo: "Sesamo haziak",
  dioxidoDeAzufre: "Sufre dioxidoa",
  altramuces: "Altramuzak",
  moluscos: "Moluskuak",
  cartaASecas: "Menua",
  extra: "Extra",
  opcional: "Aukerako",

  estreProcesoBorraraLasMateriasPrimasActualesEnLasCategoriasSeleeccionadasDeLosTiposElegidos:
    "Prozesu honek hautatutako kategoriako lehengaiak ezabatuko ditu hautatutako motetan",
  aceptarProceso: "Prozesua onartu",
  necesitasMarcarAlMenosUnTipoYUnaCategoria:
    "Gutxienez mota eta kategori bat hautatu behar duzu",
  materiaPrimaCopiadaCorrectamente: "Lehengai zuzen kopiatu da",
  editado: "editatua",
  agregada: "gehitua",
  relacion: "Erlazioa",
  noPuedeHaberDosMateriasPrimasConElMismoTipo:
    "Ezin dira bi lehengai mota berdinekoak egon",
  estasSeguroDeBorrarLaMateriaPrima:
    "Ziur zaude lehengai hau ezabatu nahi duzula?",
  siDeseoBorrarlo: "Bai, ezabatu nahi dut",
  seleccionaUnaCarta: "Menu bat hautatu",
  replicarProductos: "Produktuen kopia",
  verCarta: "Menua ikusi",
  verPedido: "Eskaera ikusi",
  verQR: "QR ikusi",
  nombreEnTpv: "TPV izena",
  cartaYPedido: "Menua eta eskaera",
  replicarTodosLosProductos: "Produktua guztiak kopiatu",
  editarImagen: "Irudia editatu",
  esteNegocioNoContieneNingunaCarta: "Negozio honek ez du menuik",
  estasSeguroDeReplicarTodosLosProductosALosNegociosSeleccionados:
    "Ziur zaude produktua guztiak hautatutako negozioetara kopiatu nahi dituzula?",
  sustanciasQue: "Osagaiak",
  componenALosProductos: "produktuetan osatzen",
  informacionAcercaDel: "Informazioa",
  negocioMinuscula: "negozioa",
  actualizarPedidos: "Eskaerak eguneratu",
  pendienteDeConfirmacion: "Konfirmaziorako zain",
  confirmados: "Konfirmatuta",
  enPreparacion: "Prestaketa",
  finalizados: "Amaituta",
  recogida: "Hartu",
  domicilio: "Etxerako",
  noHayPedidosPendientesDeConfirmacion:
    "Ez dago konfirmaziorako zain dauden eskaerarik",
  noHayPedidosConfirmados: "Ez dago konfirmatutako eskaerarik",
  noHayPedidosEnPreparacion: "Ez dago prestaketa fasean dauden eskaerarik",
  noHayPedidosTerminados: "Ez dago amaitutako eskaerarik",
  siBorrarPedido: "Bai, ezabatu eskaera",
  estasSeguroDeSuspenderElServicioEnMesas:
    "Ziur zaude mahaiko zerbitzua etetea?",
  siSuspendeElServicioEnMesasNoEntraranMasPedidosEnMesaHastaActivarloDeNuevo:
    "Mahaiko zerbitzua etetean, ez dira eskaerarik jasoko mahaian berriro aktibatu arte",
  siSuspenderElServicioEnMesa: "Bai, mahaiko zerbitzua etetea",
  estasSeguroDeActivarElServicioEnMesas:
    "Ziur zaude mahaiko zerbitzua aktibatzea?",
  siActivaElServicioDeMesasVolveranAEntrarPedidosDeMesa:
    "Mahaiko zerbitzua aktibatzean, eskaerak berriro jasoko dira mahaian",
  siActivarElServicioEnMesa: "Bai, mahaiko zerbitzua aktibatzea",
  estasSeguroDeSuspenderElServicio: "Ziur zaude zerbitzua etetea?",
  siSuspendeElServicioNoEntraranMasPedidosHastaActivarloDeNuevo:
    "Zerbitzua etetean, ez dira eskaerarik jasoko berriro aktibatu arte",
  siSuspenderElServicio: "Bai, zerbitzua etetea",
  estasSeguroDeActivarElServicio: "Ziur zaude zerbitzua aktibatzea?",
  siActivaElServicioVolveranAEntrarPedidos:
    "Zerbitzua aktibatzean, eskaerak berriro jasoko dira",
  siActivarElServicio: "Bai, zerbitzua aktibatzea",
  pedidoAceptadoCorrectamente: "Eskaera zuzenean onartu da",
  pedidoEnPreparacion: "Eskaera prestaketa fasean",
  pedidoFinalizado: "Eskaera amaituta",
  pedidoArchivado: "Eskaera artxibatuta",
  servicioActualizadoCorrectamente: "Zerbitzua zuzenean eguneratu da",
  estasSeguroDeEditarLaObservacion: "Ziur zaude behaketa editatu nahi duzula?",
  siEditarObservacion: "Bai, behaketa editatu",
  mesasActivadas: "MAHAIAK⠀AKTIBATUTA⠀",
  mesasDesactivadas: "MAHAIAK⠀DESAKTIBATUTA⠀",
  crearNuevoProveedor: "Hornitzaile berria sortu",
  crearMateriaPrima: "Lehengai berria sortu",
  eliminarMateriaPrima: "Lehengai ezabatu",
  sinCasaAsignada: "Etxerik gabekoa",
  buscarPorRefONombreDeLaMateriaPrima:
    "Bilatu erreferentzia edo izenaren arabera",
  mensajePorcentajeCompraDisminuido:
    "Prezioa ezarritako erosketaren portzentajean jaitsi da",

  seleccioneEtiqueta: "Seleccione etiqueta...",
  unidadesStockMinimo: "Unidades stock mínimo",
  partesStockMinimo: "Partes stock mínimo",
  anadirProveedor: "Añadir proveedor",
  amarillo: "amarillo",
  cajas: "Cajas",
  botellas: "Botellas",
  barriles: "Barriles",
  palets: "Palets",
  bolsas: "Bolsas",
  litros: "Litros",
  rollos: "Rollos",
  visualizar: "Visualizar",
  sinCasa: "Sin casa",
  elProveedorEsObligatorio: "El proveedor es obligatorio",
  laFechaEsObligatoria: "La fecha es obligatoria",
  hayUnaMateriaPrimaSinUnidades: "Hay una materia prima sin unidades",
  hayUnaMateriaPrimaSinPrecio: "Hay una materia prima sin precio",
  guardandoGasto: "Guardando gasto...",
  actualizado: "actualizado",
  creado: "creado",
  laLongitudDelNombreNoPuedeSerMayorDe:
    "La longitud del nombre no puede ser mayor de ",
  relleneTodosLosDatosMarcadosConAsteriscoAntesDeEnviar:
    "Rellene todos los datos marcados con * antes de enviar",
  seleccionaProveedor: "Selecciona proveedor...",
  filtrarPorFecha: "Filtrar por fecha",
  convertirAlbaranes: "Convertir albaranes",
  cancelarConversion: "Cancelar conversión",
  convertir: "Convertir",
  convertirAlbaranEnFactura: "Convertir albarán en factura",
  refFactura: "Ref factura",
  albaranesDeLaFactura: "Albaranes de la factura",
  finalizada: "finalizada",
  conversion: "Conversión",
  error: "Error",
  estaSeguroDeVerificarEsteGasto: "¿Está seguro de verificar este gasto?",
  siVerficarGasto: "Sí, verificar gasto",
  estasSeguroDeEliminarElGasto: "¿Estás seguro de eliminar el gasto?",
  siEliminarGasto: "Sí, eliminar gasto",
  contabilizadoCambiadoCorrectamente: "Contabilizado cambiado correctamente",
  gastoEliminadoCorrectamente: "Gasto eliminado correctamente",
  hacerInventario: "Hacer inventario",
  seleccionarTodas: "Seleccionar Todas",
  inventarioRealizadoCorrectamente: "Inventario realizado correctamente",
  traspaso: "Traspaso",
  negocioDeDestino: "Negocio de destino",
  referenciaNecesaria: "Referencia necesaria",
  elMovimientoDeAlmacenTieneQueTenerAsignadoUnProductoOProductos:
    "El movimiento de almacén tiene que tener asignado un producto o productos",
  realizado: "realizado",
  enviarInventario: "Enviar inventario",
  volverAlAlmacen: "Volver al almacén",
  inventarioCompletado: "Inventario completado",
  inventarioNoEncontrado: "Inventario no encontrado",
  cargandoInventario: "Cargando inventario",
  inventarioExcluidosTitulo: "Hay materias primas que no se contabilizan en este inventario",
  inventarioExcluidosTexto: "Su código está repetido, así que no se puede saber a qué materia prima corresponde la cantidad. No aparecerán para contar hasta que se corrija el código.",
  inventarioExcluidoCodigoCompartido: "El código {codigo} lo comparten {total} materias primas activas.",
  inventarioExcluidoLineaDuplicada: "El código {codigo} aparece {total} veces en este inventario.",
  importacion: "Importación",
  importar: "Importar",
  tienesQueSeleccionarUnArchivoDeImportacion:
    "Tienes que seleccionar un archivo de importación",
  importandoVentasDelNegocio: "Importando ventas del negocio...",
  nuevosProductos: "Nuevos Productos",
  seHanCreadoLosSiguientesProductos: "Se han creado los siguientes productos",
  importandoMovimientosDeAlmacen: "Importando movimientos de almacén...",

  seleccionaCasa: "Selecciona casa...",
  desgloseDeVentasPorProductos: "Desglose de ventas por productos",
  noTienesPermisoParaVisualizarEsteInforme:
    "No tienes permiso para visualizar este informe",
  historicoVentasPorCliente: "Histórico ventas por cliente",
  buscarPorNombreDelCliente: "Buscar por nombre del cliente",
  importeSinDto: "Importe sin Dto.",
  seleccioneUnClienteValido: "Seleccione un cliente válido",
  seleccioneUnNegocioParaVerLosTickets:
    "Seleccione un negocio para ver los tickets",
  ventasDeCategoriasPorClientes: "Ventas de categorías por clientes",
  desgloseDeVentasDeLaCategoria: "Desglose de ventas de la categoría",
  verImporteEnCategoriasHijas: "Ver importe en categorias hijas",
  gestionDePedidos: "Gestión de pedidos",
  cargandoGastos: "Cargando gastos...",
  cargandoDatos: "Cargando Datos",
  tiempoMedioCocina: "Tiempo medio cocina",
  nComandas: "Nº Comandas",
  eliminada: "eliminada",
  tiempoMedio: "Tiempo medio",
  noHayComandasEnviadasAlKdsEnEsteRangoDeFechas:
    "No hay comandas enviadas al kds en este rango de fechas",
  tiempoMedioProducto: "Tiempo medio producto",
  nProductos: "Nº Productos",
  informePersonalizado: "Informe Personalizado",
  nombreDelDispositivo: "Nombre del dispositivo",
  dispositivo: "Dispositivo",
  registrosHorarios: "Registros horarios",
  marshallEjecutadoCorrectamente: "Marshall ejecutado correctamente",
  mes: "Mes",
  seleccionaUnaSemana: "Selecciona una semana",
  seleccioneUnaFechaValida: "Seleccione una fecha válida",
  noMayuscula: "NO",
  siMayuscula: "SI",
  editarObservacion: "Editar observación",
  anadirObservacion: "Añadir observación",
  editarHoraInicioYHoraFin: "Editar hora inicio y hora fin",
  verLocalizacionEnMapa: "Ver localización en mapa",
  noSeHaEncontradoLocalizacion: "No se ha encontrado localización",
  inicioJornada: "Jornada iniciada",
  finJornada: "Jornada finalizada",
  geolocalizacionJornada: "Geolocalización de la jornada",
  editarHorario: "Editar horario",
  editarHorarioDeTurno: "Editar horario de turno",
  observacion: "Observación",
  turnosOperarios: "Turnos operarios",
  compartirEnlaceTurnos: "Compartir enlace de turnos",
  hazClicConsultar: "Egin klik Kontsultatu botoian bilaketa egiteko.",
  calculo: "Kalkulua",
  alMinuto: "Minutuan",
  redondear: "Biribildu",
  alSegundo: "Segunduan",
  horaCompleta: "Osoko ordua",
  haciaArriba30m: "Gora (30m)",
  haciaArriba45m: "Gora (45m)",
  verInfoCalculos: "Kalkulu-informazioa ikusi",
  infoCalculoTurnosTitulo: "Txanda-kalkuluari buruzko informazioa",
  infoCalculoIntroP1: "Sistemak denbora eta soldata hiru modutan kalkulatzeko aukera ematen du. Biribilketa aplikatzen denean,",
  infoCalculoIntroDestacado: "benetako lan-denbora beti parentesi artean eta gris kolorez agertuko da",
  infoCalculoAlMinutoTitulo: "1. Minutuan",
  infoCalculoAlMinutoDesc: "Segundoak baztertzen ditu. Langile batek 1h 30m 45s lan egiten badu,",
  infoCalculoAlMinutoSueldo: "Soldata minutu horietarako zehaztasunez kalkulatzen da.",
  infoCalculoRedondearTitulo: "2. Biribildu",
  infoCalculoRedondearDesc: "Denbora hautatutako arauaren arabera doitzen du:",
  infoCalculoHoraCompletaDesc: "Ez ditu minutuak zenbatzen. 1h 55m lan egiten badu,",
  infoCalculoHaciaArribaDesc: "Minutuak atalasea gainditzen badute, hurrengo ordura biribildu.",
  infoCalculoRedondearNota: "* Soldata dagoeneko biribiltutako denbora honen gainean kalkulatuko da.",
  infoCalculoAlSegundoTitulo: "3. Segunduan",
  infoCalculoAlSegundoDesc1: "Zehaztasun maximoa. Denbora zehatza zenbatzen du (ad.",
  infoCalculoAlSegundoDesc2: ") eta soldata segundo horiek sortutako azken zentimoa barne hartzen du.",
  enlaceGeneradoExito: "Enlace generado correctamente",
  enlaceCopiadoAlPortapapeles: "Enlace copiado al portapapeles",
  enlaceExternoTurnosTitle: "Enlace externo para consulta de turnos",
  enlaceExternoTurnosLabel:
    "A través de este enlace podrás consultar los turnos de los operarios. Caducará en 24 horas.",
  errorComunicacionBackend: "Error de comunicación con el servidor.",
  errorNoSeHaPodidoGenerarElEnlace:
    "Lo sentimos, no se ha podido generar el enlace, inténtalo de nuevo",
  enlaceExternoTurnosOperariosTitle: "Turnos de operarios de ",
  enlaceExternoTurnosCaducadoTitle: "El enlace ha caducado",
  enlaceExternoTurnosCaducadoLabel:
    "Para consultar los turnos de los operarios, contacte con el administrador del negocio para que vuelva a generar un nuevo enlace.",
  ventasDeProductosMinusculas: "ventas de productos",
  pedidosGuionPasarelaDePago: "Pedidos - Pasarela de Pago",
  numPedidos: "Num.Pedidos",
  costoPorPedido: "Costo por pedido",
  totalComisiones: "Total Comisiones",
  totalSinComisiones: "Total sin comisiones",
  errorEnLaPeticion: "Error en la petición",
  rentabilidad: "Rentabilidad",
  buscarPorNombreDelRepartidor: "Buscar por nombre del repartidor",
  verDesgloseDeTarifas: "Ver Desglose de tarifas",
  ventasPorMeses: "Ventas por meses",
  ventasHoras: "Ventas horas",
  ventasPorHorasYMesas: "Ventas por horas y mesas",
  tarifasDelProducto: "Tarifas del producto",
  cantidad: "Cantidad",
  fechaDesde: "Fecha desde",
  fechaHasta: "Fecha hasta",
  seleccionaProcedencia: "Selecciona procedencia...",
  verDesgloseFacturas: "Ver desglose facturas",
  verDesgloseMateriasPrimas: "Ver desglose materias primas",
  seleccionaUnaEtiqueta: "Selecciona una etiqueta",
  buscarPorNombreDeLaMateriaPrima: "Buscar por nombre de la materia prima",
  ventasDeMateriasPrimas: "Ventas de materias primas",
  seleccionaTpv: "Selecciona TPV...",
  deVentas: "de ventas",
  totalComision: "Total comisión",
  totalSinComision: "Total sin comisión",
  desgloseFacturas: "Desglose facturas",
  facturasDelProveedor: "Facturas del proveedor",
  retiradas: "Retiradas",
  buscarTicket: "Buscar ticket...",
  baseMayusculas: "BASE",
  numServ: "Num. Serv.",
  ticketMed: "Ticket Med.",
  necesitasElegirUnTpvParaPoderVerLosDetallesDeEste:
    "Necesitas elegir un TPV para poder ver los detalles de este",
  ventasMinusculas: "ventas",
  totales: "Totales",
  noTienesNingunRangoDeFechaCreadoDeseasCrearUnRangoDeFecha:
    "No tienes ningun rango de fecha creado. ¿Deseas crear un rango de fecha?",
  siCrearUnRangoHorario: "Sí, crear un rango horario",
  detalleDe: "Detalle de ",
  cierresDeCaja: "cierres de caja",
  ventasNegocioPorZonaHoraria: "Ventas negocio por zona horaria",
  porZonaHoraria: " por zona horaria",
  detalleDeVentasSegun: "Detalle de ventas según",
  comensalesMinuscula: " comensales",
  desgloseDe: "Desglose de ",
  ticketsCobrados: "tickets cobrados",
  segunTipoDeIVA: "según tipo de IVA",
  facturasEmitidas: "Facturas emitidas",
  aClientes: " a clientes",
  desgloseDeVentasSegun: "Desglose de ventas según ",
  formasDePagoMinusculas: "formas de pago",
  agenciasMinusculas: "agencias",
  cuentasACredito: "cuentas a crédito",
  sumatorioDe: "Sumatorio de ",
  impuestos: "impuestos",
  porFechas: " por fechas",
  cuentasAnuladasMinusculas: "cuentas anuladas",
  delNegocio: " del negocio",
  cuentasRectificadas: "Facturas rectificativas",
  cuentasRectificadasMinusculas: "facturas rectificativas",
  retiradasMinusculas: "retiradas",
  ventaDeProductosPorNegocio: "Ventas de productos por negocio",
  rankingDe: "Ranking de",
  costeDeProductos: "Coste de productos",
  margenDeCostes: "Margen de costes",
  segunVentasPorRangoDeFecha: "según ventas por rango de fecha",
  historicoDeProducto: "Historico de producto",
  rankingAgrupadoDe: "Ranking agrupado de",
  enTodosLosNegocios: "en todos los negocios",
  ventasDeCategoriasPorNegocio: "Ventas de categorías por negocio",
  agrupacionDe: "Agrupación de",
  ventasDeCategoriasMinusculas: "ventas de categorías minúsculas",
  deProductos: "de productos",
  invitacionesMinusculas: "invitaciones",
  ventasPorMateriasPrimas: "Ventas por materias primas",
  ventasDeMateriasPrimasMinusculas: "ventas de materias primas",
  comprasDeMateriasPrimas: "compras de materias primas",
  porRangoDeFecha: "por rango de fecha",
  comprasAProveedores: "compras a proveedores",
  comprasAUnProveedor: "compras a un proveedor",
  porRangoDeFechaEn: "por rango de fecha en",
  todosLosNegocios: "todos los negocios",
  comprasAgrupadasPorEtiquetas: "compras agrupadas por etiquetas",
  comprasAFabricantes: "compras a fabricantes",
  comprasAUnFabricante: "compras a un fabricante",
  ranking: "Ranking",
  detallesDe: "Detalles de",
  turnos: "turnos",
  ventasPorClientesPlural: "Ventas por cliente",
  deVentasPorClientes: "de ventas por cliente",
  consultaDeVentasPorCliente: "Consulta de ventas por cliente",
  historico: "Histórico",
  deVentasPorCliente: "de ventas por cliente",
  numierPedidos: "Numier Pedidos",
  informeDePasarelaDePago: "Informe de Pasarela de Pago",
  desgloseDiarioDeLosPagosATraves: "Desglose diario de los pagos a través",
  pasarelaDePagoStripe: "Pasarela de pago Stripe",
  clicParaMasInformacion: "Clic para más información",
  cantidadMinusculas: "cantidad",
  totalMinusculas: "total",
  tarjetaYCheques: "Tarjeta y cheques",
  seleccionaOperario: "Selecciona operario...",
  necesitasSeleccionarUnProveedorParaPoderHacerUnPedido:
    "Necesitas seleccionar un proveedor para poder hacer un pedido",
  estePedidoNoEsValido: "Este pedido no es válido",
  quieresRestablecerElPedido: "¿Quieres restablecer el pedido?",
  siRestablecerPedido: "Sí, restablecer pedido",
  datosPersonales: "Datos Personales",
  datosDeAcceso: "Datos de Acceso",
  contrasenaAntigua: "Contraseña Antigua",
  contrasenaNueva: "Contraseña Nueva",
  confirmarContrasena: "Confirmar Contraseña",
  quieresDarDeAltaUnUsuario: "¿Quieres dar de alta un usuario?",
  quieresDarDeBajaUnUsuario: "¿Quieres dar de baja un usuario?",
  licencias: "Licencias",
  fechaCaducidad: "Fecha caducidad",
  ilimitado: "ILIMITADO",
  lasContrasenasNoCoinciden: "Las contraseñas no coinciden",
  seleccionaUsuario: "Selecciona usuario...",
  usuario: "Usuario",
  negocios: "Negocios",
  balance: "Balance",

  teHaParecidoUtilEsteArticulo: "Artikulu hau erabilgarria iruditu zaizu?",
  graciasPorTuOpinion: "Eskerrik asko zure iritzia emateagatik",
  asignarTurno: "Txanda esleitu",
  vacaciones: "Oporrak",
  descargarPDF: "PDF deskargatu",
  enviarHorario: "Ordutegia bidali",
  incidenciasEnElMes: "Hilabete honetako gertaerak",
  diasDeVacacionesEnElMes: "Hilabete honetako opor egunak",
  diasDeVacacionesEnElAno: "Urteko opor egunak",
  nuevoTurno: "Txanda berria",
  clonarTurno: "Txanda klonatu",
  nombreDelTurno: "Txandaren izena",
  diasDeLaSemana: "Aste honetako egunak",
  editarTurno: "Txanda editatu",
  borrarTurno: "Txanda ezabatu",
  evento: "Gertaera",
  nombreEvento: "Gertaeraren izena",
  hayUnaIncidenciaEnEsteTurno: "Txanda honetan gertaera bat dago",
  fechaInicioTurno: "Txandaren hasiera data",
  fechaFinTurno: "Txandaren amaiera data",
  numHorasTurno: "Txandako ordu kop.",
  fechaInicioTrabajada: "Lan hasiera data",
  fechaFinTrabajada: "Lan amaiera data",
  numHorasTrabajadas: "Lan ordu kop.",
  noIniciado: "Hasierarik gabe",
  noFinalizado: "Amaierarik gabe",
  fechaInicioVacaciones: "Oporren hasiera data",
  fechaFinVacaciones: "Oporren amaiera data",
  turnoHorario: "Ordutegi txanda",
  nombreTurno: "Txandaren izena",
  campoRequerido: "Derrigorrezko eremua",
  introduzcaLosDiasDeLaSemana: "Sartu aste honetako egunak",
  crearTurnoHorarioDeOperario: "Langilearen ordutegi txanda sortu",
  introduzcaLosOperarios: "Sartu langileak",
  laboral: "Lan eguna",
  vacacional: "Opor eguna",
  seleccionaTurno: "Txanda hautatu...",
  seleccionaLosNegociosALosQueQuiereClonarElTurno:
    "Txanda klonatu nahi dituzun negozioak hautatu",
  seleccionaLaFechaEnLaQueDeseasCopiarLosHorarios:
    "Ordutegiak kopiatu nahi dituzun data hautatu",
  seleccioneUnaSemana: "Aste bat hautatu",
  lunes: "Astelehena",
  martes: "Asteartea",
  miercoles: "Asteazkena",
  jueves: "Osteguna",
  viernes: "Ostirala",
  sabado: "Larunbata",
  domingo: "Igandea",
  laFechaSeleccionadaNoEsValida: "Hautatutako data baliogabea da",
  turnoClonadoCorrectamente: "Txanda zuzenean klonatu da",
  correoEnviadoCorrectamente: "Posta zuzenean bidali da",
  estasSeguroDeBorrarElTurnoSeleccionado:
    "Ziur zaude hautatutako txanda ezabatu nahi duzula?",
  siBorrarTurno: "Bai, txanda ezabatu",
  necesitasCrearAlgunTurnoParaPoderCrearCuadrantes:
    "Txandak sortu behar dituzu ordutegiak sortzeko",
  estasSeguroDeEditarElTurno: "Ziur zaude txanda editatu nahi duzula?",
  siEditarTurno: "Bai, txanda editatu",
  hoy: "Gaur",
  turno: "Txanda",
  turnoBorradoCorrectamente: "Txanda zuzenean ezabatu da",
  informacion: "Informazioa",
  elDiaNoCorrespondeConLaConfiguracionDelTurnoElegido:
    "Eguna ez dator hautatutako txandaren konfigurazioarekin",
  turnoCopiadoCorrectamente: "Txanda zuzenean kopiatu da",
  turnoDeOperarioAgregadoCorrectamente: "Langilearen txanda zuzenean gehitu da",
  turnoDeOperarioEliminadoCorrectamente:
    "Langilearen txanda zuzenean ezabatu da",
  turnoDeOperarioEditadoCorrectamente: "Langilearen txanda zuzenean editatu da",
  tecnicoConsultasTecnicasIncidencias:
    "Teknikoa (Kontsulta teknikoak, Gertaerak...)",
  comercialActivacionDeProductosInformacionServicios:
    "Merkataritza (Produktuen aktibazioa, Informazioa, Zerbitzuak...)",
  administracionFacturacionReclamaciones:
    "Administrazioa (Fakturazioa, Kexa...)",
  elAsuntoEsObligatorio: "Gaia derrigorrezkoa da",
  elMensajeEsObligatorio: "Mezua derrigorrezkoa da",
  soporteOnlineEnviadoCorrectamente: "Online laguntza zuzenean bidali da",
  todosLosNegociosMayusculas: "Negozio guztiak",
  recordarMisDatos: "Nire datuak gogoratu",
  paraCualquierIncidenciaOMasInformacionPuedePonerseEnContactoConNosotros:
    "Gertaera edo informazio gehiago lortzeko jar zaitez gurekin harremanetan",
  iniciarSesion: "Saioa hasi",
  haOlvidadoSuContrasena: "Pasahitza ahaztu duzu?",
  haHabidoUnErrorAlConectarPruebeDeNuevo:
    "Konexio errorea egon da. Saiatu berriro",
  elEmailNoPuedeEstarEnBlanco: "Email-a ezin da hutsik egon",
  elEmailNoEsValido: "Email-a ez da baliagarria",
  laContrasenaNoPuedeEstarEnBlanco: "Pasahitza ezin da hutsik egon",
  estaPaginaNoSeEncuentraEnElSistema: "Orri hau sisteman ez dago",
  volverAlInicio: "Hasierara itzuli",
  obtenerContrasena: "Pasahitza lortu",
  disculpeLasMolestiasEstamosDeMantenimiento:
    "Barkatu eragozpenak, mantentze-lanean gaude",
  funcionEnMantenimiento: "Funtzioa mantentze-lanean",
  getDataCompanyMantenimiento: "Funtzio hau aldi baterako mantentze-lanean dago. Barkatu eragozpenak.",
  vuelvaAIntentarloMasTarde: "Saiatu berriro beranduago",
  acepto: "Onartzen dut",
  categoriasDeClientes: "Bezeroen kategoriak",
  categoriaDeCliente: "Bezeroaren kategoria",
  nombreCategoria: "Kategoriaren izena",
  noSeleccionada: "Hautatu gabe",
  cobradoMayusculas: "ORDUAN ORDAINDUTA",
  envioProgramadoPara: "Bidalketa programatua",
  eliminarPedido: "Eskaera ezabatu",
  aceptarPedido: "Eskaera onartu",
  pedidoConfirmado: "Eskaera berretsi",
  archivarPedido: "Eskaera artxibatu",
  detallesPedido: "Eskaeraren xehetasunak",
  nota: "Oharra",
  precioUd: "Prezioa Ud",
  gratis: "DOAKO",
  guardarYAceptarPedido: "Gorde eta onartu eskaera",
  seleccionaGrupo: "Taldea hautatu...",
  todosMayusculas: "DENAK",
  nombreOperario: "Langilearen izena",
  apellidos: "Abizenak",
  claveAcceso: "Sarbide gakoa",
  codigoDeTurnos: "Txandaren kodea",
  claveAccesoPDA: "PDA sarbide gakoa",
  seleccionaIVA: "BEZa hautatu",
  calcularCostoAPartirDeMateriasPrimas: "Kostua lehengaien arabera kalkulatu",
  seleccionaImpresoraDeComandasTPV: "TPV aginduen inprimagailua hautatu",
  seleccionaImpresoraDeComandasPDA: "PDA aginduen inprimagailua hautatu",
  buscarMateriaPrima: "Lehengaia bilatu",
  buscarProducto: "Produktua bilatu",
  nuevaMateriaPrima: "Lehengaia berria",
  ordenarSubproductos: "Azpiproiektuak ordenatu",
  seleccionaEtiqueta: "Etiketa hautatu...",
  clonarProducto: "Produktu klonatu",
  clonarProductoCarta: "Produktu klonatu",
  buscarSinPuntos: "Bilatu",
  sinProveedores: "Hornitzaileik gabe",
  agregadas: "gehituak",
  modificadas: "aldatuak",
  materiaPrimaEliminadaCorrectamente: "Lehengaia zuzenean ezabatu da",
  asociacion: "Elkartea",
  materiaPrimaOrdenadaCorrectamente: "Lehengaia zuzenean ordenatu da",
  productosCopiadosCorrectamente: "Produktuak zuzenean kopiatu dira",
  menuCopiadoCorrectamente: "Menua zuzenean kopiatu da",
  responder: "Erantzun",
  administracion: "Administrazioa",
  soporteTecnico: "Laguntza teknikoa",
  horaInicioMayusculas: "Hasiera Ordua",
  horaFinal: "Amaiera Ordua",
  personaDeContacto: "Harreman pertsona",
  motivoVisita: "Bisitaren arrazoia",
  servicioBajoMantenimiento: "Zerbitzua mantentze-lanean",
  desplazamiento: "Mugimendua",
  ticketEnviadoCorrectamente: "Sarrera zuzenean bidali da",
  precioCompraConDescuento: "Erosketa prezioa deskontuarekin",
  introduzcaLasPartesDelStockMinimo: "Sartu stock minimo zatiak",
  actualizarStockMinimoYOptimo: "Stock minimo eta optimo eguneratu",
  subproductoDeVerdad: "Azpiproiektua",
  entregado: "Entregatua",
  retirada: "Ateratakoa",
  subtotal: "Azpikopurua",
  pagosACuenta: "Aurrerako ordainketak",
  horaDeApertura: "Irekiera Ordua",
  horaInicio: "Hasiera Ordua",

  condicionesDeNumierOnline: "Numier Onlineko baldintzak",
  descripcionDelServicio: "Zerbitzuaren deskribapena",
  terminosIntroduccionParte1:
    "NEXODO DIGITAL S.L.-k (aurrerantzean NEXODO) eskaintzen duen Numier hodeiko zerbitzuak bere bezeroei beren negozioen informazio eguneratua linean eskuratzeko aukera ematen die.",
  terminosIntroduccionParte2:
    "Horretarako, Numier salmenta puntuko aplikazioek internet bidez bidaliko dituzte egindako salmenten xehetasunak eta bezeroentzako interesgarriak izan daitezkeen bestelako informazioa.",
  terminosIntroduccionParte3:
    "Zerbitzu honetara sarbidea https://www.numier.com/clientes webgunearen bidez egingo da, non salmenta puntuek bidalitako informazioa kontsultatu ahal izango den.",
  terminosIntroduccionParte4:
    "NEXODO-k zerbitzua hobetzeko, aldatzeko edo bertan behera uzteko eskubidea gordetzen du uneoro.",
  politicaDePrivacidad: "Pribatutasun politika",
  privacidadParte1:
    "1. NEXODO-k pribatutasun adierazpen hau egin du bere bezeroen pribatutasuna babesteko helburuarekin. Zerbitzu hau erabiltzen hasi aurretik, irakurri arretaz politika hau, datu pertsonalak biltzeko eta prozesatzeko politika hau aplikatuko delako. NEXODO-k eskubidea du pribatutasun politika uneoro aldatzeko, eta kasu horretan, bezeroari jakinaraziko dio aldaketa horiek nola eragiten dioten.",
  privacidadParte2:
    "2. NEXODO-k zure pribatutasun aukerak errespetatzen ditu. Informazioa ematen badiguzu, politika honen arabera tratatuko da.",
  privacidadParte3:
    "3. NEXODO-k gomendatzen du informazioa emateko kontu handia izatea. Sare publikoetan, hala nola chat guneetan, informazioa ematea edozein interneteko erabiltzailek ikus dezakeela esan nahi du. Ez sartu nahi ez duzun informaziorik toki horietan.",
  privacidadParte4:
    "4. NUMIER ONLINE-ra erregistratzea erabakitzen baduzu, datu pertsonalak eman beharko dituzu. Eguneratuta eta zuzen sartu informazioa. Aldaketak egin ondoren, berehala eguneratu behar dira, bestela zerbitzu edo informazio bat jaso ez dezakezu.",
  privacidadParte5:
    "5. NEXODO-k zure informazioa erabil dezake gune hau hobetzeko helburuarekin.",
  privacidadParte6:
    "6. NEXODO-k datu hauek jasotzen ditu zerbitzuak eta produktuak hobetzeko. Informazioa erabil dezake eskaintza elektronikoak edo postaz bidaltzeko, zure intereserako.",
  privacidadParte7:
    "7. Korreo horietako harpidetza bertan behera uzteko, jar zaitez NEXODO-rekin harremanetan. Bestela, datuak gordeko ditu harpidetza bertan behera geratu arte edo legeak adierazitako epea amaitu arte.",
  privacidadParte8:
    "8. NEXODO-k ez du zure daturik hirugarren bati emango zure baimenik gabe, legeak hala eskatzen ez badu.",
  privacidadParte9:
    "9. Zure harpidetzako datu guztiak ezabatzeko aukera duzu, gure datu-basean. Horretarako, enpresarekin jarri harremanetan eta eskaera egin.",
  privacidadParte10:
    "10. NEXODO-k neurriak hartu ditu informazioa hasieran sartu zuen erabiltzailearentzat bakarrik eskuragarri egoteko.",
  privacidadParte11:
    "11. Informazioa pasahitza sartu ondoren soilik eskuratu daiteke.",
  privacidadParte12:
    "12. Gune honek NEXODO-rekin loturarik ez duten webgunerako estekak izan ditzake. Web horien pribatutasun politikak eurenak dira, NEXODO-k ez ditu erantzukizunekoak. Estekatutako guneetara sarbidea zure erantzukizunpean da.",
  privacidadParte13:
    "13. NEXODO-k erabiltzaileen informazioaren segurtasuna bermatzen du, honako kasuak salbu:",
  privacidadParte13dos: "- NEXODO-k zure baimena badu.",
  privacidadParte13tres:
    "- Lege edo auzi judizial baten bidez informazioa eman behar denean.",
  privacidadParte13cuatro:
    "- Datu hauek partekatzea NEXODO-ren eskubideak eta jabetza babesteko beharrezkoa denean.",
  privacidadParte13cinco:
    "- Zure datuak partekatzea bezeroen zerbitzu eta produktuak hobetzeko beharrezkoa denean, zure barne.",
  privacidadParte14:
    "14. NEXODO-k datuak zerbitzari seguru eta zifratuan gordetzen ditu, baimendutako hirugarrenek soilik eskuratzeko moduan.",

  cartaDigital: "Menu digitala",
  horarios: "Ordutegiak",
  zonas: "Eskualdeak",
  modificarHorariosDeLaCarta: "Menuaren ordutegiak aldatu",
  modificarZonasDeLaCarta: "Menuaren eskualdeak aldatu",
  diaDeLaSemana: "Aste eguna",
  esteNegocioNoTieneCarta: "Negozio honek ez du menurik",
  tipoDeEnvio: "Bidalketa mota",
  nuevoHorario: "Ordutegi berria",
  elCampoDiaDeLaSemanaEsRequerido: "Aste eguna derrigorrezkoa da",
  borrarHorario: "Ordutegia ezabatu",
  laHoraInicioNoPuedeSerMayorQueLaHoraFin:
    "Hasiera ordua ezin da amaiera ordu baino handiagoa izan",
  noHayHorariosEnEsteNegocio: "Negozio honetan ez dago ordutegirik",
  deseaEliminarEsteHorario: "Ordutegi hau ezabatu nahi duzu?",
  siBorrarHorario: "Bai, ordutegia ezabatu",
  seleccioneDiaDeLaSemana: "Aste eguna hautatu",
  seleccioneTipoDeEnvio: "Bidalketa mota hautatu",

  importacionSage: "Sage inportazioa",
  importacionContable: "Kontabilitate inportazioa",
  enlaceContable: "Kontabilitate esteka",
  ejercicio: "Ariketa",
  codigoEmpresa: "Enpresa kodea",
  asiento: "Kontu sarrera",
  cargoAbono: "Kargua / Ordainketa",
  codigoCuenta: "Kontu kodea",
  fechaAsiento: "Sarrera data",
  comentario: "Iruzkina",
  importeAsiento: "Sarrera kantitatea",
  numeroPeriodo: "Aldiko zenbakia",
  delegacion: "Delegazioa",
  canal: "Kanal",
  ejercicioFactura: "Faktura ariketa",
  serie: "Serie",
  factura: "Faktura",
  suFacturaNo: "Zure faktura No",
  fechaFactura: "Faktura data",
  importeFactura: "Faktura kantitatea",
  tipoFactura: "Faktura mota",
  codigoCuentaFactura: "Faktura kontu kodea",
  codigoRetencion: "Atxikipen kodea",
  baseRetencion: "Atxikipen oinarria",
  porRetencion: "Atxikipen portzentaia",
  importeRetención: "Atxikipen kantitatea",
  baselva1: "BEZa oinarria 1",
  porlva1: "BEZa portzentaia 1",
  cuotaIva1: "BEZa kuota 1",
  porRecargoEquivalencia1: "Ordezko kargua % 1",
  recargoEquivalencia1: "Ordezko kargua 1",
  codigoTransaccion1: "Transakzio kodea 1",
  descargarComoTxt: ".txt moduan deskargatu",

  noHayAsientosContablesEnEsteTpvEnEsteRangoDeFecha:
    "Ez dago kontabilitate sarrerarik TPV honetan datu-tarte honetan",
  cargandoAsientosContables: "Kontabilitate sarrerak kargatzen",
  fechaDeAperturaDeCaja: "Kutxaren irekiera data",
  fechaDeCierreDeCaja: "Kutxaren itxiera data",
  descargarVentas: "Salmentak deskargatu",
  descargarGastos: "Gastuen deskarga",
  noHasCerradoEstaCaja: "Ez duzu kutxa hau itxi",
  numeroDeCierres: "Itxierak kop.",
  introduzcaElUltimoNumeroDeAsientoContableQueTieneEnSAGE:
    "Sartu SAGE-n duzun azken kontabilitate sarrera zenbakia",
  porFavorRelleneElAsientoContable: "Mesedez, bete kontabilitate sarrera",
  descargar: "Deskargatu",
  elAsientoContableDebeSerUnNumero:
    "Kontabilitate sarrera zenbaki bat izan behar da",
  elAsientoContableNoPuedeSerMayorA10Digitos:
    "Kontabilitate sarrera ezin da 10 digitu baino handiagoa izan",
  TengaEnCuentaQueUtilizaremosLosSiguientesNumerosAEsteParaCompletarLosDatos:
    "Kontuan izan honako zenbaki hauek erabiliko ditugula datuak osatzeko",
  noExistenVentasEsteDia: "Egun honetan ez dago salmentarik",
  noExistenGastosEsteDia: "Egun honetan ez dago gasturik",
  enSage: "SAGE-n",
  proyecto: "Proiektua",
  codigoEmpresaHelp:
    "Gogoratu enpresa datua negozio guztien artean partekatzen dela",
  cuentasDelTpvSeleccionado: "Hautatutako TPV-ko kontuak",
  nuevaCuenta: "Kontu berria",
  nombreDeCuenta: "Kontu izena",
  codigoCuentaMinuscula: "Kontu kodea",
  tipoDeCuenta: "Kontu mota",
  noHayCuentasCreadasConElTpvSeleccionado:
    "Hautatutako TPV-rekin ez dago konturik sortuta",
  crearNuevaCuenta: "Kontu berria sortu",
  codigoDeLaCuenta: "Kontu kodea",
  codigoDeLaSubcuenta: "Azpiko kontu kodea",
  configuracionCuentasIva: "BEZ kontuen konfigurazioa",
  configuracionCuentasEspeciales: "Kontu berezien konfigurazioa",
  cuenta: "Kontua",
  subcuenta: "Azpiko kontua",
  editarCuenta: "Kontua editatu",
  sage200: "SAGE 200",
  exportarCAPTE: "CAPTE esportatu",
  losCamposNombreCodigoDeCuentaYCodigoDeSubcuentaDebenEstarRellenos:
    "Izena, kontu kodea eta azpiko kontu kodea eremuak bete behar dira",
  estaSeguroDeQueDeseaEliminarEstaCuenta:
    "Ziur zaude kontu hau ezabatu nahi duzula?",
  siBorrarCuenta: "Bai, kontua ezabatu",
  cuentaEditadaCorrectamente: "Kontua zuzenean editatu da",
  cuentaCreadaCorrectamente: "Kontua zuzenean sortu da",
  configuracionSAGE: "SAGE konfigurazioa",
  sinCuentaAsociada: "Kontu loturarik gabe",
  loSientoSuNegocioNoTieneContratadoSAGE:
    "Barkatu, zure negozioak ez du SAGE kontratatuta",
  loSientoSuNegocioNoTieneContratadoEsteModulo:
    "Barkatu, zure negozioak ez du modulu hau kontratatuta",
  paraMasInformacionContacteConComerciales:
    "Informazio gehiago nahi baduzu, jarri harremanetan merkatariekin",
  laLongitudMaximaDeLasSubCuentas:
    "Azpiko kontuaren gehienezko luzera 12 karakterekoa izan behar da",

  preparados: "Prest",
  enReparto: "Banaketa batean",
  noHayPedidosPreparados: "Ez dago prest dauden eskaerarik",
  noHayPedidosEnReparto: "Ez dago banaketa batean dauden eskaerarik",
  pedidoListo: "Eskaera prest",
  pedidoEnReparto: "Eskaera banaketa batean",

  codigo: "Kodea",
  crearNuevoCodigoCuenta: "Kontu kode berria sortu",
  editarNuevoCodigoCuenta: "Kontu kode berria editatu",
  seleccioneUnaFormaDePagoParaElGasto: "Aukeratu gastuaren ordainketa modu bat",
  hasSeleccionadoAlbaranesConDiferentesFormasDePagoPorFavorSeleccioneUna:
    "Albaran ezberdinak hautatu dituzu, mesedez aukeratu bat",
  seleccioneUnaFormaDePago: "Ordainketa modu bat hautatu",
  zonasActualizadasCorrectamente: "Eskualdeak zuzenean eguneratu dira",
  zonaCreadaCorrectamente: "Eskualdea zuzenean sortu da",
  zonaEditadaCorrectamente: "Eskualdea zuzenean editatu da",
  guardarCambios: "Aldaketak gorde",
  laZonaNoPuedeTenerElNombreEnBlanco: "Eskualdeak ezin du izenik gabe egon",
  zonasDeReparto: "Banaketa eskualdeak",
  editarZona: "Eskualdea editatu",
  color: "Kolorea",
  costeDeReparto: "Banaketa kostua",
  pedidoMinimo: "Eskaera minimoa",
  crearNuevaZona: "Eskualde berria sortu",
  estasSeguroDeQueQuieresEliminarLaZona:
    "Ziur zaude eskualde hau ezabatu nahi duzula?",
  estaZonaDejaraDeEstarDisponibleInmediatamenteYNoSePodranHacerPedidos:
    "Eskualde hau berehala ez da erabilgarri egongo eta ez dira eskaerak egingo bertatik",
  siEliminarZona: "Bai, eskualdea ezabatu",
  zonaEliminadaCorrectamente: "Eskualdea zuzenean ezabatu da",
  ventasExportadas: "Salmentak esportatu dira",
  gastosExportados: "Gastuak esportatu dira",
  todosLosCierresDeEsteDiaHanSidoExportados:
    "Egun honetako itxiera guztiak esportatu dira",
  faltanVentasPorExportarEsteDia:
    "Egun honetako salmentak esportatu gabe daude",
  todosLosGastosDeEsteDiaHanSidoExportados:
    "Egun honetako gastu guztiak esportatu dira",
  faltanGastosPorExportarEsteDia: "Egun honetako gastuak esportatu gabe daude",
  exportar: "Esportatu",

  // 10-02-2021
  otros: "Besteak",
  restriccionHorarios: "Ordutegi muga",
  restriccionHorariosDesc:
    "Ordutegi batzuk murriztu (itxita, bete, ez banaketa...)",
  borrar: "Ezabatu",
  restriccion: "Muga",
  nMaximoPedidos: "Eskaera max. kop.",
  cerrarFranja: "Txanda itxi",
  limitePedidos: "Eskaera mugak",
  loSentimosSuNegocioNoTieneContratadoEsteModulo:
    "Barkatu, zure negozioak ez du modulu hau kontratatuta",
  numeroPedidosPermitidos: "Onartutako eskaera kopurua",
  estaSeguroDeQueDeseaEliminarEstaRestriccion:
    "Ziur zaude muga hau ezabatu nahi duzula?",
  siBorrarRestriccion: "Bai, muga ezabatu",
  loSentimosParaAccederAEsteModuloNecesitaActivarLaConfiguracion:
    "Barkatu, modu honetara sartzeko konfigurazioa aktibatu behar duzu",
  costeSinIVA: "Kostua BEZ barik",

  // 11.3.2021
  importeIVA: "BEZ kantitatea",

  // 17.3.2021
  pasarAPreparacion: "Prestaketa modura pasatu",
  pasarAPreparados: "Prestaketan pasatu",
  pasarAEnReparto: "Banaketa modura pasatu",
  finalizarPedido: "Eskaera amaitu",

  // Tener en cuidado con los espacios, ya que son los espacios Braille
  domicilioActivado: "‏‏‎ETXEAN⠀AKTIBATUTA",
  domicilioDesactivado: "ETXEAN⠀DESAKTIBATUTA",
  recogerActivado: "JASOTZEA⠀AKTIBATUTA",
  recogerDesactivado: "JASOTZEA⠀DESAKTIBATUTA",

  conDetalles: "xehetasunekin",
  zonasRepartoActivadas: "AKTIBATUTA⠀",
  zonasRepartoDesactivadas: "DESAKTIBATUTA⠀",
  siEliminarCategoria: "Bai, kategoria ezabatu",
  confirmaEliminarCategoria: "Ziur zaude kategoria hau ezabatu nahi duzula?",
  pedidoPreparado: "Eskaera prest",
  configuracionParaLaImportacionExportacionDeDatosDeSage:
    "Sage datuen inportazio/esportazio konfigurazioa",
  enEstaPantallaSeConfiguranLosCodigosDeLasCuentas:
    "Pantaila honetan kontu kodeak konfiguratzen dira",
  formadosPor3Digitos: "3 digitu osatuta",
  estosSonNecesariosParaConfigurarLasCuentasContables:
    "Kontabilitate kontuak konfiguratzeko beharrezkoak dira",
  alEditarUnCodigoRelacionadoConUnaCuentaContableYaExistente:
    "Jada existitzen den kontu batekin lotutako kodea editatzean",
  todoCambioQueSeProduzcaSobreEsteAfectaraTambienALaPropiaCuenta:
    "aldaketa guztiak kontu horretan ere eragingo du",
  aContinuacionSeListaranLasCuentasDeTipo:
    "Ondoren, honako mota kontuak zerrendatuko dira",
  gastoMinuscula: "gastu",
  paraQue: "hona",
  asocieMinuscula: "lotu",
  ventaMinuscula: "salmenta",
  unaParaSuPosterior: "bat bere ondorengoetarako",
  relacionEnSage: "lotura SAGE-n",
  relacionEnContabilidad: "lotura kontabilitatean",
  seleccioneUnaCuenta: "Kontu bat hautatu",
  aDomicilio: "Etxera",
  aRecoger: "Jasotzera",
  tipoDeZona: "Eskualde mota",
  seleccioneUnTipo: "Mota bat hautatu",
  kilometrosDelArea: "Eskualdearen km-ak",
  codigoEmpleado: "Langile kodea",
  exportarReservas: "Erreserbak esportatu",
  importacionSinqro: "Sinqro inportazioa",
  configuracionParaLaImportacionDeDatosDeSinqro:
    "Sinqro datuen inportazio konfigurazioa",
  pasarelaDePago: "Ordainketa bidea",
  importeSinDescuento: "Kantitatea deskonturik gabe",
  desactivarZona: "Eskualdea desgaitu",
  activa: "AKTIBOA",
  inactiva: "EZ-AKTIBOA",
  exportarPdfConMateriasPrimasAsociadas: "PDF esportatu lotutako lehengaiak",
  exportarExcelConMateriasPrimasAsociadas:
    "Excel esportatu lotutako lehengaiak",

  // Pedidos archivados 18/05/21
  informePedidosDetalle: "Eskaeren xehetasunak",
  informePedidos: "Eskaeren txostena",
  tipoPago: "Ordainketa modu",
  tipoPedido: "Eskaera mota",
  domicilio: "Etxera bidalketa",
  recoger: "Lekura jasotzea",
  pagoLocal: "Lekuan ordainketa",
  otro: "Beste",

  // 25/05/2021
  configuracionTurnos: "Txanden konfigurazioa",

  // 2021/05/20
  estasSeguroDeImportarTusProductosASinqro:
    "Zure produktuak Sinqro-ra inportatu nahi dituzu?",
  esteProcesoPuedeTardarVariosMinutos:
    "Prozesu hau minutu batzuk iraun dezake.",
  siImportarConSinqro: "Bai, Sinqro-ra inportatu",
  estasSeguroDeDarDeBajaElProducto: "Produktua baja eman nahi duzu?",
  podraDarloDeAltaEnUnFuturo: "Etorkizunean alta eman ahal izango duzu",
  siDarDeBaja: "Bai, baja eman",
  estasSeguroDeDarDeAltaElProducto: "Produktua alta eman nahi duzu?",
  podraDarloDeBajaEnUnFuturo: "Etorkizunean baja eman ahal izango duzu.",
  siDarDeAlta: "Bai, alta eman",
  laImportacionTardara:
    "Inportatzen... prozesu honek minutu batzuk iraun ditzake",
  importacionFinalizada: "Inportazioa arrakastaz burutu da",
  completo: "Osatua",
  vale: "Ados",
  importarSinqro: "Sinqro inportatu",
  importandoProductos: "Inportazioa momentu honetan egiten ari da...",
  generandoCarta: "Mesedez, itxaron. Zure menu digitala sortzen ari gara.",
  procesoFin: "Prozesua arrakastaz amaitu da",
  procesoCompletado: "Prozesua amaitu da",
  yaFaltaPoco: "Dagoeneko gutxi falta da...",
  estamosEnEllo:
    "Inportazioan lanean ari gara. Mesedez, ez berrkargatu nabigatzailea.",
  finProgres: "Aurrerapena arrakastaz amaitu da.",
  textoInfo: "Eremu honek BEZ barik erosketa prezioa erakusten du",
  textoInfoImporteDTO:
    "Eremu honek deskontuarekin erosketa prezioa erakusten du (BEZ barik prezioaren arabera kalkulatua)",
  correosEnviados: "Postak bidalita",
  correosEnviadosCorrectamente: "Postak arrakastaz bidali dira.",
  errorAlEnviar: "Bidalketan errorea",
  noSePudieronEnviarTodosLosCorreos: "Ez ziren bidali guztiak: ",
  errorInesperadoEnvioCorreos:
    "Errore ezezaguna gertatu da. Mesedez, saiatu berriro geroago.",

  // 07/06/2021
  valorRecuento: "Zenbateko balioa",

  // 08/06/2021
  obligatorioEmail: "Email-a betetzea derrigorrezkoa da",
  datosCliente: "Bezeroaren datuak",

  // 11/06/2021
  recuerdeQueElHacerCobrosAvanzadosPuedeGenerarPequenosDescuadres:
    "Gogoratu aurreratutako kobrantzek desorekak sor ditzaketela",
  yQue: "eta",
  losDescuentosDeLasVentasEstanAlCeroPorcientoDeIva:
    "salmenten deskontuak BEZaren %0an daude",

  // 16/06/2021
  totalValoresNegativos: "Balio negatiboen totala",
  solamenteSeTieneEnCuentaValoresPositivos:
    "Balio positiboak bakarrik kontuan hartzen dira",
  totalValoresDiferencia: "Balio desberdinen totala",
  totalValoresDiferenciaDto: "Balio desberdinen totala Dto.",
  valorDiferencia: "Desberdintasun balioa",
  valorDifereciaDto: "Desberdintasun balioa Dto.",
  precioDto: "Prezioa Dto.",

  // 24/06/2021
  exportarMateriasPrimasAsociadasAEsteProducto:
    "Produktuekin lotutako lehengaiak esportatu",
  sinIVA: "BEZ barik",
  errorAlIntentarObtenerLosTpvs: "Errorea TPV-ak lortzen saiatzean",

  // 01/07/2021
  deseaguardarelproductoencarta:
    "Ondoren, tarifetako izenak eta prezioak (0 € baino handiagoak direnak) eta 'baja' eremua kopiatuko dira. Aldaketa hauek NumierPEDIDOSeko produktuei eragingo diete, produktu honi lotuta dauden guztiei.",
  leidoyacepto: "Ulertzen dut!",
  replicarencarta: "Ziur zaude?",
  aceptarreplicarencarta: "Onartu eta karta kopiatzea",
  guardaryreplicar: "Gorde eta karta kopiatzea",

  // Modal seleccionar categoría al crear en carta
  enlazarACategoria: "Kategoriari lotzea",
  deseaEnlazarProductoCategoria: "Produktu berria kartako kategoria batean lotzea nahi duzu?",
  categoria: "Kategoria",
  seleccionarCategoria: "Kategoria hautatu",
  omitirYCrear: "Saltatu eta sortu",
  aceptarYAgregar: "Onartu eta gehitu",

  // 01/07/2021
  porRangosHorarios: " ordutegi-tarteen arabera",

  // 22/07/2021
  recuerdeQueLasLineasDeDescuentoNoSeSumanAlTotal:
    "Gogoratu deskontu lerroak ez direla guztira gehitzen",

  // 16/07/21
  destacado: "Nabarmendua",
  sugerido: "Gomendatua",

  // 23/07/2021
  totalSinDescuento: "Deskonturik gabe totala",

  // MENÚS
  menus: "Menuak",
  descripcionMenus: "Elkarren artean saltzen diren produktuen taldea",
  numeroDePlatos:
    "Bezeroak aukeratu ditzakeen plater kopurua plater bakoitzeko:",
  platosTip1: "Pantaila honetan sortu daitezke plater desberdinak",
  platosTip2: "menua osatzeko, eta ondoren produktuekin lotzeko.",
  productosPlatosTip:
    "Pantaila honetan platerak eta produktuak erlaziona daitezke, ondoren kartean bistaratuko dira.",
  plato: "Platera",
  platos: "Platerak",
  primerPlato: "Lehenengo platera",
  segundoPlato: "Bigarren platera",
  tercerPlato: "Hirugarren platera",
  cuartoPlato: "Laugarren platera",
  quintoPlato: "Bosgarren platera",
  sextoPlato: "Seigarren platera",
  seleccionaUnPlato: "Hautatu platera",
  noPuedeDejarEnBlancoElNombreDeUnPlato:
    "Ezin duzu plater baten izena hutsik utzi",
  estaSeguroDeQueQuiereBorrarEstePlato:
    "Ziur zaude plater hau ezabatu nahi duzula?",
  seBorraranTodasLasAsociacionesDeProductosConElMismo:
    "Produktuarekin dauden erlazio guztiak ezabatuko dira",
  siEstoySeguro: "Bai, ziur nago",
  estaSeguroDeQueQuiereDesvincularEsteProductoDelPlatoSeleccionado:
    "Ziur zaude produktu hau platerarekin lotuta ezabatu nahi duzula?",
  dejaraDeFormarParteDelMenuDeFormaInstantanea:
    "Berehala ez da menuaren parte izango",
  noMostrarSuelto: "Ez erakutsi bakarrik (menuetan bakarrik eskuragarria)",
  clonarMenu: "Menua klonatu",
  // 29/07/2021
  totalPedidosDevueltos: "Itzulitako eskaeren kopurua",
  totalImportesDevueltos: "Itzulitako guztizko kopurua",

  // 06/08/2021
  NoMostrarRecargasSaldo: "Saldo kargak ez erakutsi",
  // 10/08/2021
  noMostrarDescuento: "Deskonteak ez erakutsi",
  // 17/08/2021
  operarioApertura: "Irekitzeko langilea",
  aperturasPorOperarios: "Langile bakoitzak irekitako kontuak",
  aperturasPorOperariosMinuscula: "langile bakoitzak irekitako kontuak",
  aperturasOperarios: "Irekitako kontuak",
  productosPorAperturaDe: "Irekitzearen arabera produktuak",
  productosPorApertura: "Irekitzearen arabera produktuak",
  facturasEmitidasMinuscula: "igortutako fakturak",

  // 18/08/21
  restriccionesProductos: "Produktuen murrizketak",
  restriccionesProductosDesc:
    "Produktuen salmentarako ordutegi-murrizketak konfiguratu",
  // 19/08/21
  noHayRestriccionesParaProductos:
    "Ez dago produktuen ordutegi-murrizketarik negozio honetan.",
  alcohol: "Alkohola",
  // 20/08/21
  inforestriccionesproducto:
    "Ordutegi-murrizketa sortu ondoren, produktuetan konfiguratu ahal izango duzu.",
  noMostrarDescuento: "Deskonteak ez erakutsi",

  // 17/08/2021
  rangosDeMesas: "Mahai-tarteak",
  agrupacionesDeMesasParaConsultarVentas:
    "Salmentak kontsultatzeko mahai-taldeak",
  verUnInformeDeRangosDeMesas: "Ikusi mahai-tarteen txostena",
  nuevoRangoMesa: "Mahai-tarte berri",
  mesaInicial: "Hasierako mahaia",
  mesaFinal: "Amaierako mahaia",
  noHayRangosDeMesasEnEsteTpv: "Ez dago mahai-tarterik TPV honetan",
  nombreRangoDeMesas: "Mahai-tartearen izena",
  borrarRangoMesas: "Mahai-tartea ezabatu",
  deseaEliminarEsteRangoDeMesas: "Mahai-tarte hau ezabatu nahi duzu?",
  siBorrarEsteRangoDeMesas: "Bai, mahai-tarte hau ezabatu",
  ventasPorRangoDeMesas: "Salmentak mahai-tartearen arabera",
  porRangoDeMesas: " mahai-tartearen arabera",
  numeroDeOperaciones: "Operacion kopurua",
  precioMedioPorOperacion: "Operazio bakoitzeko batez besteko prezioa",
  propuestoParaCierre: "Itxierarako proposatua",
  esteTicketHaSidoPropuestoParaSuCierreComaEstaUstedDeAcuerdo:
    "Txartel hau itxierarako proposatua izan da, ados zaude?",
  siCerrarTicket: "Bai, txartela itxi",
  propuestaDeCierreDeTicket: "Txartelaren itxieraren proposamena",
  noEstoyDeAcuerdo: "Ez nago ados",
  ultimaRespuestaDelEquipoTecnico: "Azken erantzuna tekniko-taldearen aldetik",
  escribaAquiSuRespuesta: "Idatzi zure erantzuna hemen",
  enviarRespuesta: "Erantzuna bidali",
  tienesTicketsPendientesDeCerrar: "Itxi gabe dituzun txartelak daude",

  // 27/08/2021
  cuandoUnProductoEsDeTipoMenuSeCreaUnProductoMenuEnElTPV:
    "Produktua Menu motakoa denean, TPV-rekin sinkronizatutako Menu bat sortzen da",
  platosDelMenu: "Menuaren platerak",
  productosDelMenu: "Menuaren produktuak",
  paraConfigurarUnProductoComoTipoMenu:
    "Produktua Menu motakoa izateko, lehenik produktuaren datuak gorde behar dira",
  ocultarSaldo: "Saldoarekin lotutako produktuak ezkutatu",

  // 26/08/21
  resActiva: "Aktibatuta",
  resInactiva: "Desaktibatuta",

  // 26/08/2021
  exportarExcelDeTodosLosTickets: "Ticket guztiak Excel-era esportatu",
  soloPuedesSacarInformesDeUnMesComoMaximo:
    "Maximo batean soilik atera daitezke txostenak",
  loSentimos: "Barkatu",
  noTienesNingunRangoDeMesasCreadoDeseasCrearUnRangoDeMesas:
    "Ez duzu mahai-tarterik sortuta. Mahai-tarte berri bat sortu nahi duzu?",
  siCrearUnRangoMesas: "Bai, mahai-tartea sortu",

  // 07/08/2021
  usuarioSinAcceso: "Zure erabiltzaileak ez du sarbiderik modulura",

  // 08/09/21
  pedidosHoras: "Orduko eskaerak",
  graficaPedidosHoras:
    "Grafikoa, gaurko eguneko eskaerak ordutegi-tartearen arabera erakusten ditu",

  // 20/09/21
  personalizacionCarta: "Lineako Kartearen pertsonalizazioa",
  personalizacion: "Pertsonalizazioa",
  conLasOpcionesQueTeOfrecemos: "eskainitako aukerekin",
  opcionesConfiguracion: "Konfigurazio-aukerak",
  vistaPrevia: "Aurrebista",
  imagenCargando: "Irudia kargatzen",

  // 21/09/21
  diagnosis: "Diagnosia",
  diagnosticoProductos: "Produktuen diagnostikoa",
  comprobacionProducts: "Produktuen egiaztapena",
  diagnosticarProductos: "Produktuen diagnostikoa egin",
  productosSinRelacionEnElTpv: "Dena ondo!",
  pulseElBoton: "Sakatu nahi duzun botoia",
  paraRealizarDiagnosis: "diagnosia egiteko",
  productoRelacionadoConTpv: "TPV-rekin lotuta",
  noTieneRelacion: "Ez du loturarik",
  hayProductosSinRelacion: "TPV-n loturarik ez duten produktuak daude",

  // 20/09/21
  destacadosTitulo: "Izenburu nabarmendua",
  nuevoTitulo: "Izenburu berria",
  tituloActual: "Uneko izenburu",

  // 22/09/21
  textos: "Testuak",

  // 21/09/21
  facturas: "Fakturak",
  facturasMinusculas: "fakturak",
  facturacionGeneral: "Fakturazio orokorra",
  deTodasLasSeries: " serie guztietatik",

  // 29/09/21
  permisoBusinessGestion:
    "Barkatu. Ez duzu baimenik tresna hau erabiltzeko negozio honetan",
  permisoUsuarioGestion: "Barkatu. Negozio honek ez du modulu hau aktibatuta.",
  traduccion: "Itzulpena",
  traduccionDe: "Itzulpena honetatik",
  idioma: "Hizkuntza",
  losDescuentosDeLasVentasEstanAlCeroDeIva:
    "Salmentetako deskonteak %0ko BEZarekin daude",
  recuerdeQueAlRealizarCobrosAvanzadosLosComensalesSeAsignaranALaFormaDePagoEfectivo:
    "Gogoratu aurreratutako kobramenduetan bezeroak eskudiruzko ordainketara asignatuko direla",
  mapasYZonas: "Mapak eta eremuak",
  idiomas: "Hizkuntzak",
  permisoControlIdiomas:
    "Barkatu, negozio honek ez du hizkuntzen kontrola aktibatuta.",
  idiomasCartaTip1:
    "Hizkuntza bat aktibatu edo desaktibatzeko, klik egin etengailuetan.",
  idiomasCartaTip2: "Hizkuntzak kartean ordenatzeko, erabili ordenaren eremua.",
  idiomasCartaTip3: "Orden txikiagoa duten hizkuntzak lehenengo agertuko dira.",
  menu: "Menu",

  // 30/11/21
  totalVentasDevueltos: " salmenta eta itzulitako guztira",

  // 24/11/21
  tpvOrigen: "Jatorrizko TPV",
  validez: "Baliozkotasuna (egun)",
  dateConsumo: "Kontsumo-data",
  dateCreacion: "Emisio-data",
  nombreTpvDestino: "Truke TPV",
  nombreTpvOrigen: "Jatorrizko TPV",
  hash: "KODEA (hash)",
  proveedor: "Hornitzailea",

  // 14/12/2021
  apuntes: "Oharra",
  apunte: "Oharra",
  cuentaContableGastos: "Kontu kontable gastuak",
  cuentaContableApuntes: "Kontu kontable oharra",
  retrocederEstado: "Egoera atzera",

  // 23/12/2021
  excluirDeSage: "Sage-tik kanpo utzi",
  costeDeProductosPorAgencias: "Produktuaren kostua agentzien arabera",
  agrupadoPorAgencias: " agentzietan multzokatuta",

  // 27/10/21
  selectCategory: "Hautatu kategoria importaziorako",
  errorCategorySelect: "ADI",
  txtErrorCategorySelect:
    "Importazioa bertan behera utzi da, hautatutako kategoriak menuak soilik baititu.",

  // 24/01/22
  consultarPorAperturaDeCuenta: "Kontuaren irekieraren arabera kontsultatu",
  consultarPorCierreDeCuenta: "Kontuaren itxieraren arabera kontsultatu",
  informeAperturaCuentas: "Kontu irekieraren txostena",
  informeCierreCuentas: "Kontu itxieraren txostena",
  activado: "Aktibatuta",
  desactivado: "Desaktibatuta",
  rango: "Tarifa",
  pedidosPlataformaDePagoSinCompletar:
    "Ordaindu gabeko ordainketa-plataformako eskaerak",
  estaAccionAnadiraUnPedidoEstaSeguro:
    "Ekintza honek eskaera bat gehituko du, ziur zaude ordainketa egin dela?",
  estaAccionNoSePuedeDeshacerEstaSeguro:
    "Ekintza hau ezin da desegin, ziur zaude?",
  haHabidoUnPedidoConEsteTelefonoEnLasUltimas12Horas:
    "Telefono honekin azken 12 orduetan eskaera bat egon da",
  interrogacionQuiere: "Ba al nahi duzu ",
  elPedidoTemporalInterrogacion: " eskaera aldi baterako?",
  aceptarMinuscula: "onartu",
  eliminarMinuscula: "ezabatu",
  excluirPrecioMedioMenu:
    "Menuetan saldutako produktuak batez besteko prezioetik kanpo utzi",

  // 28/01/22
  categoriasPadre: "Ama-kategoriak",
  quieresConvertirLaCategoria: "Kategoria hau bihurtu nahi duzu",
  quieresQueLaCategoria: "Kategoria hau nahi duzu",
  enUnaCategoriaPadre: "ama-kategoria batean?",
  dejeDeSerUnaCategoriaPadre: "ama-kategoria izateari utzi",
  porFavorAnadaUnaCategoriaPadreAntesDeActivarLaConfiguracion:
    "Mesedez, gehitu ama-kategoria bat konfigurazioa aktibatu aurretik",
  deseaActivarLasCategoriasPadreParaLaCartaDigital:
    "Ama-kategoriak aktibatu nahi dituzu lineako kartearako?",
  deseaDesactivarLasCategoriasPadreParaLaCartaDigital:
    "Ama-kategoriak desaktibatu nahi dituzu lineako kartearako?",
  recuerdeQueLasCategoriasQueNoEstenRelacionadasAUnaCategoriaPadreNoApareceranEnLaCartaDigital:
    "Ama-kategoriari lotura ez duten kategoriak ez dira agertuko Numier Pedidos-en",
  activadas: "AKTIBATUTA",
  desactivadas: "DESAKTIBATUTA",
  categoriasPadreTextoExplicativo:
    "Ama-kategoriak Numier Pedidos kategorien taldeketa handiagoak egiteko erabiltzen dira. Adibidez: Primeros ama-kategoria izan daiteke, eta Carne, Pescado eta Vegetariano barne.",
  lasImagenesSoloSeraVisibleEnLasCategoriasPadre:
    "Irudiak ama-kategorietan soilik ikusiko dira",

  // 09/02/2022
  consultarInventarioPorSectores: "Kontsultatu inventarioa sektoreka",
  inicioReal: "Hasiera benetakoa",
  precarga: "Aurrekarga",
  mermas: "Galera",
  finalBarra: "Barraren amaiera",
  porSectores: "sektoreka",
  buscarPorRefONombreDelProducto: "Bilatu produktua kode edo izenaren arabera",
  textoAyudaProductoCompleto:
    "Aukera hau desmarkatuta dagoenean, lehengaiak erabiliko dira",
  accion: "Ekintza",

  metodoLiquidacionSinqro: "Sinqro likidazio metodoa",
  metodoLiquidacionSinqroInfo:
    "Eremu hau aldatzea laguntza teknikoari eskatu behar zaio.",
  horaRepartidorAsignado: "Eskaera banatzaileari esleitutako ordutegia",
  envioProgramado: "Bidalketa programatua",
  tiempoEstimado: "Denbora estimatua",
  gastosEnvio: "Bidalketa-gastuak",
  buscarPedidoPorCliente: "Bilatu eskaera bezeroaren arabera...",
  obligatorioApellidos: "Bi abizenak derrigorrezkoak dira",

  // 13/06/2022
  introduzcaElPorcentajeDeLaPrimeraCuentaContable:
    "Sartu lehen kontu kontablearen ehunekoa",
  porcentajeContable: "Kontu ehunekoa",

  // 7/7/2022
  incidenciaOperario: "Langilearen intzidentziak",
  deIncidenciaOperario: "langilearen intzidentzien arabera",
  verIncidenciaOperario: "Ikusi intzidentziak",
  Incidencia: "Intzidentzia",

  // 11/07/2022
  nTickets: "Txartel kopurua",
  propina: "Ahozko gomendioa",
  serviceCharge: "Zerbitzu tasak",

  // 15/07/2022
  totalCompleto: "Guztizko guztira",

  // 31/08/2022
  sinConsumir: "Erabili gabe",

  // 06/09/2022
  integraciones: "Integraketak",
  GStock: "G-Stock",

  // 13/09/2022
  estasSeguroDeExportarLasVentas:
    "Ziur zaude salmentak G-Stock-era esportatu nahi dituzula?",
  ventasExportadasExsitosamente: "Salmentak arrakastaz esportatu dira",
  rangoFechasExcedidoMaximo: "Data-tartea 3 hilez ez daiteke gainditua",
  rangoSolicitadoMayorAlPermitido: "Eskatutako tartea baimendutakoa baino handiagoa da (gehienez 3 hilabete)",
  respuestaInvalida: "Zerbitzariaren erantzun baliogabea",

  // 04/10/2022
  referenciaYaExiste: "Erreferentzia beste gastu batekin bat dator",
  continuar: "Jarraitu?",
  guardarGasto: "Gastuak gorde",
  maximoOpcionales: "Hautazko gehienekoak",

  // 04/11/2022
  totalImpuestoIva: "BEZaren guztizko zerga",

  // 09/11/2022
  enviarFacturaECorreo: "Faktura elektronikoa posta bidez bidali",

  // 10/11/2022
  baseImponible: "Oinarri zergapetua",
  cuotaIVA: "BEZ kuota",
  baseSinDto: "Oinarria dto gabe",
  importeTotalSinDto: "Guztira dto gabe",

  // 17/11/2022
  identificador: "Identifikatzaile kontable",

  // 13/12/2022
  cambiarAgencia: "Agentzia aldatu",
  facturaEditadaCorrectamente: "Faktura behar bezala editatu da",
  editarNumeroComensales: "Bezeroen kopurua editatu",
  buscarPorNombreDeAgencia: "Bilatu agentziaren izenaren arabera",

  // 10/01/2023
  exportadoSage: "SAGE-ra esportatua",
  updateExportadoSageCorrectamente:
    "SAGE-ra esportatua behar bezala eguneratu da",
  titleModificarExportadoSage: "SAGE-ra esportatua aldatu",
  askUpdateExportadoSageTrue: "Ziur zaude gastua esportatua jarri nahi duzula?",
  askUpdateExportadoSageFalse:
    "Ziur zaude gastua EZ esportatua jarri nahi duzula?",

  // 01/02/2023
  ProgramacionCarta: "Kartaren planifikatzailea",
  guardados: "Gordetakoak",
  publicados: "Argitaratutakoak",
  dePublicacion: "Argitaratzetik",
  sinPublicar: "Argitaratu gabe",
  publicado: "argitaratua",
  publicar: "Argitaratu",
  Ocultar: "Ezkutatu",
  Publicado: "Argitaratua",
  aliasMayuscula: "Alias",

  // 03/02/2023
  porcentajeRespectoTotal: "% guztizkoaren arabera",

  // 13/02/2023
  ultimoPrecioCompra: "Azken erosketaren prezioa",

  // 21/02/2023
  basePropina: "Ahozko oinarria",
  impuestoPropina: "Ahozko zerga",
  baseServiceCharge: "Zerbitzu tasaren oinarria",
  impuestoServiceCharge: "Zerbitzu tasaren zerga",

  // 02/03/2023
  socios: "Bazkidea",
  noSocios: "Ez bazkidea",

  // 20/04/2023
  productoCartaSinRelacionar: "Loturarik gabe",

  // 21/04/2023
  precioTarifa: "Prezioa / Tarifa 1",

  resetearDias: "Egunak berrezarri",
  resetearButton: "Berrezarri",
  fechaIni: "Hasiera-data",
  fechaFin: "Amaiera-data",
  reseteoExitoso: "Berrezarpena behar bezala egin da",
  reseteoError: "Errore bat egon da berrezarpena egiten",

  productosNoRelacionados: "PLU gabeko produktuak",
  productosNoRelacionadosDescripcion: "PLU gabeko produktuak aurkitzeko tresna",

  // 23/05/2023
  verDetallesDeCuentaAnulada: "Ezeztatuta dagoen kontuaren xehetasunak ikusi",
  desgloseDeCuenta: "Kontuaren banaketa",

  // 29/03/2023
  exportarExcelValderrama: "Excel osoa esportatu",

  // 20/04/2023
  productoCartaSinRelacionar: "Loturarik gabe",

  // 21/04/2023
  precioTarifa: "Prezioa / Tarifaren 1",

  // 29/05/2023
  pendientePago: "Ordainketa zain",
  fechaVencimiento: "Bukaera-data",
  pendientePagoCambiadoCorrectamente: "Ordainketa zain behar bezala aldatu da",
  numeroTickets: "Txartelen kopurua",

  // 06/06/2023
  mensajePorcentajeCompraAumento:
    "Prezioa ezarritako erosketaren ehunekoan igo da",
  avisoPorcentajeCompra: "Erosketaren ehunekoaren abisua",

  // 19/06/2023
  conIvaDesglosado: "BEZ deskontatua barne",

  // 21/06/2023
  ventasPorProductos: "Salmentak produktuen arabera",
  sinRecoger: "Jasotzeko gabe",
  sinDomicilio: "Hirigunerik gabe",
  recogerEnPedidos: "Jaso",
  domicilioEnPedidos: "Hirigune",
  informeDeVentasDeProductosDePedidos: "Eskaeren produktuen salmenten txostena",

  // 22/06/2023
  numeroPedidosDomicilio: "Etxeko eskaeren kopurua",
  numeroPedidosRecoger: "Jasotzeko eskaeren kopurua",

  // 25/07/2023
  exportarSage200Fechas: "Sage200 dataren arabera esportatu",
  fechas: "Datak",
  soloExportarGastos: "Gastuen esportazioa bakarrik",

  // 05/09/2023
  noMostrarInformeSectores: "Eremuen txostena ez erakutsi",
  totalCargar: "Guztira kargatu",
  deshabilitar: "Desaktibatu",
  noMostrar: "Ez erakutsi",

  // 19/09/2023
  verificarTodo: "Denak egiaztatu",
  estaSeguroDeVerificarTodosLosGastos:
    "Ziur zaude gastu guztiak egiaztatu nahi dituzula?",
  gastosVerificadosCorrectamente: "Gastuak behar bezala egiaztatu dira",

  // 26/09/2023
  siVerificarGastos: "Bai, gastuak egiaztatu",
  seleccionarTodosDelMismoProveedor: "Hautatu hornitzaile bereko guztiak",

  // 28/09/2023
  mostrarSinIva: "BEZ gabe erakutsi",
  modificarPrecio: "Prezioa aldatu",

  // 05/10/2023
  nDeComensales: "Bezeroen kopurua",

  // 13/10/2023
  archivoEnFormatoExcel: "Excel formatuan fitxategia",
  importarExcelClientes: "Bezeroen Excel inportatu",
  importarExcelSaldoClientes: "Bezeroen saldoaren Excel inportatu",
  importarClientes: "Bezeroak inportatu",

  // 31/10/2023
  ticketMedioRecoger: "Jasotzeko ticket ertaina:",
  ticketMedioDomicilio: "Etxerako ticket ertaina:",

  // 23/11/2023
  ultimoPrecioCompraSinIva: "Azken erosketaren prezioa BEZ barik",

  // 08/01/2024
  ventaDeProductosPorRangoDeMesas: "Produktuen salmentak mahai-tarteen arabera",
  filtradoPorRangoDeMesas: " mahai-tartearen arabera iragazia",
  vecesQueSeHaVendidoDentroDeMenus: "Menuetan saldu den maiztasuna",
  delMenu: "menuaren",
  cEnMenus: "Menuetan C.",
  cFueraDeMenus: "Menuetatik kanpo C.",
  rangoDeMesas: "Mahai-tartea",

  // 10/01/2024
  // ToolTip
  tolTipLogo:
    "Gehitu zure jatetxeko logotipoa hasierako pantailan eta zure QR txartelean ager dadin. Gomendatutako tamaina 90 x 90 px da.",
  tolTipFondo:
    "Gehitu kalitate handiko argazki bat zure QR menuko azalean ager dadin. Gomendatutako tamaina 1280 x 1024 px da.",
  tolTipImagenProducto:
    "Gehitu kalitate handiko irudi bat zure produktua bisual eta erakargarri erakusteko. Menuetako produktuetarako, sortu berria 500 x 500 px edo 12 cm x 12 cm-ko ebazpenarekin.",
  tolTipNombreMostrado:
    "Idatzi hemen zure negozioaren izena erakutsi nahi duzuna.",
  tolTipEmail: "Emateko bezeroekin harremanetan jartzeko email bat.",
  tolTipTelefono: "Emateko kontaktu-telefonoa.",
  tolTipDescripcion:
    "Laburbildu zure jatetxea: kontzeptua eta eskaintzen duzun esperientzia.",
  tolTipDireccion: "Emateko jatetxearen helbidea, kartarekin lotua.",
  tolTipPresentacion:
    "Idatzi deialdi egokia, bezeroek QR txartela ireki nahi izateko.",
  tolTipHorario:
    "Erakutsi ordutegia edo informazio gehigarria (oporrak, zerbitzutik kanpo...).",
  tolTipMostrarCategoriaDeBaja:
    "Kutxa markatuz gero, baja emandako kategoriek agertuko dira, baina ez dute zure kartan ikusiko.",
  tolTipMostrarProductoDeBaja:
    "Kutxa markatuz gero, baja emandako produktuek agertuko dira, baina ez dute zure kartan ikusiko.",
  tolTipTraducirCategoria:
    "Itzuli kategorien izenburuak nahi duzun hizkuntzara",
  tolTipConvertirCategoriaPadre: "Kategori nagusi bihurtu",
  tolTipOrdenCategorias:
    "Kategoria hau lehenengo agertu nahi baduzu, zenbakia '1' izan behar da, eta horrela jarraitu ordenaren arabera.",
  tolTipBajaCategoria:
    "Aukera hau aktibatzean, hautatutako kategoria ez da zure menu digitalean agertuko. Kategoria bat desaktibatzeak bertan dauden produktuak ere ez dira ikusiko.",
  tolTipVerQr: "Sartu eta deskargatu zure kartako QR kodea",
  tolTipDisponibleProducto:
    "Markatu produktua eskuragarri dagoen: produktua zure kartan dagoen edo ez adierazten du.",
  tolTipIdiomaProducto: "Aukeratu produktua erakutsi nahi duzun hizkuntza",
  tolTipOrdenProducto: "Aukeratu produktua kategoria hautatuan nola agertu",
  tolTipProductoDestacado:
    "Aukera hau hautatzen baduzu, produktu hau menuaren hasieran nabarmendutako atalean agertuko da. Produktu bereziak edo promozioak nabarmentzen ditu.",
  tolTipBaja: "Produktu hau ez da zure kartan agertuko (aktibatuta badago).",
  tolTipDisponible:
    "Aktibatu botoia produktua salgai badago. Desaktibatu produktua 'Stock-etik kanpo' dagoenean.",
  tolTipImagenCarga:
    "Irudia kartaren kargatze denbora laburrean erakutsiko da.",
  tolTipTituloDestacado:
    "Hemen produktu nabarmenduak izendatuko dituen testua defini dezakezu. Adibidez: 'Chef-en gomendioak', 'Gure Top Salmentak' edo 'Ez galdu'.",
  tolTipIdiomaMateriaPrima: "Aukeratu lehengaia erakutsi nahi duzun hizkuntza",
  guiaUsuario: "Erabiltzailearen gida",

  // 14/02/24
  pedidosPorRepartidores: "Banatzailearen arabera eskaerak",
  nombreRepartidor: "Banatzailearen izena",
  cantidadDePedidos: "Eskaeren kopurua",

  // 13/02/2024
  herramientaControlStockControlComprasInventarios:
    "Stock kontrol, erosketen eta inventarioen kontrol tresna",
  fidelizacion: "Fidelizazioa",
  cheerfy: "Cheerfy",
  plataformaGestionPromocionesClientes:
    "Bezero promozioen kudeaketa plataforma",
  nuevaPromocion: "Promozio berria",
  noHayPromocionesEnEsteTpv: "Ez dago promoziorik TPV honetan",
  tolTipDisponiblePromocion:
    "Markatu promozioaren erabilgarritasuna: promozioa eskuragarri dagoen edo ez adierazten du.",
  promocion: "promozioa",
  fechaCreacion: "Sortze-data",
  activo: "Aktiboa",
  inactivo: "Inaktiboa",
  borrarPromocion: "Promozioa ezabatu",
  promociones: "Promozioak",
  codigoPromocion: "Promozio kodea",
  elCampoCodigoEsRequerido: "Kode eremua beharrezkoa da",
  deseaEliminarEstaPromocion: "Promozio hau ezabatu nahi duzu?",
  siBorrarEstaPromocion: "Bai, promozio hau ezabatu",

  // 12/03/24
  basesFree: "Oinarri gehigarriak doan",
  extrasFree: "Oinarriak / Extra doan",
  tooltipBaseExtra:
    "Oinarria aktibatuta badago, ez da extra doan gehituko. Extra aktibatuta badago, ez da doan kontatuko.",

  // 09/04/24
  permisoControlModulos: "Barkatu. Negozio honek ez du modulua aktibatuta.",
  calcularCosteTodosLosProductos: "Produktuen kostua kalkulatu",
  trabajarSinIva: "BEZ barik lan egin",
  filtrarPorAgencias: "Agentziaren arabera iragazi",
  seleccioneLaTarifaParaMostrarSuNombre: "Aukeratu tarifa kostua erakusteko",
  conIVA: "BEZarekin",
  calcular: "Kalkulatu",
  productosIncluidosConEsteMenu: "Menu honetan sartuta dauden produktuak",
  abonarFacturaQr: "QR faktura ordaindu",
  deseasAbonarEstaFacturaQR: "QR faktura hau ordaindu nahi duzu?",
  abonarFactura: "Faktura ordaindu",

  exportar: "Esportatu",
  codigoBarras: "Barra kodea",
  codBarras: "B.Kodea",

  // 18/08/24
  listadoTicketRepartidor: "Banatzailearen tiket-ak",

  // WALLET
  passbooks: "Wallet-ak",
  sharePassbooks: "Wallet-ak partekatu",
  copyToClipboard: "Kopiatu paperean",
  shareViaEmail: "Bidali e-mail bidez",
  shareViaWhatsapp: "Bidali Whatsapp bidez",
  copied: "Paperean kopiatu da",
  selectBusinessForWallet: "Aukeratu wallet-ak bidali nahi dituzun negozioa",
  sendMethod: "Bidalketa metodoa",
  share: "Bidali",
  sendAndSaveButton: "Bai, bidali eta gorde",
  sendAndNoSaveButton: "Ez, bidali eta ez gorde",
  titleSaveInfoModalText:
    "Bezeroaren informazioa aldatu da. Informazio hau gorde nahi duzu?",
  verifyNumberText: "Telefonoa egiaztatu",
  verifyEmailText: "E-maila egiaztatu",
  selectOption: "Aukeratu aukera bat",
  clipboardCopied: "Paperean kopiatu da",
  clipboardFailedToCopy:
    "Paperean API hau ez dago erabilgarri nabigatzaile honetan.",
  enviarWallet: "Wallet bidali",
  confirmacionEnvioWallet: "Wallet bidalketaren baieztapena",
  confirmacionTextoEnviarWallet:
    "Ziur zaude wallet bezero guztiei bidali nahi diozula?",
  mensajeConfirmacion:
    "Ekintza hau ezin da desegin eta email-a gehita eta Barra kodea duen bezeroei soilik bidaliko zaie.",
  enviar: "Bidali",
  noHayCorreosElectronicos: "Ez dago emailik.",
  ningunClienteConCorreoElectronico: "Ez da emaila duen bezeroik aurkitu.",
  clientHasNoBarcode: "Bezeroak ez du barra kodea ezarri.",
  exportarCarta: "Karta esportatu",
  exportarSimplifiedExcel: "Excel gisa esportatu (Goiburu gabe)",

  // GESTIÓN DE IMPUESTOS
  taxes: "Zergak",
  tax: "Zerga",
  gestionImpuestos: "Zergen kudeaketa",
  administracionTiposTasas: "Kudeaketa",
  administracionTiposTasasImpositivas: " zergen eta tasa motak",
  agregarImpuesto: "Zerga gehitu",
  taxRate: "Aplikatutako zerga",
  taxDescription: "Deskribapena",
  taxType: "Zerga mota",
  taxBoldType: "zergak",
  impuestoAplicadoEsCero: "Aplikatutako zerga ezin da txikiagoa izan",
  impuestoYaCreado: "Zerga hau existitzen da eta ezin da berriro sortu",

  // IMPORTAR CLIENTES
  previewClientData: "Bezeroen aurrebista",
  editarCliente: "Bezeroa editatu",
  importarData: "Datuak inportatu",
  importandoDatos: "Datuak inportatzen",
  preview: "Aurrebista",
  importacionRealizada: "Inportazioa egin da",
  datosImportados: "Datuak behar bezala inportatu dira",
  confirmarImportacion: "Inportazioa berretsi",
  seguroContinuarImportacion:
    "Ziur zaude jarraitu nahi duzula? Ekintza hau ezin da desegin",

  // 18/11/24 - Update-Logo
  inserteImagen: "Sartu irudi bat",
  seleccioneArchivoImagen: "Aukeratu irudi fitxategia",
  archivoDemasiadoGrande:
    "Fitxategia handiegia da. Baimendutako tamaina maximoa 5MB da.",
  dimensionesExcedenLimite:
    "Irudiaren neurriak baimendutako muga gainditzen du (2000x2000px).",
  mensajeconfirmacion:
    "Existitzen den irudia ordezkatzeko prest zaude. Gorde nahi duzu?",
  botonGuardar: "Gorde",
  botonCancelar: "Utzi",
  Guardado: "Gordeta",
  guardarOvisualizarLogo: "Logotipoa ikusi edo gorde",
  configurarLogoNegocio: "Negozioaren logotipoa konfiguratu",
  seleccionLogo: "Klik egin logo bat aukeratzeko",
  volver: "Itzuli",
  noExisteLogoNegocio: "Negoziorako logorik ez dago.",
  informacion: "Informazioa: ",
  tamaño: "Tamaina: ",
  dimensiones: "Neurriak: ",
  restriccionesLogo: "Logotipoaren muga-kopurua:",
  tamañoMaximo: "Tamaina max: ",
  dimensionesMaximas: "Neurriak max: ",

  // 13/12/24 - ProductosNoRelacionados
  mensajeAviso:
    "Ziur zaude PLU-ak automatikoki sortu nahi dituzula? Prozesu honek kode bat sortuko du konfiguratu gabeko produktu eta tarifetarako eta automatikoki gorde egingo da.",
  mensajeAvisoSubProducto:
    "Ziur zaude PLU-ak automatikoki sortu nahi dituzula? Prozesu honek kode bat sortuko du konfiguratu gabeko lehengaietarako eta automatikoki gorde egingo da.",
  generarPlu: "PLU-ak automatikoki sortu",
  botonAceptar: "Onartu",
  PLUsGenerados: "PLU-ak behar bezala sortu dira!",
  errorGenerandoPLUs: "Errorea PLU-ak sortzean",

  // 21/01/2025
  nosmudamos: "Mugitzen gara!",
  noscambiamosaselfi:
    "Zure negozioak pauso handia eman du: orain zure karta Selfibar familiaren parte da. Horrela, karta-rekin lotutako konfigurazio eta kudeaketak zuzenean Selfibar-en egin ahal izango dituzu.",
  esteNegocioEsSelfi: "Negozio hau Selfibar da",
  paraContinuar:
    "Jarraitzeko, egin klik Selfibar-en eta sartu zure Selfibar kontuan erabiltzaile eta pasahitzarekin",
  irASelfibar: "Joan Selfibar-era",
  barcodeUnico: "Barra kode bakarra",
  barcodeNecesarioSeActualizara:
    "Barra kodea beharrezkoa da ekintza honetarako eta bezero honi bidaltzean edo paperean kopiatzean eguneratuko da.",
  emailenviado: "Emaila bidalia",

  // ListadomateriaPrima-Proveedor
  // 14/01/25
  verListado: "Lehengai zerrenda",
  listadoMateriaPrimaProveedor: "Lehengai zerrenda hornitzailearen arabera",
  noTiene: "Ez du ",
  esteProveedor: " hornitzaile hau",
  precioAcordado: "Hornitzailearekin adostutako prezioa",
  porcentajeAcordado: "Adostutako ehunekoa ",
  filtrarPorEtiqueta: "Etiketaren arabera iragazi: ",
  precioAcordadoGuardadoCorrectamente: "Prezioa finkatuta. Ondo gorde da!",
  fijarprecio: "Prezioa finkatu ",
  preciofijado: "(Lehengaiaren prezioa finkatzeko)",
  mensajePrecioFijado: "Lehengaiaren prezioa da  ",
  explicacionFijarPrecio:
    "Aktibatzean, lehengaiaren prezioa eta deskontu ehunekoa finkatuta geratuko dira. Gastu berri bat egiterakoan prezioa edo deskontua ez dira aldatuko.",
  porcentajeAcordado: "Ohartarazpen ehunekoa",
  porcentajeAcoradoGuardado: "Adostutako ehunekoa. Ondo gorde da!",
  losSubproductosSeHanIncrementado:
    "Hurrengo lehengaietan prezio igoera detektatu da hornitzailearekin adostutako ehunekoan konparatuta",
  errorverificar: "Errorea egiaztatzen",
  mensajeErrorVerificarTodo:
    "Hurrengo gastuetan lehengaiaren prezio igoera detektatu da hornitzailearekin adostutako ehunekoan konparatuta",
  explicacionPorcentajeAcordado:
    "Hau hornitzailearekin adostutako ehunekoa da, lehengai prezioen kontrolerako gastua egiterakoan.",
  generarBusinessHash: "URL sortu langileentzat",
  enlaceFicharTurnosOperario: "Sartu eta kontsultatu txandak",
  enlaceFicharTurnosOperarioDescripcion:
    "Negozioaren langileek TPV-eko kredentzial berberak erabiliz sartu ahal izango dute txandaren hasiera eta bukaera erregistratzeko, baita azken 14 txandak eta haien denbora kontsultatzeko.",

  // KIOSKOS
  kioskos: "Kioskoak",
  stockBreak: "Stock eten",
  kiosksMenu: "Kioskoen karta",
  barcode: "BARCODE",

  sort: "Ordenatu",
  productSorted: "Produktuaren ordena behar bezala eginda",
  subproductSorted: "Lehengaiaren ordena behar bezala eginda",
  categorySorted: "Kategoriaren ordena behar bezala eginda",

  saldoAnterior: "AURREKO SALDOA",
  saldoActual: "EGUNEROKO SALDOA",

  // 31/01/2025
  guardarOreplicar:
    "Produktua kartan dago. Produktuaren aldaketak gordetzea nahi duzu, ala gorde eta kartan erreplikatu?",
  guardarYreplicar: "Gorde eta erreplikatu kartan",
  CrearProductoEnCarta: "Gorde eta sortu produktu kartan",
  tienesProductosSinActualizar:
    "Kartan produktu eta/edo lehengai batzuk TPV-n eguneratu gabe edo baja egoeran daude",
  porFavorDirijaseADiagnosticoParaActualizar:
    "Mesedez, joan Carta digital > Carta konfigurazioa > Diagnostikoa > Diagnostikoan eguneratzeko zain dauden produktuak eta lehengaiak berrikusteko",
  irAdiagnosis: "Joan Diagnostikora",
  realizarDespues: "Gero egin",
  actualizarProductos: "Berrikusi gabe geratzen dira ",
  activoEnCarta: "Aktiboa kartan",
  activoEnTPV: "Aktiboa TPV-n",
  relacionarProducto: "Produktua kartan eta TPV-n erlazionatu",
  editarProductoCarta: "Editatu produktua kartan",
  editarProductoTpv: "Editatu produktua TPV-n",
  editarMateriaPrimaCarta: "Editatu lehengai kartan",
  editarMateriaPrimaTpv: "Editatu lehengai TPV-n",
  sinErroresProductos: "Ez da aurkitu potentzialeko errore produkturik kartan",
  sinErroresMateriasPrimas:
    "Ez da aurkitu potentzialeko errore lehengairik kartan",

  // Sinqro refactor
  seleccionePrecioAgenciaSinqro: "Sincronizatu nahi duzun agentziaren prezioa",
  iniciandoImportacion: "Inportazioa hasten",
  limpiandoSinqro: "Sinqro erregistroak ezabatzen",
  obteniendoCategorias: "Kategoria lortzen",
  obteniendoProductos: "Produktua lortzen",
  obteniendoSubproductos: "Azpiproductuak lortzen",
  sincronizandoConSinqro: "Sinqrorekin sinkronizatzen",
  finalizandoSincro: "Sinkronizazioa amaitzen",
  errorSincronizacion: "Errorea Sinqrorekin sinkronizatzean",
  estamosTrabajandoEnEllo: "Lan egiten ari gara, itxaron mesedez...",
  creandoCategoriasSinqro: "Kategoria sortzen Sinqron",
  errorSincronizacionPruebeOtraVez:
    "Errorea Sinqrorekin sinkronizatzean. Mesedez, saiatu berriro.",
  losentimos: "Barkatu!",
  estamosPreparandoTuCarta: "Zure karta prestatzen ari gara",
  borrandoCartasObsoletas: "Karta zaharrak ezabatzen",
  creandoCarta: "Karta sortzen Sinqron",
  ultimoPasoCasiTerminado: "Azken urratsa, amaitzeko bidean gaude",

  exportarPdfSinDesglose: "PDF gisa esportatu (Desglose gabe)",
  exportarPdfConDesglose: "PDF gisa esportatu (Desglosatuta)",
  exportarExcelSinDesglose: "Excel gisa esportatu (Desglose gabe)",
  exportarExcelConDesglose: "Excel gisa esportatu (Desglosatuta)",

  // 14/07/2025
  replicarPLUs: "PLU-ak erreplikatu",
  pluReplicadosExitosamente: "PLU-ak ongi erreplikatu dira",
  replicarPLUPRod: "TPV-tan produktuen PLU-ak erreplikatu",
  replicarPLUSubPRod: "TPV-tan lehengai PLU-ak erreplikatu",
  replicarPLUsaBusinesses: "Negozioetan produktuen PLU-ak erreplikatu",
  replicarPLUaBusinesses: "Negozioetan lehengai PLU-ak erreplikatu",
  noSeActualizoNingunProducto: "Ez da produktu bakar bat ere eguneratu",
  productosActualizadosCorrectamente: "Produktua ongi eguneratu da",

  importarExcelTarjetas: "Excel fitxak inportatu",
  importarTarjetas: "Fitxak inportatu",
  editarTarjeta: "Editatu fitxa",
  previewTarjetasData: "Fitxen aurrebista",

  estaSeguroPLU: "Ziur zaude PLU erreplikatu nahi duzula?",
  conEstaAcciónPLU:
    "Ekintza honekin, PLU-a hautatutako negozio guztietan erreplikatuko da.",

  porDiaNatural: "egun natural bakoitzeko",
  actualizados: "Eguneratuak",
  conErrores: "Erroreak dituztenak",
  estasSeguro: "Ziur zaude?",
  conEstaAccionPLUTpvs:
    "Ekintza honekin, PLU-a negozio honetako TPV guztietan erreplikatuko da",
  advertenciaPLUTexto1Prod:
    "Negozioen arteko PLU erreplikazio prozesu honek produktuaren izena erabiltzen du funtzionatzeko.",
  advertenciaPLUTexto2Prod:
    "Produktuen izen errepikatuak badituzu, prozesu hau ezin izango da haientzat burutu.",
  advertenciaSubPLUTexto1:
    "Lehengai PLU-ak erreplikatzeko prozesu honek lehengaiaren izena erabiltzen du funtzionatzeko.",
  advertenciaSubPLUTexto2:
    "Lehengai izen errepikatuak badituzu, prozesu hau ezin izango da haientzat burutu.",

  advertenciaPLUsDuplicadosProductos:
    "⚠️ Produktuen izen errepikatuak dituzten PLU-ak ezin izan dira erreplikatu, izena erreferentzia gisa erabiltzen baita prozesu honetan.",
  advertenciaPLUsDuplicadosSubproductos:
    "⚠️ Lehengaien izen errepikatuak dituzten PLU-ak ezin izan dira erreplikatu, izena erreferentzia gisa erabiltzen baita prozesu honetan.",

  productosActualizadosResumen: "Eguneratutako Produktuak",
  productosNoEncontradosResumen: "Ez aurkitutako Produktuak",
  productosSinCambiosResumen: "Aldaketarik gabeko Produktuak",

  subproductosActualizadosResumen: "Eguneratutako Lehengaienak",
  subproductosNoEncontradosResumen: "Ez aurkitutako Lehengaienak",
  subproductosSinCambiosResumen: "Aldaketarik gabeko Lehengaienak",

  seRepite: "errepikatzen da",

  ordenarProductosAlfabeticamenteDesc:
    "Produktuak alfabetoaren arabera ordenatu, goranzko moduan.",
  ordenarMateriasPrimasAlfabeticamenteDesc:
    "Lehengaienak alfabetoaren arabera ordenatu, goranzko moduan.",
  configurarFechaCaducidadFacturas: "FACTURA QR-en iraungitze data",
  configurarFechaCaducidadFacturasDesc:
    "Ezarri bezeroek FACTURA QR-ak ordaintzeko izango duten denbora iraungitu aurretik.",
  configurarLogoNegocioDesc: "Ezarri negozioaren logoa fakturetan erakusteko.",
  cambiarPreciosAProductosDesc: "Produktuen prezioak aldatu masiboki.",
  calcularCostoProductos: "Produktuen kostua",
  calcularCostoProductosDesc: "Egin produktuen kostua TPV bakoitzeko.",
  gestionAvanzadaHerramientas: "Tresna kudeaketa aurreratua",
  gestionAvanzadaHerramientasDesc:
    "Inprimagailuak, kategoriak eta sukaldaritzako monitorra konfigurazio aurreratua zure negoziorako.",
  hora: "Ordua",
  cancelaciones: "Ezeztapenak",
  totalNeto: "Guztira Garbi",
  identificadorPostit: "Post-it identifikatzailea",

  // VentasNegocios internationalization
  totalMesasPostit: "Post-it Mahai Guztira",
  noHayVentasDisponibles: "Ez dago salgai hautatutako planoan",
  intentaSeleccionarOtroPlano:
    "Saiatu beste plano bat aukeratzen edo egiaztatu hautatutako epearen datuak",
  loSentimos: "Barkatu",
  esteNegocioNoCuentaConModulo: "Negozio honek ez du modulu hau aktibatuta",
  mesasDePostit: "Post-it Mahaiak",
  totalConsolidado: "Guztira Kontsolidatua",
  totalMesa: "Mahai Guztira",
  pagosaldo: "Saldo ordaindu",
  desgloseVentasPorMesasHoras: "Salmenten Desglosea Mahai eta Orduen arabera",

  configurar: "Konfiguratu",
  configurarLogoFacturas: "Fakturen logoa",
  configurarFechaDeVencimientoDeFacturas:
    "Fakturen iraungitze data konfiguratu",
  introduzcaElNumeroDeDiasEnElQueVenceranLasFacturas:
    "Sartu egun kopurua fakturak iraungitzeko.",
  datoInformativo:
    "Data honek ez du sistemaren mailan eragingo, bezeroarentzako informazio hutsa da.",
  calcularCostoDeTodosLosProductos: "Egin produktuen kostua",

  // Business Central
  summary: "Produktuen baja laburpena",
  productDowngrades: "Produktuen baja aurkitu da",
  subproductDowngrades: "Lehengaien baja aurkitu da",
  totalDowngrades: "Baja Guztira",
  totalAffectedRecipes: "Eragin dituzten errezeta guztiak",
  downgradedProducts: "Baja eman diren produktuak",
  downgradedSubproducts: "Baja eman diren lehengaienak",
  noRecipesAffected: "Ez dago errezeta eragindurik",

  actualizar: "Eguneratu",
  crear: "Sortu",
  terminar: "Amaitu",

  departamentosSeleccionados: "Hautatutako sailak",

  seleccionarProducto: "Produktua\nhautatu",
  seleccionarDepartamentos: "Sailak\nhautatu",
  completarCampos: "Eremuak\nbetetu",
  asignarMateriasPrimas: "Lehengaienak",
  seleccionaMateriasPrimasBusinessCentralAlertInfo:
    "Hau da Numier-en sortu edo eguneratu gabe dauden Business Central-eko lehengai salgarriak zerrenda. Hautatu zerrendako lehengaia jarraitzeko. <strong>{PRODUCT_LIST_LENGTH} lehengai dituzu zain.</strong>",
  seleccionaProductosBusinessCentralAlertInfo:
    "Hau da Business Central-en produktu zerrenda, Numier-en sortu edo eguneratzeko zain daudenak. Jarraitzeko, hautatu zerrendako produktua. <strong>{PRODUCT_LIST_LENGTH} produkturen zain daude.</strong>",
  seleccionaDepartamentosBusinessCentralAlertInfo:
    "<strong>Non egon behar da {PRODUCT_NAME} produktua eskuragarri?</strong> Hautatu produktua eskuragarri egon dadin nahi dituzun sailak {PRODUCT_NAME}.",
  completarCamposProductosBusinessCentralAlertInfo:
    "Ondoren, <strong>betetu {PRODUCT_NAME}-ren eremuak eta tarifak</strong>.",
  asignarMateriasPrimasProductosBusinessCentralAlertInfo:
    "<strong>{PRODUCT_NAME}</strong> produktuari dagozkion lehengai hauek detektatu dira. Prozesua amaitzean automatikoki produktuan gehituko dira.",
  estasMateriasPrimasSeAnadiranAlProducto:
    "Lehengai hauek automatikoki gehituko dira produktuan prozesua amaitzean.",
  completarTarifasBusinessCentralAlertInfo:
    "<strong>{PRODUCT_NAME}-k sailaren arabera kategoriak, BEZa eta prezio desberdinak izan ditzake</strong>. Adibidez, 2,50€ Tarifa 1-eko prezioa 1. sailean eta 3,00€ 2. sailean. 'Balioak erreplikatu' kutxa markatuta eta balio bat sartzen baduzu, zutabe osoa beteko da balio horrekin.",
  CategoriayTarifasPorDepartamento:
    "Sail bakoitzeko Kategoria, BEZa eta Tarifak",
  replicarValoresTarifasEnTodaLaColumnaCheckbox:
    "Tarifen balioak zutabe osoan erreplikatu",
  sincronizado: "sinkronizatuta",
  swalSalirFromProductosBusinessCentralTitle: "Jarraitu aurretik...",
  swalSalirFromProductosBusinessCentralText:
    "Orain irten ezkero, zure aurrerapena galtzen duzu.",
  swalSalirFromProductosBusinessCentralButtonConfirm: "Bai, irten",
  swalCamposObligatoriosFromProductosBusinessCentralText:
    "Izarrez (*) markatutako eremu guztiak bete behar dituzu",
  swalNombreProductoObligatorioFromProductosBusinessCentralText:
    "Produktua izena",
  swalColorObligatorioFromProductosBusinessCentralText: "Botoiaren kolorea",
  swalCategoriaObligatorioFromProductosBusinessCentralText:
    "Sail bakoitzeko Kategoria",
  swalTipoIvaObligatorioFromProductosBusinessCentralText:
    "Sail bakoitzeko BEZa",
  noPuedenCoincidirLosValoresDeLosCodigosDeBarrasEntreDiferentesFormatos:
    "Barra-kodeen balioak ezin dira bat etorri formatu desberdinen artean.",
  yaExisteUnProductoConEseCodigoDeBarras:
    "Produktu bat jadanik kode-barra hau du.",

  swalProductoSincronizadoTitle: "Produktua sinkronizatuta!",
  swalProductoSincronizadoTextNPendientes:
    "Produktuen sinkronizazioa jarraitu nahi duzu edo momentuz bukatu nahi duzu?",
  swalProductoSincronizadoText0Pendientes:
    "Produktuen sinkronizazioa guztiz burutu da.",
  swalProductoSincronizadoButtonSeguir: "Sinkronizazioa jarraitu",
  swalProductoSincronizadoButtonTerminar: "Bukatu",
  swalProductoActualizadoTitle: "Produktua eguneratuta!",
  swalProductoActualizadoText0Pendientes:
    "Produktuen eguneraketa guztiz burutu da.",
  swalSuplementoTarifa1ObligatoriaFromProductosBusinessCentralText:
    'SUPLEMENTUAREN prezioa (Tarifa 1) falta da "{tpv}" departamentuan/TPVn.',

  modalUnidadesMedidaTitle: "ℹ️ GARRANTZITSUA",
  modalUnidadesMedidaTextIntro:
    "{PRODUCT_NAME}-k {UD_COUNT} neurri-unitate ditu Business Central-en ({UD_LIST}). 2 aukera daude:",
  modalUnidadesMedidaOpcionMultiples:
    "🔹 {UD_COUNT} produktuak sortu → Egokia lehengaia desberdinak badira (adib: Agua BOT500ML eta Agua BOT1L lehengai desberdinak dira).",
  modalUnidadesMedidaOpcionUnico:
    "🔹 1 produktua sortu eta 4 tarifara arte erabili → Hobeto da lehengai bera kantitate desberdinekin badago (adib: Ensaladillaren 'Tapa' eta 'Ración' tarifak erabiltzea).",
  modalUnidadesMedidaRecomendacion:
    "Gomendioa: Lehengaia bera bada (adib: Ensaladilla kantitate desberdinetan), 1 produktua erabili. Lehengaia desberdinak badira, sortu {UD_COUNT} produktuak.",
  modalUnidadesMedidaButtonMultiples: "{UD_COUNT} produktuak sortu",
  modalUnidadesMedidaButtonUnico: "1 produktua sortu",

  modalConfirmarDatosTitle: "ℹ️ EGINBERRI EZAZU PRODUKTUAREN DATUAK",
  modalConfirmarDatosIntro:
    "{PRODUCT_NAME} jada sinkronizatuta eta gordeta zegoen Numier-en, baina Business Central-en aldatu da.",
  modalConfirmarDatosExplicacion:
    "Ondoren, formularioan kargatuko ditugu produktu honen Numier-en dauden datuak, egiaztatu eta jarraitzeko sakatu ahal izateko.",
  continuar: "Jarraitu",

  cargandoListaProductos: "Produktuen zerrenda kargatzen...",
  seHaDetectadoCambioUdmEsNecesarioActualizarPorFormato: "Neurketa-unitateetan aldaketa bat atzeman da. Beharrezkoa da formatuaren araberako prezioak eguneratzea neurketa-unitate berri honetarako.",
  productoYaCreadoMateriasPrimasIguales: "Produktua dagoeneko existitzen da Numier-en, beraz, lehengaiak berdinak izango dira.",
  seHanDetectadoMasUdmQueSoportaNumierSeCrearanProductosIndividuales: "Business Central-en Numierrek onartzen dituen baino neurri-unitate gehiago antzeman dira. Neurri-unitate bakoitzerako produktu indibidualak sortuko dira.",
  error: "Errorea",
  serverError: "Zerbitzariarekin komunikatzean arazo bat egon da",
  errorRecetasBC: "Ezin izan dira errezetak lortu Business Central-etik.",
  erroresAddTipoMateriaPrima: "Lehengai bakoitzaren mota aukeratu behar duzu.",
  erroresAddTodasMateriasPrimas: "Lehengai guztiak gehitu behar dituzu",
  redirigidoIntegracionesBC:
    "Aukeratutako enpresa zuzena dela egiaztatzeko hasierako puntura bideratu zaitugu.",
  redirigidoFaltanDatos:
    "Datu beharrezko batzuk falta zirelako bideratu zaitugu.",
  unknownProduct: "Produktua ezezaguna",

  // BussinessCentral MateriasPrimas
  nombreMateriaPrima: "Lehengaien izena",
  descripcion: "Deskribapena",
  codigoDeBarra: "Barra kodea",
  seleccionaCategoria: "Kategori bat hautatu",
  seleccionaTipo: "Mota bat hautatu",
  precioCompraSinIva: "Erosketa prezioa (BEZik gabe)",
  baja: "Baja",
  escandallo: "Eskandallo",
  quieresSeguirSincronizando: "Jarraitu nahi duzu sinkronizatzen?",
  seguirSincronizando: "Jarraitu sinkronizatzen",
  seleccionar: "Hautatu",
  materiaPrimaGuardada: "Lehengaia gorde da!",
  seleccionarMateriaPrima: "Hautatu\nlehengaia",
  completarCamposMateriaPrima: "Beteta utzi\ndatuak eta\nlehengaien asignazioa",
  queQuieresHacerAhora: "Jarraitu nahi duzu lehengaiak sinkronizatzen?",
  seguirEditando: "Jarraitu editatzen",
  materiaPrimaSincronizadaCorrectamente: "Lehengaia sinkronizatuta dago",
  estaMateriaPrimaTieneMateriasPrimasRelacionadasAlertInfo:
    "<strong>{MATERIA_PRIMA_NAME}</strong> lehengaia beste lehengaiekin lotuta dago. Gehitu sinkronizazioa osatzeko.",
  finalizar: "Bukatu",
  seleccionaLosDepartamentos: "Hautatu sailak",
  noHayEtiquetasTPV: "Ez dago etiketarik TPV honetarako",
  aniadir: "Gehitu",
  aniadirTodas: "Guztiak gehitu",
  listo: "prest",
  errorDesconocido: "Errore ezezaguna",
  nombreMateriaPrimaObligatorio: "Lehengaien izena derrigorrezkoa da.",
  submateriasPrimasObligatorio: "Sub-lehengaia guztiak gehitu behar dituzu.",

  actualizacionMateriaPrima: "Lehengaien eguneraketa",
  mensajeCambioMateriaPrimaInfo:
    "Aldaketak detektatu dira Business Central-en lehengaia honetan.",
  antesContinuarMateriaPrimaInfo:
    "Jarraitu aurretik, egiaztatu lehengaia zein departamentutan egon behar duen aldaketak badaude.",
  accionNecesariaMateriaPrimaInfo:
    "Ekintza hau beharrezkoa da informazioa eguneratuta mantentzeko.",
  entendido: "Ulertu dut",
  noVolverAMostrarEsteAviso: "Ez erakutsi berriro abisu hau",
  cerrarYNoVolverAMostrar: "Itxi eta ez erakutsi berriro",
  preferenciasGuardadas: "Hobespenak behar bezala gorde dira",
  errorAlGuardarPreferencias: "Errorea hobespenak gordetzean",
  seleccioneCategoria: "Kategori bat hautatu...",

  // Formulario combinado de productos
  precioRequerido: "Beharrezko prezioa",
  introduzcaPrecio: "Sartu osagarriaren prezioa",
  errorValidandoCodigosBarras: "Errorea kode-barren validazioan",
  asignaPreciosMateriasPrimas: "Lehengaiei prezioak esleitzen dizkie",
  rateNameRequired: "Derramaren izena adieraztea derrigorrezkoa da zk.: ",
  categoryRequiredForDept: "Sailarentzat kategoria bat hautatzea derrigorrezkoa da: ",
  validationError: "Eremuen balidazio errorea",
  pleaseFillRequiredFields: "Mesedez, bete derrigorrezko eremu guztiak.",
  configuracionPorDepartamento: "Sailkaaketa departamentuaren arabera",
  productoNormal: "Normala",
  productoCON: "KIN",
  productoSUPL: "OSAG",
  esProductoCON: "KIN da",
  esProductoSUPL: "OSAG da",
  categoriaNormal: "Normala",
  categoriaCON: "KIN",
  categoriaSUPL: "OSAG",
  suplemento: "OSAGARRI",
  mensajeProductoCON:
    "You are creating a WITH product. 2 products will be generated: one normal and one WITH.",
  mensajeProductoSUPL:
    "You are creating a SUPPL product. 2 products will be generated: one normal and one SUPPL.",
  mensajeProductosCONySUPL:
    "You are creating both WITH and SUPPL products. 3 products will be generated: one normal, one WITH and one SUPPL.",
  completeCamposObligatorios: "Please fill in all required fields.",
  completeNombreProductoCON: "Please enter the name for the WITH product.",
  completeNombreProductoSUPL: "Please enter the name for the SUPPL product.",
  productosGuardadosCorrectamente: "Products have been saved successfully.",
  errorAlGuardarProductos: "An error occurred while saving the products.",

  dataNegocioVisualizar: "Departamentuak",
  formaPagoFiltrado: "Ordainketa moduaren arabera iragazi",
  fechaExportacionDisponible: "Detektatutako esportazio data",
  todasLasFormasPago: "Ordainketa modu guztiak",
  seleccioneSubtipoFormaPago:
    "Mesedez, hautatu ordainketa mota zehatz bat (adib: Visa, Mastercard edo txeke mota).",
  noCambiosFormaPago: "Ez dira aldaketarik egin ordainketa moduan",
  finalizarProcesoActualizar: "Lehengaien eguneraketa prozesua amaitu",
  actualizarFinalizarText:
    "Prozesua osatzeko eta lehengaiak eguneratzeko, sakatu beheko 'Eguneratu eta amaitu' botoia.",
  cambiosDepartamentosMateriaPrimaInfo:
    "Lehengaiaren departamentutan aldaketarik egon bada, aldaketak automatikoki aplikatuko dira eguneratzean.",
  actualizarFinalizar: "Eguneratu eta amaitu",
  verDetallesFormaPago: "Ordainketa moduen xehetasunak ikusi",
  detallesFormaPago: "Ordainketa moduen xehetasunak",
  formaDePago: "Ordainketa modu",
  medioDePago: "Ordainketa bide",
  medioPagoFiltrado: "Ordainketa bideen arabera iragazi",
  advertenciaExportacionVentas: "Salmenten esportazioari buruzko ohartarazpena",
  seExportaranTodosLosDepartamentos:
    "DEPARTAMENTU GUZTIETAKO salmentak esportatuko dira",
  advertenciaExportacionTodosLosDepartamentos:
    "Jarraituz gero, departamentu guztietako salmentak esportatuko dira, bakoitzaren ordainketa moduarekin, ez soilik unean dagoen departamentuarekin.",
  noHayVueltaAtras: "Esportazioa eginda, ezin izango da atzera egin.",
  reviseYEditeFormasPagoAntes:
    "Berrikusi eta editatu ordainketa moduak aurrera egin aurretik.",
  eleccionModoExportacion: "Esportazio moduak salmentak loteetan edo batera bidaltzea soilik zehazten du. Kasu guztietan, salmenta guztiak eta TPV guztietakoak bidaliko dira.",
  estaSeguroDeExportar: "Ziur zaude esportazioa jarraitu nahi duzula?",
  todosLosMediosPago: "Ordainketa modu guztiak",
  tpv: "TPV",
  department: "Departamentua",
  department: "Saila",
  productoEspecialDetectado: "Produktu berezia detektatu da",
  productoEspecialDetectadoMensaje: "Produktu berezi bat detektatu da.",
  seCrearanTresProductos: "{cantidad} produktu sortuko dira Numier-en: normal bat, BATKIN eta OSAGARRI bat.",
  seCrearanDosProductosCon: "{cantidad} produktu sortuko dira Numier-en: normal bat eta BATKIN bat.",
  seCrearanDosProductosSuplemento: "{cantidad} produktu sortuko dira Numier-en: normal bat eta OSAGARRI bat.",
  relleneFormularios: "Mesedez, bete beheko dagokion formularioak.",
  categoriaEnlazada: "Kategoria lotuta",
  dadoDeBaja: "Bajan emanda",
  refrescar: "Freskatu",
  errorAlRefrescar: "Ezin izan dira datuak eguneratu. Saiatu berriro.",
  sinPermisoExportacionBC: "Ez duzu Business Central-erako salmenten esportaziora sartzeko baimenik. Hitz egin zure administratzailearekin.",
  productoDeBajaTitulo: "Produktua bajan emanda",
  productoDeBajaTexto: "Produktu hau bajan emanda dago eta ezin da menuko plater gisa gehitu. Aktibatu Business Central-en eta sinkronizatu berriro: Numierrek hurrengo sinkronizazioan berraktibatuko du.",
  categoriaFijadaPorTipo: "{TIPO} motak finkatzen du",
  categoriaFijadaPorTipoAviso: "Kategoria ezin da hautatu: {TIPO} bat beti sortzen da jatorrizko negozioan duen kategorian. Helburuan existitzen ez bada, sortu egiten da.",
  sinNegociosParaReplicar: "Ez dago produktu hau replikatzeko beste negoziorik erabilgarri.",
  negocioSinCategorias: "Kategoriarik sortu gabe",
  resultadoReplicacion: "Replikazioaren emaitza",
  replicados: "Replikatuak",
  replicaFamiliaAviso: "Produktu hau familia batekoa da. Hauek replikatuko dira:",
  replicaTipoDetectado: "Antzemandako produktu mota:",
  productosPorNegocio: "produktu negozioko",
  faltaCategoriaEnNegocios: "Hautatu kategoria bat negozio hauetan:",
  seleccionaAlMenosUnNegocio: "Hautatu gutxienez negozio bat.",
  seleccionaPreviamenteCategoria: "Mesedez, hautatu kategoria bat lehenago.",

  // Producto solo con/suplemento
  crearProductoSinNormal: "Sortu produktu normala inaktibo gisa",
  crearProductoSinNormalExplicacion: "Aukera hau aktibatzen baduzu, produktu normala sortuko da baina 'baja' (inaktibo) egoerarekin. Hau erabilgarria da produktuak BATKIN edo OSAGARI gisa bakarrik saltzeko zentzuia duenean, berezko produktu bezala ez baita saltuko. TPVan bakarrik ikusgai izango da eskuz aktibatzen baduzu.",
  crearProductoSinNormalDetalle: "Produktu normala beti sortuko da, baina aukera hau markatuta badago desaktibatuta agertuko da. WITH eta SUPLEMENTO produktuak berehala erabiltzeko aktibo egongo dira.",
  crearProductoSinNormalImportante: "GARRANTZITSUA: Kutxa hau markatu aurretik kategoria bat hautatu behar duzu, datuen integritatea mantentzeko beharrezkoa baita produktua inaktiboa egon arren.",
  productoNormalOculto: "Produktu normala ezkutatua",
  productoNormalOcultoExplicacion: "Inprimaki hau ezkutatua dago produktu normala inaktibo gisa sortuko delako",
  activarProducto: "Aktibatu produktua",

  // Business Central - Exportación de ventas
  exportacionVentasBC: "Salmentak esportatu",
  noHayDiasParaExportar: "Ez da esportatzeko egunik",
  dailyExportCardTitle: "Salmenten esportazio eguna",
  dailyExportCardSubtitle:
    "Salmentak egiaztatu eta Business Central-era esportatu",
  todoExportadoCorrectamente:
    "Salmenta guztiak esportatu dira behar bezala edo ez dago salmentarik departamentu honetan.",
  hayVentasPendientesExportar: "Esportatzeko salmenta zain daude.",
  debesExportarPrimeroDiasAnteriores:
    "Lehenengo aurreko egunak esportatu behar dituzu korrelazioa mantentzeko.",
  fechaExportacion: "Esportazio data",
  formapago: "Ordainketa modu",
  noPuedeCambiarFechaSinExportarPrimero:
    "Ez da data berririk esportatu aurretik egon behar.",
  trabajador: "Langilea",
  exportData: "Salmentak esportatu",
  exportacionExitosa: "Esportazioa behar bezala burutu da",
  errorExportarDatos: "Errorea datuak esportatzean",
  falloExportarDatos: "Errorea datuak esportatzean",
  exportacionRealizada: "Esportazioa burutu da",
  exportacionRealizadaParcial: "Esportazioa burutu da parcialmente",
  exportacionExitosaConErrores: "Esportazioa behar bezala burutu da con algunos errores",
  editarFormaPago: "Ordainketa modua editatu",
  noExistenDatosNoPudieronCargar: "Ez da daturik edo ezin izan dira kargatu",
  mensajeEfectivoSeleccionado:
    "Efectivo hautatu da ordainketa modua gisa. Ez da beharrezkoa xehetasun gehiago ematea.",
  guardarFormaPago: "Ordainketa modua gorde",
  tipoFormaPago: "Ordainketa mota",
  seleccioneUnTipo: "Mota bat hautatu",
  formaPagoTarjeta: "Txartel bidezko ordainketa",
  formaPagoCheque: "Txeke bidezko ordainketa",
  updatePagoCorrecto: "Ordainketa modua behar bezala eguneratu da",
  noSePudoActualizarFormaPago: "Ez da ordainketa modua eguneratu",
  errorAlGuardarFormaPago: "Errorea ordainketa modua gordetzean",
  noHayVentasConEstaFormaPago: "Ez da salmentarik ordainketa modua honekin",
  formaPagoNoEncontrada:
    "Ordainketa modua ez da detektatu departamentu honetan",
  totalCash: "Efectibo guztira",
  totalCard: "Txartel guztira",
  totalCheque: "Txeke guztira",
  totalPagosaldo: "Ordaindu gabeko guztira",
  totalAvanzado: "Aurreratua guztira",
  avanzadoEfectivo: "Efectibo aurreratua",
  avanzadoTarjeta: "Txartel aurreratua",
  avanzadoCheque: "Txeke aurreratua",
  avanzadoPagosaldo: "Ordaindu gabeko aurreratua",
  avanzadoOtros: "Beste aurreratua",
  cashPaymentMethod: "Efectibo ordainketa modua",
  cardPaymentMethod: "Txartel ordainketa modua",
  chequePaymentMethod: "Txeke ordainketa modua",
  importeTotal: "Guztizko zenbatekoa",
  sinDatos: "DATU GABE",

  // Integración Business Central > Business Central
  businessCentral: "Business Central",
  sincronizacionBusinessCentralSubtitle:
    "Produktuen, departamentu eta gehiago sinkronizazioa denbora errealean",
  sincronizaMateriasPrimasBusinessCentralSubtitle:
    "<strong>{MATERIAS_PRIMAS_LENGTH}</strong> lehengai eguneratzeko zain daude",
  noHayParaActualizar: "Ez dago ezer eguneratzeko edo sinkronizatzeko zain",
  obteniendoDatos: "Datuak eskuratzen...",
  relacionesProcesadas: "Relazioak prozesatuta",
  exportacionDeshabilitada: "Esportazioa desgaituta",
  sincronizaProductosBusinessCentralSubtitle:
    "<strong>{NUMERO_PRODUCTOS_PENDIENTES}</strong> produktu sinkronizatzeko zain daude",
  sincronizaFormasDePagoBusinessCentralSubtitle:
    "<strong>{NUMERO_FORMAS_PAGO_PENDIENTES}</strong> ordainketa modu sinkronizatzeko zain daude",
  productoFormCompleto: {
    info: "Produktua editatzen: {productName}",
  },
  completaProductosBussinessCentralSubtitle:
    "Lehengaien sinkronizazioa lehenik osatu, eta gero produktuarekin jarraitu",

  seleccionaMateriaPrimaBusinessCentralAlertInfo:
    "Hau da Business Central-en lehengaien zerrenda, Numier-en sortu edo eguneratzeko zain daudenak. Hautatu lehengaia jarraitzeko. <strong>{PRODUCT_LIST_LENGTH} lehengaiekin zain.</strong>",
  seleccionaDepartamentosMateriasPrimasBusinessCentralAlertInfo:
    "<strong>{PRODUCT_NAME} lehengaia non egon behar den?</strong> Hautatu departamentuak non egon behar duen {PRODUCT_NAME}.",
  completarCamposMateriasPrimasBusinessCentralAlertInfo:
    "Bukatzeko, bete {PRODUCT_NAME}-ren datuak.",
  materiaPrimaDisabledByPendingsChildrenTooltip:
    "Lehengaia hau errezeta bat da eta oraindik sinkronizatu gabeko lehengaiekin dago.",

  swalMateriaPrimaSincronizadaTitle: "Lehengaia sinkronizatuta!",
  swalMateriaPrimaSincronizadaTextNPendientes:
    "Jarraitu nahi duzu lehengaiekin sinkronizatzen edo bukatu nahi duzu une honetan?",
  swalMateriaPrimaSincronizadaText0Pendientes:
    "Lehengaia guztiak sinkronizatuta daude.",
  swalMateriaPrimaSincronizadaButtonSeguir: "Jarraitu sinkronizatzen",
  swalMateriaPrimaActualizadaTitle: "Lehengaia eguneratuta!",
  swalMateriaPrimaActualizadaText0Pendientes:
    "Lehengaia guztiak eguneratuta daude.",

  // Integración Business Central > Empty entidades pendientes
  esteNegocioNoTieneProductosParaSincronizar: "Produktua guztiz sinkronizatuta",

  // Integración Business Central > Formas de pago
  formasDePagoBC: "Ordainketa moduak",
  swalTipoObligatorioFormasDePago:
    "Lehenik eta behin, hautatu ordainketa modu bakoitzarentzat mota bat.",
  formasDePagoBusinessCentralAlertInfo:
    "Lotu Business Central-eko ordainketa moduak Numier-en ordainketa modu (Efectivo, Txartel edo Txeke)ekin. <strong>Bakarrik hautatu daiteke Efectivo mota bakarra, gainerakoak Txartel eta Txeke bezala.</strong>",
  noHayFormasDePagoPorConfigurar:
    "Ez dago konfiguratzeko ordainketa modurik zain.",
  formasDePagoConfiguradasCorrectamente:
    "Ordainketa modu guztiak behar bezala ezarri dira.",
  formaPagoGuardada: "Ordainketa modu guztiak gordeta!",
  todasFormasPagoConfiguradas: "Ordainketa modu guztiak konfiguratu dira",
  formasPagoDarDeBajaMensaje:
    "Hurrengo ordainketa modu hauek baja eman behar dira Numier-en, Business Central sisteman ez daudelako eskuragarri",
  pulsaDarDeBaja: "Baja emateko sakatu berresteko",
  darDeBaja: "Baja eman",
  dandoDeBajaFormasPago: "Ordainketa moduak baja ematen...",
  formasPagoDadasDeBaja: "Ordainketa moduak behar bezala baja eman dira.",
  errorDarDeBajaFormasPago: "Errorea ordainketa moduak baja ematen.",
  errorServidorDarDeBaja:
    "Errorea zerbitzarira komunikatzean baja ematerakoan.",

  // Verifactu Dashboard
  verifactu: "VERI*FACTU",
  verifactu2: "Verifactu",
  declaracionesResponsables: "Erantzukizuneko adierazpenak",
  conectaNumierConHacienda: "Konektatu Numier Ogasunarekin klik gutxitan.",
  solicitar: "Eskatu",
  esperandoRespuestaNumier: "Numierren erantzunaren zain",
  seleccionarCertificado: "Ziurtagiria aukeratu.",
  enviarCertificado: "Ziurtagiria bidali.",
  subeTuCertificadoParaConectarConHacienda: "Igo zure ziurtagiria zure negozioa Ogasunarekin konektatzeko.",
  seleccionarArchivo: "Fitxategia aukeratu.",
  ustedYaHaGuardadoElCertificadoDigital: "Ziurtagiri digitala behar bezala gorde duzu negozio honetan.",

  paraComenzarVerifactuSeleccionaNegocio: "VERI*FACTU-rekin hasteko, mesedez <strong>aukeratu negozio bat</strong> beheko zerrenda goitibeherakoan.",
  bienvenidoA: "Ongi etorri",
  verifactuDescripcion: "<strong>Verifactu</strong> Estatuko Zerga Agentziaren (AEAT) sistema da, fakturak automatikoki egiaztatzeko eta haien benetakotasuna bermatzeko.",
  informacionSobreVerifactu: "Informazioa VERI*FACTU-ri buruz",

  importanteEmpresasSII: "Garrantzitsua: SIIra atxikitako enpresak",
  siTuEmpresaEstaAdscritaSII: "Zure enpresa Informazioaren Hornidura Berehalako Sistemara (SII) atxikita badago, ez duzu VERI*FACTU erabili behar.",
  masInformacionAqui: "Informazio gehiago hemen",

  automatizacionInteligente: "Automatizazio adimenduna",
  automatizacionInteligenteDesc: "Eskuzko esku-hartzerik gabeko faktura-egiaztapena. Sistemak dokumentu bakoitza berehala prozesatzen du.",
  automatizacionInteligenteDetalle: "Astean 8 ordu arteko lana aurreztu dezakezu",
  automatizacionInteligenteStat: "%100 Automatikoa",

  cumplimientoNormativo: "Arau-betetze osoa",
  cumplimientoNormativoDesc: "Zerga-arau guztiak betetzen ditu. Lege-aldaketekin automatikoki eguneratzen da.",
  cumplimientoNormativoDetalle: "AEATren araudi guztiekin bateragarria",
  cumplimientoNormativoStat: "AEAT araudia",

  controlDeCalidad: "Kalitatearen kontrola",
  controlDeCalidadDesc: "Errore humanoak ezabatu eta iruzurrak saihesten ditu datu-balidazio aurreratuaren bidez.",
  controlDeCalidadDetalle: "Inkoherentzia eta anomalia automatikoen detekzioa",
  controlDeCalidadStat: "-95% erroreak",

  seguridadAvanzada: "Segurtasun aurreratua",
  seguridadAvanzadaDesc: "Transakzio guztietan babes maximoa banku-mailako zifratzearekin.",
  seguridadAvanzadaDetalle: "SSL ziurtagiriak eta bi faktoreko autentifikazioa",
  seguridadAvanzadaStat: "SSL zifratzea",

  configuracionDeVerifactu: "Verifactu konfigurazioa",
  paraComenzarNecesitasCertificado: "VERI*FACTU erabiltzen hasteko, zure <strong>ziurtagiri digitala</strong> igo behar duzu.",
  certificadoPermiteAutenticacion: "Ziurtagiri honek AEATrekin autentifikazio segurua ahalbidetzen du.",
  formatosSoportados: "Onartutako formatuak: <code>.pfx</code>, <code>.p12</code>.",
  aunNoTienesCertificado: "Oraindik ez duzu ziurtagiri digitalik?",
  puedesObtenerCertificadoEn: "Zure ziurtagiria lor dezakezu hemen:",
  fabricaNacionalMonedaTimbre: "Moneta eta Zigiluaren Fabrika Nazionala (FNMT)",
  yaTienesCertificadoListo: "Ziurtagiri digitala prest al duzu?",
  hazClickAbrirSelector: "Egin klik hemen fitxategi-hautatzailea irekitzeko.",
  tengoUnCertificado: "Ziurtagiri bat dut",
  hazClickSeleccionarCertificado: "Egin klik eta aukeratu zure ziurtagiria",
  formatosMaximo: "Formatuak: .pfx, .p12 (gehienez 60KB)",
  subirCertificado: "Ziurtagiria igo",
  debeSeleccionarFechaInicioVerifactu: "VERI*FACTU-rako hasiera-data aukeratu behar duzu jarraitu aurretik.",
  porFavorSeleccionaFechaInicioNuevamente: "Errore bat aurkitu da. Mesedez, hautatu hasiera-data berriro.",
  porFavorSeleccionaCertificadoNuevamente: "Mesedez, hautatu ziurtagiria berriro.",

  certificadoConfiguradoCorrectamente: "Ziurtagiria behar bezala konfiguratu da!",
  certificadoValidadoConfigurado: "Zure ziurtagiri digitala egiaztatu eta konfiguratu da.",
  certificadoValidoHasta: "Ziurtagiria baliozkoa data honetara arte:",
  noSeHaPodidoVerificarFecha: "Ezin izan da ziurtagiriaren iraungitze-data egiaztatu",
  facturasComplianNormativa: "Zure fakturak VERI*FACTU araudia beteko dute.",
  sistemaListoVerificacion: "Sistema prest faktura-egiaztapen automatikorako.",
  comoFuncionaVerifactu: "Nola funtzionatzen du VERI*FACTUk?",

  generacionAutomatica: "Sortze automatikoa",
  generacionAutomaticaDesc: "Fakturak automatikoki sortuko dira VERI*FACTUren formatuarekin eta baldintzekin",

  codigoQRenTickets: "QR kodea txarteletan",
  codigoQRenTicketsDesc: "Kobrantza-txartel bakoitzak QR kode bat izango du AEATren egoitzan faktura egiaztatzeko",

  comprobacionInstantanea: "Egiaztapen berehalakoa",
  comprobacionInstantaneaDesc: "Faktura bakoitzaren egoera QR kodea eskaneatuz egiaztatu daiteke edozein gailutik",

  seguridadGarantizada: "Segurtasun bermatua",
  seguridadGarantizadaDesc: "Transakzio guztiak erregistratu eta sinadura elektroniko aurreratuarekin babestuta daude",

  contrasenaCertificado: "Ziurtagiriaren pasahitza",
  introduceContrasenaDesc: "Sartu zure ziurtagiri digitalaren pasahitza behar bezala prozesatzeko.",
  contrasena: "Pasahitza:",
  introduceContrasenaPlaceholder: "Sartu ziurtagiriaren pasahitza",
  contrasenaRequerida: "Pasahitza beharrezkoa da",
  procesando: "Prozesatzen...",
  continuar: "Jarraitu",
  cancelar: "Utzi",

  exito: "Arrakasta",
  seleccionaArchivoAntes: "Mesedez, aukeratu fitxategi bat bidali aurretik.",
  errorNegocioNoValido: "Errorea: Ez da baliozko negoziorik hautatu.",

  // Textos para negocio exento
  negocioExentoVerifactu: "VERI*FACTUtik salbuetsitako negozioa",
  negocioRegistradoComoExento: "Negozio hau VERI*FACTU-tik salbuetsita dago.",
  noRequiereVerifactu: "Ez du ziurtagiririk ez konfiguraziorik behar.",
  facturacionNormalContinua: "Zure fakturazioa normaltasunez jarraituko du.",
  queSignificaExento: "Zer esan nahi du honek?",
  queSignificaExentoDesc: "Zure negozioak ez du VERI*FACTU bete behar. Baliteke SII sistemari atxikita egotea edo salbuespen fiskalak izatea.",
  siHayAlgunError: "Arazoren bat al dago?",
  siHayAlgunErrorDesc: "Klasifikazio hau okerra dela uste baduzu edo arazoak badituzu, jarri harremanetan gure laguntza-taldearekin.",
  noSePudoObtenerIdUsuario: "Ezin izan da erabiltzailearen IDa lortu.",
  verificandoCertificado: "Ziurtagiria egiaztatzen...",
  certificadoEnviadoCorrectamente: "Ziurtagiria behar bezala bidali da",
  respuestaInesperadaServidor: "Zerbitzariaren ustekabeko erantzuna",

  verifactuError449: "Pasahitz okerra edo fitxategi baliogabea.",
  verifactuError552: "Ustekabeko errorea gertatu da. Saiatu berriro, mesedez.",
  errorAlEnviarCertificado: "Errorea ziurtagiria bidaltzean",
  noSeRecibioRespuestaServidor: "Ez da zerbitzariaren erantzunik jaso",
  errorDeConfiguracion: "Konfigurazio errorea:",
  noSeSeleccionoArchivo: "Ez da fitxategirik hautatu.",
  formatoArchivoNoValido: "Fitxategi-formatu baliogabea. Erabili .pfx edo .p12",
  archivoDemasiadoGrande: "Fitxategia handiegia da. Gehienez: 60KB",

  // Selector de fecha de inicio Verifactu
  cuandoDebeComenzarTuNegocio: "Noiz hasi behar du zure negozioak VERI*FACTU erabiltzen?",
  antesDeConfigurarDebesIndicar: "VERI*FACTU konfiguratu aurretik, hasiera-data adierazi behar duzu zure negozio motaren arabera.",
  consultarInformacionOficial: "Informazio ofiziala kontsultatu",
  paraContribuyentesSociedades: "Sozietateen zergapekoentzat",
  restoNegociosAutonomos: "Gainerako enpresak eta autonomoak. Sistema berrira egokitzeko laguntza gisa.",
  miNegocioAdscritoSII: "Nire negozioa SII sistemari atxikita dago",
  estoyExentoSII: "Salbuetsita nago (SII)",
  seleccionar: "Aukeratu",
  fechaInicioSeleccionada: "Hasiera-data aukeratuta",
  exentoSII: "Salbuetsita (SII)",
  cambiar: "Aldatu",
  negocioExentoVerifactu: "VERI*FACTU-tik salbuetsitako negozioa",
  tuNegocioNoRequiereVerifactu: "Zure negozioak ez du VERI*FACTU behar, SII sisteman sartuta dagoelako.",
  alEstarEnSIINoNecesitas: "SII-n bazaude, ez duzu VERI*FACTU inplementatu behar.",
  confirmacionExencionSII: "SII salbuespenaren berrespena",
  antesDeConfirmar: "Berretsi aurretik ziurtatu:",
  miNegocioEstaAdscritoSistemaInmediato: "Nire negozioa Informazio Berehalako Sistemari (SII) atxikita dago",
  tengoDocumentacionQueLoAcredita: "Horren egiaztagiria dut",
  entiendoQueNoDebereUsarVerifactu: "Ulertzen dut ez dudala VERI*FACTU erabili behar SII-n nagoen bitartean",
  siNoEstasSegurotConsultaAsesor: "Ziur ez bazaude, galdetu zure aholkulari fiskalari",
  confirmarExencion: "Salbuespena baieztatu",
  negocioMarcadoComoExento: "Negozioa VERI*FACTU-tik salbuetsitzat markatu da",
  errorAlMarcarExencion: "Errorea gertatu da salbuespena markatzean. Saiatu berriro, mesedez.",

  certificadoExpiradoAlerta: "<strong>Kontuz:</strong> Negozio honen ziurtagiri digitala <strong>iraungi da</strong>. Berritu behar duzu VERI*FACTU betetzen jarraitzeko.",
  certificadoProximoExpirarAlerta: "<strong>Abisua:</strong> Negozio honen ziurtagiri digitala <strong>laster iraungiko da</strong>. Berritzea gomendatzen da.",
  certificadoExpirado: "Ziurtagiria iraungi da",
  certificadoProximoExpirar: "Ziurtagiria iraungitzear",
  certificadoExpiroEl: "Ziurtagiria honako egunean iraungi zen:",
  certificadoExpiraEl: "Ziurtagiria honako egunean iraungiko da:",
  certificadoYaNoValido: "Ziurtagiri digitala ez da gehiago baliozkoa. Berritu behar da berehala.",
  certificadoProntoVencera: "Ziurtagiri digitala laster iraungiko da. Gomendagarria da lehenbailehen berritzea.",
  sinCertificadoNoEsPosibleVerificar: "Ziurtagiri baliagarririk gabe, ezinezkoa da fakturak automatikoki egiaztatzea.",
  EsperarAExpiracionPuedeProvocarErrores: "Ez berritzeak egiaztapen automatikoan erroreak sor ditzake.",
  pongaseEnContactoConSoporteParaProceder: "Erroreak gertatuz gero, jarri harremanetan laguntza-taldearekin nola jokatu jakiteko.",
  renovarCertificado: "Ziurtagiria berritu",

  // unidades de medida dadas de baja
  unidadesMedidaDadasDeBaja: "Produktuetan baja aurkitu dira",
  bajasDeProductos: "Produktu-bajak",

  // 21/05/2025 - Listado productos por operario
  listadoDeProductosPorOperario: "Produktuen salmenta langilearen arabera",
  listadoProductosOperario: "Langilearen araberako salmenta",

  // 29/10/2025 - Bajas
  bajaEntidades: "Erakundeen baja",
  checkBajaEntidades: "Ikusi eta aplikatu ezabatutako entitateen ezabaketak Business Central-en",

  bajaProductos: "Produktuen baja",
  bajaSubproductos: "Lehengaiaren baja",
  bajaFormasPago: "Ordainketa moduaren baja",
  bajaUdMedida: "Neurketa unitateen baja",
  bajaLineaProd: "Produktuen lerroen baja",

  checkBajaProductos: "Produktuen bajak kontsultatu",
  checkBajaSubproductos: "Lehengaiaren bajak kontsultatu",
  checkBajaFormasPago: "Ordainketa moduaren bajak kontsultatu",
  checkBajaUdMedida: "Neurketa unitateen bajak kontsultatu",
  checkBajaLineaProd: "Produktuen lerroen bajak kontsultatu",

  loadingBajaProductos: "Produktuen bajak kontsultatzen...",
  loadingBajaSubproductos: "Lehengaiaren bajak kontsultatzen...",
  loadingBajaFormasPago: "Ordainketa moduaren bajak kontsultatzen...",
  loadingBajaUdMedida: "Neurketa unitateen bajak kontsultatzen...",
  loadingBajaLineaProd: "Produktuen lerroen bajak kontsultatzen...",

  emptyBajaUdMedida: "Ez da baja emandako neurketa unitaterik aurkitu.",
  errorUnidadMedidaNoConfigurada: "Ez da produktuak unitatea konfiguratzen Business Central desetik.",
  errorUnidadMedidaMateriasPrimas: "Ez da produktuak unitatea konfiguratzen Business Central desetik",

  configurarVerifactuUrgente: "Numier TPV dagoeneko VERI*FACTU-rekin ziurtagirituta dago",
  debesConfigurarVerifactuAntes15Nov: "Dagoeneko daukagu dena prest zure negozioa <span><i>VERI*FACTU</i></span>-rekin konektatzeko.<br />Horretarako soilik behar dugu <strong>zure negozio bakoitzean zure ziurtagiri digitala igo dezazula</strong>, horrela, data heltzen denean zure bertsioa eguneratuta izango dugu <strong>AEAT-eko arau berrira</strong>.<br />Informazio gehiago behar baduzu, bisitatu gure <i><a href='#/novedades' style='color: #1E22AA; text-decoration: underline; font-weight: 600;'>Berrikuntzak</a></i>.",
  subirCertificadoVerifactu: "Igo ziurtagiria <i class='fas fa-file-upload ml-1'></i>",
  verNovedades: "Ikusi Berrikuntzak",
  verifactuAplazadoTitulo: "VERI*FACTU 2027ra atzeratu da",
  verifactuAplazadoMensaje: "<strong><a style='text-decoration: underline; font-weight: 600;' href='https://sede.agenciatributaria.gob.es/Sede/iva/sistemas-informaticos-facturacion-verifactu/nota-informativa-ampliacion-plazo-adaptacion-facturacion.html' target='_blank' rel='noopener noreferrer'>VERI*FACTU-ren araudiaren atzeratzeagatik</a></strong> 2027. urtera arte, <b><i>Numier</i></b>-ren zerbitzarietan ostatatutako ziurtagiri digital guztiak <strong>ezabatu dira</strong> arrazoi logistikoetariko.<br/><br/>Inplementazio data berriak hauek izango dira:<br/><strong>• 2027ko urtarrilaren 1a</strong> zergadun eta sozietateentzat.<br/><strong>• 2027ko uztailaren 1a</strong> gainerako negozioentzat eta autonomoentzat.<br/><br/>Data berriak hurbiltzen ditugun heinean, edozein <b>berrikuntza</b> edo <b>aldaketa garrantzitsua</b> komunikatuko dugu.",

  verifactuProximoTitulo: "Prest VERI*FACTU 2027-rako",
  verifactuProximoMensaje: "<span><i>VERI*FACTU</i></span>-ren inplementazio data hurbiltzen ari da. <strong>Urtarrilean</strong> eta <strong>Uztailean 2027an</strong> indarrean jarriko da fakturazioaren arau berria derrigorrezkoa.<br/><br/>Zure negozioaren funtzionamendu egokia bermatzeko, funtsezkoena da <strong>ziurtagiri digitalak igo ditzazula</strong> zure kokalekuetan dagoenean ahalik eta lasterren.<br/><br/>Laguntza behar baduzu, ez hesitatu <strong>laguntza kontaktatzean</strong>.",

  errorVariasUdsMedidasProductoConSuplemento:
    "Ez da posible produktua sortzea, produktu oinarria hainbat neurketa unitate konfiguratu ditu Business Central-en.",

  //17/11/25 Diagnostico PLU
  diagnosticoPLU: "PLU Diagnostikoa",
  todosPluIguales: "PLU guztiak berdinak",
  pluDiferentes: "PLU desberdina",
  noExiste: "Ez dago",
  productoNoDisponible: "Produktua ez da aurkitu",
  subproductoNoDisponible: "Lehengai ez da aurkitu",
  productoNoEncontrado: "Produktua ez da aurkitu negozio honetan",
  coincide: "PLU bera",
  noCoincide: "PLU desberdina",
  //12/12/25
  tipoRol: "Rol mota",
  updatedPaymentMethod: "Ordainketa modu hauek eguneratu dira:",
  paymentMethodNameChanged: "Ordainketa modua izena aldatu da <strong>{oldName}</strong>-tik <strong>{newName}</strong>-ra.",
  updatedPaymentMethod: "Honako ordainketa-metodoak eguneratu dira:",
  noEsProductoValidoParaMutarProductoConSuple: "Produktu honek ez ditu bete PRODUKTU CON edo PRODUKTU OSAGARRI gisa onartzeko baldintzak.",

  paymentMethodDowngrades: "Se han encontrado bajas en formas de pago",
  downgradedPaymentMethods: "Formas de pago dadas de baja",
  unknownPaymentMethod: "Forma de pago desconocida",
  configuracionRol: "(Konfigurazio hau Numier TXANDAK sistemarentzat bakarrik da)",
  sinIdDeProducto: "Xehetasunik ez",

  addSupplementPriceTitle: "Osagarriaren prezioa zehaztu",
  addSupplementPriceText: "Detektatu da <strong>{PRODUCT_NAME}</strong> produktu honek orain osagarri gisa funtzionatu dezakeela, aurretik ez bezala. Eguneraketa amaitzeko, beharrezkoa da osagarri hau hautatzean aplikatuko den prezio aldaketa zehaztea. Hau produktuaren azken prezioa kalkulatzeko erabiltzen da, osagarria barne.",
  addSupplementPriceInputLabel: "Prezio aldaketa: ",
  productComputedInfo: "Hautatutako produktuak neurri-unitate bat baino gehiago dituela eta, aldi berean, “CON” edo “SUPLEMENTO” motakoa dela detektatu da, eta hori ez dago onartuta. Ondorioz, neurri-unitateak baztertu egingo dira eta “con/suplemento” motako produktua sortuko da. Inprimakia betetzen jarraitu dezakezu edo Business Central-en aldatu.",
  materiaPrimaComputedInfo:
    "Hautatutako saltzeko lehengaia neurri-unitate bat baino gehiagorekin detektatu da eta, aldi berean, CON edo SUPLEMENTU motakoa da; hori ez dago onartuta. Beraz, neurri-unitateak baztertuko dira eta con/suplementu motako produktu bat sortuko da. Inprimakia betetzen jarrai dezakezu edo Business Centraletik aldatu.",

  ocultarDTOInvitaciones: "Deskontuak eta gonbidapenak ezkutatu",

  modalUnidadesMedidaOpcionUnicoMasDeCuatro:
    "⚠️ Kontuz → Derrigorrezkoa da neurri-unitate bakoitzerako produktu independente bat sortzea, sistemak gehienez 4 tarifa onartzen baititu produktu bakoitzeko.",

  exportarPorLotesTPV: "TPV loteen arabera esportatu",
  modoExportacion: "Esportazio modua",
  exportacionNormal: "Esportazio normala",
  exportarDatos: "Datuak esportatu",
  descripcionExportacionNormal: "Salmenta guztiak batera esportatzen ditu eragiketa bakarrean",
  descripcionExportacionTPV: "Salmentak salmenta-puntuen (TPV) arabera taldekatuta esportatzen ditu",
  importeSinDto: "Zenbatekoa desk. gabe",

  //28/07/26
  actualizandoCartaSinqro: "Actualizando carta de productos en Sinqro...",
  cartaActualizadaSinqro: "Carta de productos actualizada correctamente en Sinqro.",
  
  businessCentralCode: "Business Central kodea",
  errorCargandoDatos: "Error al cargar los datos",
  noSeHaPodidoConsultarIntenteloMasTarde: "Ezin izan da kontsultatu, saiatu berriro mesedez.",
  listaPresentaMateriasPrimasNoSincronizadas: "Zerrendak zure TPVarekin sinkronizatu ez diren lehengaiak ditu. Saiatu berriro geroago mesedez.",
  
  noTieneProveedor: "Hornitzailerik gabe, eskaeraren gordetzean hautatuko da.",
  seleccionarProveedorMateriasPrimas: "Lehengaien hornitzailea hautatu",
  lasSiguientesMateriasPrimasNoTienenProveedor: "Ondorengo lehengaiek ez dute hornitzailerik esleituta. Hautatu hornitzaile bat bakoitzarentzat eskaera gorde aurretik:",
  seleccioneUnProveedor: "Hautatu hornitzaile bat",
  guardarYEnviar: "Gorde eta bidali",
  dividirPedidoEntreProveedores: "Eskaera hornitzaileen artean banatu",
  modalTextMp0: "Unitateak eta parteak 0 dituzten lehengaiak dituzu. Eskaeretatik baztertuko dituzu?",
  pedidoSinMp: "Eskaera hutsik geratu da lehengaiak baztertzean.",
  excluir: "Baztertu",

  materiaPrimaNoSincronizada: "Lehengai hau oraindik ez da zure TPVarekin sinkronizatu",

  noHayProductosAutoEditables: "Momentu honetan ez dago automatikoki sinkroniza daitekeen produkturik",
  confirmarSincronizacionMasivaTitle: "Produktu automatiko guztiak sinkronizatu nahi dituzu?",
  confirmarSincronizacionMasivaText: "{COUNT} produktu automatikoki sinkronizatuko dira, banan-banan berrikusi behar izan gabe. Jarraitu nahi duzu?",
  siSincronizar: "Bai, sinkronizatu",
  sincronizando: "Sinkronizatzen",
  sincronizacionMasivaCompletadaTitle: "Sinkronizazio masiboa amaituta",
  sincronizadosCorrectamente: "Ongi sinkronizatuta",
  errorDesconocido: "Errore ezezaguna",
  sincronizarTodosAuto: "Guztiak sinkronizatu ({COUNT})",
  sincronizarTodos: "Guztiak sinkronizatu",
  sincronizarTodosAutoTooltip: "Formularioa bete behar ez duten produktu guztiak batera sinkronizatzen ditu.",
  // Business Central-erako salmenten esportazioa: taula bateratua, laburpenak eta abisuak
  exportacionPorLotesFija: "Esportazioa TPV loteka bidaltzen da.",
  resumenPorMedioPago: "Ordainbidearen arabera",
  resumenPorTpv: "TPVaren arabera",
  resumenPorTipoDocumento: "Dokumentu motaren arabera",
  documento: "Dokumentua",
  verDetalle: "Ikusi xehetasuna",
  facturaQR: "QR bidezko eskaera batetik sortutako faktura: ez dagokio kutxa-egun bati",
  rectificaA: "Dokumentu hau zuzentzen du",
  socio: "Bazkidea",
  variasFormas: "Hainbat modu",
  verDetallesVenta: "Ikusi salmentaren xehetasunak",
  editarMedioPago: "Editatu ordainbidea",
  desglosePagos: "Ordainketen banakapena",
  valesRegalo: "Opari-bonuak",
  valesDelDocumentoOriginal: "zuzendutako dokumentukoa",
  avisos: "Abisuak",
  totalDeVenta: "Salmenta guztira:",
  ticket: "Tiketa",
  rectificativa: "Zuzenketa-faktura",
  origenImporteVales: "bonuaren zenbatekoa",
  origenImporteValesOriginal: "zuzendutako dokumentuaren bonua",
  origenImporteCobrosAvanzados: "kobrantza aurreratuaren batura",
  seleccioneUnMedioPago: "Hautatu ordainbide bat",
  importesNoEditables: "Zenbatekoak ezin dira hemendik aldatu.",
  buscarClientePorNombreCodigoODni: "Bilatu izenaren, bazkide-kodearen edo NANaren arabera",
  medioPagoRequiereClienteTexto: "Ordainbide hau bezero bati kobratzen zaio, beraz bat esleitu behar da.",
  medioActual: "Uneko ordainbidea",
  detallesVenta: "Salmentaren xehetasunak",
  tipoDocumento: "Dokumentu mota",
  dni: "NAN / IFZ",
  codigoSocio: "Bazkide-kodea",
  pago: "Ordainketa",
  edicion: "Edizioa",
  ventaSinCliente: "Salmentak ez du bezerorik esleituta.",
  ventaNoEditable: "Salmenta honek ez du ordainbidea aldatzerik onartzen.",
  errorCargandoFormasPago: "Ezin izan dira ordainketa-moduak kargatu.",
  avisoFacturaSinNombre: "Faktura bezeroaren izenik gabe",
  avisoFacturaSinDocumento: "Faktura NAN / IFZ gabe",
  avisoSocioSinCodigo: "Bazkidea koderik gabe: esportazioak baztertu egingo du",
  avisoSocioSinCodigoSalesforce: "Bazkidea koderik gabe: Salesforce-ri eskatuko zaio esportatzean",
  avisoMedioPagoSinCliente: "Ordainbidea bezerorik esleitu gabe",
  avisoCuentaCasaClienteGenerico: "Etxeko kontua bezerorik gabe: etxeko kontuen bezero generikoarekin esportatuko da",
  avisoValeSinRegistro: "Opari-bonua bonuen taulan erregistrorik gabe",
  avisoVentaSinImporte: "Salmenta zenbatekorik gabe: ordainketarik gabe joango litzateke",
  avisoRectificativaSinOriginal: "Ez da aurkitzen zuzentzen duen dokumentua",
  avisoProductoSinMapeoBC: "Produktua integrazio-koderik gabe",
  avisoProductoSinUnidadMedida: "Produktua neurri-unitaterik gabe",
  motivoVentaAvanzada: "Ordainketa aurreratuko salmenta: zenbatekoen banaketa ez da hemendik editatzen.",
  motivoVentaConVale: "Opari-bonuarekin ordaindutako salmenta: bonua kontsumituta eta erregistratuta dago.",
  motivoRectificativa: "Zuzenketa-faktura: zuzentzen duen dokumentuaren modu berean kobratu behar da.",
  motivoDestinoVale: "Ezin da salmenta bat opari-bonuetara pasatu: bonua TPVan kontsumitzen da.",
  debeCambiarFormaPagoParaGuardar: "Ordainbidea edo bezeroa aldatu behar duzu gordetzeko.",
  // Exportacion BC: resumen de avisos, filtros y paginacion de la tabla
  evCargandoVentas: "Esportatzeko dauden salmentak kargatzen...",
  evDocumentosPendientes: "Dokumentu zain",
  evDelDiaDeCaja: "kutxa-egunekoak",
  evConAvisos: "Abisuekin",
  evNoSeExportaran: "Ez dira esportatuko",
  evSinAvisos: "Abisurik gabe",
  evFiltrarPorAviso: "Sakatu abisu bat taulan salmenta horiek bakarrik ikusteko.",
  evVerDetalles: "Ikusi xehetasunak",
  evOcultarDetalles: "Ezkutatu xehetasunak",
  evErrorCargaVentas: "Ezin izan dira salmentak kargatu",
  evErrorCargaVentasTexto: "Ez dakigu salmentarik zain dagoen: kontsultak huts egin du. Saiatu berriro segundo batzuk barru.",
  evYOtros: "eta beste {n}",
  evBuscarVenta: "Bilatu dokumentuaren edo bezeroaren arabera",
  evFiltroTodas: "Guztiak",
  evFiltroListas: "Esportatzeko prest",
  evFiltroConAvisos: "Abisuekin",
  evFiltroBloqueantes: "Ez dira esportatuko",
  evTodosLosTpv: "TPV guztiak",
  evQuitarFiltros: "Kendu iragazkiak",
  evFiltroAviso: "Abisua",
  evSinCoincidencias: "Ez dago iragazkiekin bat datorren dokumenturik.",
  evMostrandoRango: "{desde}–{hasta} / {total}",
  evPorPagina: "orriko",
  evIrAlDocumento: "Joan dokumentura",
  evOriginalYaExportado: "esportatuta",
  evOriginalYaExportadoTexto: "Jatorrizko dokumentua ({fecha}) esportatu da dagoeneko",
  evRectificadaPor: "Zuzendua:",
  evNivelBloqueante: "Ez da esportatuko",
  evNivelRevisar: "Berrikusi",
  evNivelBloqueanteTexto: "Salmenta hau ez da bidaliko: zain geratuko da zuzendu arte.",
  evNivelRevisarTexto: "Salmenta esportatzen da, baina berrikustea komeni da.",
  evConNotasInformativas: "Ohar informatiboekin",
  evCuentasSinCobrar: "Kobratu gabeko kontuak",
  evCuentasSinCobrarTitulo: "Kobratu gabeko kontuak kutxa-egun honetan",
  evCuentasSinCobrarTexto: "Guztira {importe}. Ez dira esportatzen kobratu gabe dauden bitartean.",
  evNivelInfo: "Informazioa",
  evNivelInfoTexto: "Informazio hutsa da: salmenta ohi bezala esportatzen da.",
  evExportando: "Esportatzen…",
  evExportandoTexto: "Salmentak esportatzen. Minutu batzuk behar izan ditzake: ez itxi orri hau.",
  evExportarUnTpv: "TPV bat esportatu",
  evExportarUnTpvDesc: "Aukeratzen duzun TPVaren salmentak bakarrik esportatzen ditu",
  evEligeTpv: "Aukeratu TPV bat",
  evPrimeraPagina: "Lehen orria",
  evUltimaPagina: "Azken orria",
  evSoloSeExportaraTpv: "{tpv} TPVa bakarrik esportatuko da.",
  evQueSeEnviara: "Zer bidaliko den",
  evSeEnviaran: "Bidaliko dira",
  evQuedaranPendientes: "Zain geratuko dira zuzendu arte",
  evCifrasDelTpv: "{tpv} TPVaren zifrak.",
  evCifrasDelDepartamento: "Departamentu honetako zifrak; konpainiako beste departamentuak ere esportatzen dira.",
  evFiltrosNoAfectanExportacion: "Taulako iragazkiek ez dute esportazioan eraginik: zain dagoen guztia bidaltzen da.",
  evExportados: "Esportatuak",
  evRechazadosPorBC: "BCk baztertuak",
  evOmitidosPorValidacion: "BCk kanpoan utziak",
  evResultadoPendientesTexto: "Esportatu ez dena zain geratzen da eta taulan agertzen da bere abisuekin.",
  evResultadosExportacion: "Esportazioaren emaitzak",
  evDescargarInformeExcel: "Excel deskargatu",
  evInformeEstaTanda: "Azken esportazioa",
  evActualizarInformes: "Eguneratu",
  evSinInformes: "Oraindik ez dago txostenik. Esportazioa martxan badago, txostena hemen agertuko da amaitzean.",
  evSinRespuestaTanda: "Ez da zerbitzariaren erantzunik jaso. Esportazioa martxan egon daiteke oraindik: salmenten egoerak eta Excel txostena amaitzean agertuko dira. Eguneratu zerrenda minutu batzuk barru.",
  evDepartamentos: "Sailak",
  evEligeDepartamentos: "Aukeratu sailak",
  evTodosLosDepartamentos: "Sail guztiak",
  evTpvsAExportar: "Esportatu beharreko TPVak",
  evTpvsAyuda: "Parentesi artean, esportatu gabeko dokumentuak.",
  evAperturasAExportar: "Esportatu beharreko kutxa-irekierak",
  evAperturaMasAntigua: "Zain dagoen irekierarik zaharrena",
  evAperturaMasAntiguaCadaTpv: "TPV bakoitzaren zain dagoen irekierarik zaharrena",
  evIncluirFacturasQR: "QR fakturak sartu",
  evPendientesCorto: "zain",
  evRechazadosCorto: "BCk baztertuak",
  evOmitidosCorto: "saltatuak",
  evExcluidosCorto: "kanpoan",
  evSeExportaraSeleccion: "Datu hauek esportatuko dira",
  evResumenSeleccion: "Sailak: {departamentos}. TPVak: {tpvs}. Irekierak: {aperturas}. {qr}.",
  evConFacturasQR: "Zain dauden QR fakturekin",
  evSinFacturasQR: "QR fakturarik gabe",
  evExportacionTpvATpv: "TPVz TPV eta zatika bidaltzen da; baztertutakoa edo saltatutakoa zain geratzen da bere arrazoiarekin txandaren Excelean.",
  evCifrasDeLaSeleccion: "Uneko hautaketaren zifrak.",
  evEstadoRechazadoBC: "Aurrez baztertua",
  evEstadoOmitido: "Saltatua",
  evEstadoExcluido: "Kanpo utzia",
  evExcluirDeExportacion: "Esportaziotik kanpo utzi",
  evIncluirEnExportacion: "Berriro esportazioan sartu",
  evVentaExcluida: "Salmenta esportaziotik kanpo utzita",
  evVentaIncluida: "Salmenta berriro esportazioan sartuta",
  evVentasIncluidasN: "{n} salmenta berriro esportazioan sartuta",
  evVentasExcluidasN: "{n} salmenta esportaziotik kanpo utzita",
  evIncluirSoloEste: "Hau sartu",
  evIncluirTambienAsociados: "Lotutakoak sartu",
  evExcluirSoloEste: "Hau kanpo utzi",
  evExcluirTambienAsociados: "Lotutakoak kanpo utzi",
  evAsociadosIncluirPregunta: "Lotutakoak ere berriro sartu nahi dituzu, ala dokumentu hau bakarrik?",
  evAsociadosExcluirPregunta: "Lotutakoak ere kanpo utzi nahi dituzu, ala dokumentu hau bakarrik?",
  evAsociadosIncluirTexto: "{doc} dokumentuak esportaziotik kanpo utzitako {n} dokumentu lotu ditu:",
  evAsociadosExcluirTexto: "{doc} dokumentuak esportatu gabeko {n} dokumentu lotu ditu, bera gabe esportatu ezin direnak:",
  evAsociadosTitulo: "Lotutako dokumentuak",
  evFechaDoc: "Dok. data",
  avisoOriginalNoExportado: "Erreferentziatzen duen dokumentua ez dago esportatuta; jatorrizkoa sartzean bidaliko da",
  avisoExcluidaManual: "Esportaziotik kanpo utziak",

  evCargarVentas: "Salmentak kargatu",
  evSeleccionCambiada: "Hautaketa aldatu da, sakatu zerrenda eguneratzeko.",
  evCambiosSinCargar: "Hautaketa aldatu duzu eta zerrenda ez dago eguneratuta. Sakatu Salmentak kargatu esportatu aurretik.",
  evModoAvanzadasTitulo: "Nola zenbatu ordainketa bat baino gehiago duten salmentak (aurreratuak)",
  evAvanzadasTodas: "Salmenta guztiak",
  evAvanzadasSolo: "Aurreratuak bakarrik",
  evAvanzadasSin: "Aurreratuak gabe",
  evMasEnExcel: "… eta {n} gehiago. Xehetasun osoa esportazio-Excelean dago.",
  evMensajeEjemploParcial: "Bidalketa partziala: salmenta batzuk baliozkotzeak baztertuta eta beste batzuk ukatuta (adibideko datuak)",
  evPrevisualizarRespuesta: "Erantzuna aurreikusi",
  evExcluidaTexto: "Erabiltzaileak kanpo utzita: ez da esportatuko berriro sartu arte.",
  evActualizandoVentas: "Salmentak hautaketa berriarekin eguneratzen...",
  evActualizarVentas: "Salmentak eguneratu",
  evTramoNotaDefecto: "Bi aukeretan esportazioa 100 dokumentuko sortatan egiten da, behean beste tamaina bat ezarri ezean.",
  evDocumentosCada: "dokumentu (gutxienez 50)",
  evTramoDeN: "Sortak honela:",
  evTramoTodoDeUnaVez: "Dena batera",
  evPersonalizarTramos: "Bidalketa bakoitzeko sortaren tamaina konfiguratu",
  evTramoNotaTodo: "Esportazio osoa sorta bakarrean joango da.",
  evTramoNota: "Bi aukeretan esportazioa {n} dokumentuko sortatan egiten da.",
  evQrNoIncluidas: "Sartu gabe",
  evQrIncluidas: "Esportazioan sartuta",
  evFacturasQR: "QR fakturak",
  evCargandoInformes: "Txostenak kargatzen...",
  evConteoNoDisponible: "Zenbaketa ez dago eskuragarri",
  evVentasExportadasN: "{n} salmenta esportatuta",
  evEnvioTodoJuntoDesc: "Aukeratutako TPV guztien salmentak batera bidaltzen dira, egin ziren ordenan.",
  evEnvioTodoJunto: "TPV guztiak batera",
  evEnvioPorTpvDesc: "Aukeratutako TPVak banan-banan igarotzen ditu: TPV bakoitza bereizita bidali eta ebazten da.",
  evEnvioPorTpv: "TPV bakoitzeko",
  evModoEnvio: "Bidalketa",
  evInformesExportacion: "Azken esportazio-txostenak",
  evLineasVenta: "Salmentaren lerroak",
  evCargandoLineas: "Lerroak kargatzen…",
  evErrorCargandoLineas: "Ezin izan dira lerroak kargatu.",
  evVolverAIntentar: "Saiatu berriro",
  evSinLineas: "Salmentak ez du lerrorik.",
  evCodigoBC: "BC kodea",
  evUds: "Unit.",
  evUnidadBC: "Unitatea",
  evMenu: "Menua",
  evIncluidoEnMenu: "Barne",
  evTotalLineas: "Guztira",
  evImporteDeLaVenta: "Salmentaren zenbatekoa",
  evDescuento: "Desk.",
  // Kutxa-itxieraren (Z) txostena
  cierreCajaZDescripcion: "Z bakoitzaren kutxa-kontaketa osoa: salmentak, ordainbideak, zergak, produktuak eta tiketak",
  todaLaEmpresa: "Enpresa osoa",
  estadoZ: "Z-aren egoera",
  zCerradas: "Itxiak bakarrik",
  zAbiertas: "Irekiak bakarrik",
  zAbierta: "Irekia",
  zCerrada: "Itxia",
  consultarRangoFechas: "Data-tarte bat kontsultatu",
  ocultarFilasSinDatos: "Daturik gabeko errenkadak ezkutatu",
  zEnElInforme: "Z txostenean",
  ocultarDetalle: "Xehetasuna ezkutatu",
  quitarFranja: "Ordu-tartea kendu",
  documentos: "Dokumentuak",
  buscarDocumento: "Dokumentua bilatu (zk., bezeroa, langilea, mahaia)",
  limpiar: "Garbitu",
  sector: "Sektorea",
  seleccionaSector: "Hautatu sektore bat",
  desplazarIzquierda: "Ezkerrera mugitu",
  desplazarDerecha: "Eskuinera mugitu",
  verIncidencias: "Gorabeherak ikusi",
  incidenciasTexto: "Z-an TPV-an aldatu edo ezabatutako prezioak, kantitateak eta lerroak",
  todasLasIncidencias: "Gorabehera guztiak",
  todasLasZ: "Z guztiak",
  caja: "Kutxa",
  sinIncidencias: "Ez dago gorabeherarik iragazki horrekin",
  bloqueResumen: "Laburpena",
  bloqueAnalisisVentas: "Salmenten analisia",
  fechaCaja: "Kutxaren data",
  propinas: "Eskupekoak",
  ventasSinPropinas: "Salmentak eskupekorik gabe",
  formaPagoTipoSaldo: "Saldoarekin ordainketa",
  incidenciasPrecioModificado: "Prezioa aldatua",
  incidenciasLineaEliminada: "Lerroa ezabatua",
  incidenciasCantidadModificada: "Kantitatea aldatua",
  incidenciasDescuentoModificado: "Deskontua aldatua",
  incidenciasOtras: "Beste gorabeherak",
  rangoNoDisponibleSectores: "Sektoreekin egun bakarra kontsulta daiteke: sektoreak TPV asko biltzen ditu eta data-tarte batek txostena kudeaezina egingo luke. TPV-ka mugatzeko erabili ikuspegi-barrako iragazkia, txostena kargatu ondoren.",
  analisisNegocio: "Negozio-analisia",
  analisisNegocioDescripcion: "Salmenten, ordainketa-moduen, gorabeheren eta errentagarritasunaren konparaketak hilabete eta urteen artean",
  anPeriodo: "Aldia",
  anModoMes: "Hilabetea",
  anModoRango: "Tartea",
  anModoAnio: "Urtea",
  anMes: "Aztertzeko hilabetea",
  anCompararCon: "Konparatu honekin",
  anMesAnteriorYAnioAnterior: "Aurreko hilabetea eta aurreko urteko hilabete bera",
  anMesAnterior: "Aurreko hilabetea",
  anMismoMesAnioAnterior: "Aurreko urteko hilabete bera",
  anSinComparar: "Konparaziorik gabe",
  anPeriodoA: "A aldia",
  anPeriodoB: "B aldia",
  anPeriodoC: "C aldia",
  anAnio: "Aztertzeko urtea",
  anAnioAnteriorMismaFecha: "Aurreko urtea data bererarte",
  anRecalcular: "Berriro kalkulatu",
  anRecalcularAyuda: "Berriro kalkulatu gordetako datuak alde batera utzita. Erabili TPV batek datuak berriro igo baditu. Gehienez behin orduro eta hiru aldiz egunean.",
  anRecalcularEspera: "Duela gutxi berriro kalkulatu da. {tiempo} barru egin ahal izango duzu berriro.",
  anRecalcularEsperaDia: "Azken 24 orduetan hiru birkalkulu egin dira. {tiempo} barru berriro kalkulatu ahal izango duzu.",
  anRecalcularConfirmacion: "Kontsultatutako TPV eta hilabeteen gordetako datuak ezabatu eta berriro kalkulatuko dira. Segundo batzuk behar ditzake.",
  anCalculandoPeriodos: "Hautatutako aldiak kalkulatzen…",
  anSinDatos: "Salmentarik gabe aldian",
  anSinDatosTexto: "Ez dago kutxa-saiorik ez dokumenturik hautatutako esparruan eta aldian.",
  anPeriodosDistintaLongitud: "Iraupen ezberdineko aldiak: konparatu batezbestekoak",
  anPestanaVentas: "Salmentak",
  anPestanaFormasPago: "Ordainketa-moduak",
  anPestanaIncidencias: "Gorabeherak",
  anPestanaRentabilidad: "Errentagarritasuna",
  anProximamente: "Hurrengo fasean eskuragarri",
  anEvolucionMensual: "Hileko bilakaera",
  anUltimos13Meses: "azken 13 hilabeteak",
  anMediaDiaria: "Eguneko batezbestekoa",
  anCalculandoMesesAntiguos: "Aurreko hilabeteak kalkulatzen…",
  anVentasPorDia: "Salmentak egunez",
  anAlinearPorDiaSemana: "Asteko egunaren arabera lerrokatu",
  anVentasPorDiaSemana: "Salmentak asteko egunez",
  anMediaPorDiaConVentas: "salmentak dituen eguneko batezbestekoa",
  anVentasPorHora: "Salmentak orduz",
  anPorNegocioYTpv: "Negozio eta TPV-ka",
  anVariacion: "Aldaketa",
  sesiones: "Saioak",
  anCompletaPeriodo: "Bete aldia kontsultatzeko",
  anPeriodoInvertido: "Aldiaren amaiera hasiera baino lehenagokoa da",
  anMaximo12Meses: "Aldi bakoitzak gehienez 12 hilabete har ditzake",
  anCalculadosAhora: "{total}-tik {n} TPV·hilabete orain kalkulatuta; gainerakoa gordetako datuetatik",
  anDatosDeCache: "Gordetako datuak ({fecha}an kalkulatuak)",
  anHasta: "arte",
  anNotaDistintaLongitud: "Aldiek ez dute iraupen bera: begiratu batezbestekoei",
  anNotaAlineadoSemana: "Asteko egunaren arabera lerrokatuta: 1. eguna aldi bakoitzeko lehen astelehena da",
  anNotaBisiesto: "{periodo} aldiak {anio}ko otsailaren 29a barne du, beste aldian parekorik ez duena",
  anDia: "Eguna",
  anFormasPagoMesesCompletos: "Ordainketa-moduen banaketa hilabete osoen gainean kalkulatzen da: aldiaren eguneko mozketa ez da hemen aplikatzen.",
  anRepartoPorTipo: "Banaketa ordainketa-motaren arabera",
  anTiposPorPeriodo: "Ordainketa-motak aldika",
  anEvolucionFormasPago: "Ordainketa-moduen bilakaera",
  anEnPorcentaje: "Ehunekotan",
  anPorTipoYMedio: "Ordainketa-mota eta bidearen arabera",
  formaPago: "Ordainketa-modua",
  anPorcentajeMediosNota: "Mota bakoitzaren % aldiaren guztizkoaren gainean da; bide bakoitzarena, bere motaren gainean.",
  anRatioIncidencias: "{n} gorabehera 100 dokumentuko",
  anRatioFrenteA: "ratioa honekiko:",
  anTipoPredominante: "Mota nagusia",
  anEvolucionIncidencias: "Gorabeheren bilakaera",
  anBarrasTotalLineaRatio: "barrak: guztira · lerroa: 100 dokumentuko",
  anIncidenciasPorDia: "Gorabeherak egunez",
  anPulsaDiaParaCierreZ: "sakatu egun bat bere Z kutxa-itxiera irekitzeko",
  anIncidenciasPorTipo: "Gorabeherak motaren arabera",
  anIncidenciasPorOperario: "Gorabeherak langileka",
  anIncidenciasPorProducto: "Gorabeherak eragindako produktuaren arabera",
  anAQueSeDeben: "zeri zor zaizkion",
  anPor100Docs: "100 dok.-ko",
  anVariacionRatio: "Ratioaren aldaketa",
  anCoberturaCoste: "Saldutako {total} elementutik {conCoste}k dute kostua ({pct} % BEZ gabeko salmentetan); horiek bakarrik sailkatzen dira.",
  anCosteActualNota: "Kostua produktu bakoitzaren uneko kostua da, ez aldian zuena.",
  anRentabilidadMesesCompletos: "Errentagarritasuna hilabete osoen gainean kalkulatzen da: eguneko mozketa ez da hemen aplikatzen.",
  anPorProductoYTarifa: "Produktua × tarifa",
  anPorProducto: "Produktua",
  anTodasLasCategorias: "Kategoria guztiak",
  anTodosLosCuadrantes: "Koadrante guztiak",
  anSinCoste: "Kosturik gabe",
  anItems: "elementu",
  anMargenContribucion: "Kontribuzio-marjina",
  anUmbrales: "Aldiaren atalaseak",
  anIndicePopularidadMedio: "Ospe-indize batezbestekoa",
  anRentabilidadMedia: "Errentagarritasun batezbestekoa (KM unitateko)",
  anMediaCoste: "Kostu batezbestekoa",
  anMatrizPopularidadMargen: "Ospea × marjina matrizea",
  anMatrizExplicacion: "burbuila bakoitza elementu bat da; tamaina, bere marjina osoa; lerroak, atalaseak",
  anMargenPorCuadrante: "Marjina osoa koadranteka",
  anTopMargen: "Marjina osorik handiena",
  anCambiosCuadrante: "Koadrante-aldaketak",
  anTablaIngenieriaMenu: "Menu-ingeniaritza",
  anNumeroVentas: "Salmenta kop.",
  anCosteProducto: "Kostua",
  anPrecioVentaSinIva: "Salneurria BEZ gabe",
  anIndicePopularidad: "Ospe-indizea",
  anCosteProductoPct: "% kostua",
  anTotalCoste: "Kostua guztira",
  anTotalVentas: "Salmentak guztira",
  anMargenContribucionTotal: "KM guztira",
  anClasifRentabilidad: "Errentagarritasuna",
  anClasifPopularidad: "Ospea",
  anClasifFinal: "Sailkapena",
  anTarifaNoIdentificada: "Tarifa identifikatu gabea: 1. tarifari esleitu da",
  anNuevo: "berria",
  anAlta: "Altua",
  anBaja: "Baxua",
  anSinUnidades: "Unitate garbirik gabe",
  anPrincipiosOmnes: "Prezioak: Omnes-en printzipioak",
  anTodaLaCarta: "Saldutako karta osoa",
  anDispersionPrecios: "Prezioen dispertsioa",
  anDispersionTexto: "Preziorik altuena {max} / baxuena {min}",
  anDispersionIdeal: "Idealki 2,5 eta 3 artean 12 plater baino gehiagoko gametan",
  anDispersionNoAplica: "Irizpidea (2,5–3) 12 plater baino gehiagoko gametan aplikatzen da",
  anAmplitudGama: "Gamaren zabalera",
  anAmplitudTexto: "Zabalera bereko bandak; mozketak {bajo} eta {alto}. Idealki % 25 / 50 / 25.",
  anRelacionCalidadPrecio: "Kalitate-prezio erlazioa",
  anPrecioMedioSolicitado: "Eskatutako batez besteko prezioa",
  anPrecioMedioOfertado: "Eskainitako batez besteko prezioa",
  anSimularCambioPrecios: "Prezio-aldaketa simulatu",
  anBandaBaja: "Banda baxua",
  anBandaMedia: "Banda ertaina",
  anBandaAlta: "Banda altua",
  anActual: "Unekoa",
  anIdeal: "Ideala",
  anRecomendableSubir: "Prezioak igotzea gomendagarria (ratioa > 1,00)",
  anRecomendableBajar: "Prezioak jaistea gomendagarria (ratioa < 0,90)",
  anRecomendableMantener: "Prezio egokiak: mantendu (ratioa 0,90–1,00)",
  anCuadranteLider: "Liderra",
  anCuadrantePopular: "Ezaguna",
  anCuadranteRentable: "Errentagarria",
  anCuadranteRevisar: "Berrikusteko",
  anCuadranteLiderAyuda: "Ospe altua eta marjina altua: negozioa eusten duten platerak. Mantendu eta nabarmendu.",
  anCuadrantePopularAyuda: "Asko saltzen da baina marjina gutxi uzten du: kostua edo prezioa berrikusi.",
  anCuadranteRentableAyuda: "Marjina ona baina gutxi saltzen da: ikusgarritasuna eman edo kartan berriro kokatu.",
  anCuadranteRevisarAyuda: "Ez da saltzen ez marjinarik uzten: aldatzeko edo kentzeko hautagaia.",
  anExportarPdfAyuda: "Uneko fitxa PDF gisa esportatu (grafikoak eta taulak)",
  anExportarExcelAyuda: "Uneko fitxa Excel gisa esportatu (orri bat bloke bakoitzeko)",
  verAnalisisNegocio: "Analisia ikusi",
  verAnalisisNegocioAyuda: "'Negozio-analisia' ireki enpresa honekin, negozio hauekin eta kontsultatutako dataren hilabetearekin",
  proximamente: "Laster",
  verAnalisisNegocioProximamente: "'Negozio-analisia' txostena laster egongo da eskuragarri",
  anPeriodosReordenados: "Aldiak berrienetik zaharrenera erakusten dira: {reciente} da aldi nagusia eta aldakuntzak {antiguo} aldiarekiko zenbat aldatu den adierazten du.",
  anVariacionDireccion: "{antiguo}-tik {reciente}-ra bitarteko aldakuntza: aldi berria aurrekoarekiko zenbat aldatu den.",
  anExportarEsperaCarga: "Itxaron fitxa kargatzen amaitu arte esportatu aurretik.",
  sinSesionesDeCaja: "Ez dago kutxa-saiorik",
  sinSesionesDeCajaTexto: "Esparruko TPV batek ere ez zuen kutxa ireki hautatutako datan. Z-a irekitzen den egunari dagokio, gauerdia pasata ixten bada ere.",
  tpvsSinApertura: "Ireki gabeko TPV-ak",
  facturasQRExcluidasTexto: "QR fakturak ez dira Z baten parte eta ez daude txosten honetan: beren txostena dute.",
  franjaHoraria: "Ordu-tartea",
  franjaHorariaSoloAnalisis: "Ordu-tarteak produktuak eta tiketak bakarrik filtratzen ditu. Kutxa-kontaketa saio osoarena da eta ez du eraginik.",
  aplicar: "Aplikatu",
  productosVendidos: "Saldutako produktuak",
  productosVendidosTexto: "Z bakoitzeko produktu bakoitzaren kopurua. Ez ditu deuseztapenak, stocka eta galerak barne hartzen.",
  todosLosDocumentos: "Dokumentu guztiak",
  formasPago: "Ordainbideak",
  invitacion: "Gonbidapena",
  cuentaCasa: "Etxeko kontua",
  valeRegalo: "Opari-bonua",
  bloqueIdentificacion: "Identifikazioa",
  bloqueVentas: "Salmentak",
  bloqueFormasPago: "Ordainbideak",
  bloqueArqueo: "Kutxa-kontaketa",
  bloqueImpuestos: "Zergak",
  numeroZ: "Z zenbakia",
  operarioCierre: "Langilea",
  duracionHoras: "Iraupena (orduak)",
  primerDocumento: "Lehen dokumentua",
  ultimoDocumento: "Azken dokumentua",
  numIncidencias: "Gorabeherak",
  numAnulados: "Deuseztatutako dokumentuak",
  ventasBrutas: "Salmentak",
  abonos: "Abonuak",
  ventasTotales: "Salmentak guztira",
  numDocumentos: "Dokumentu kopurua",
  numTickets: "Tiketak",
  numFacturas: "Fakturak",
  numRectificativas: "Zuzenketa-fakturak",
  ticketMedio: "Batez besteko tiketa",
  mediaPorComensal: "Batez bestekoa mahaikide bakoitzeko",
  numInvitaciones: "Gonbidapen kopurua",
  importeInvitaciones: "Gonbidapenen zenbatekoa",
  formaPagoTipoEfectivo: "Eskudirua",
  formaPagoTipoTarjeta: "Txartela",
  formaPagoTipoCheque: "Txekea",
  formaPagoTipoOtros: "Beste batzuk",
  totalFormasPago: "Ordainbideak guztira",
  ventaSegunTpv: "Salmenta TPV-aren arabera",
  diferenciaConDocumentos: "Dokumentuekiko aldea",
  cambioInicial: "Hasierako kanbioa",
  gastosCaja: "Kutxa-gastuak",
  totalCalculado: "Kalkulatutako guztizkoa",
  totalDeclarado: "Deklaratutako guztizkoa",
  retirado: "Kendua",
  nuevaFianza: "Fidantza berria",
  baseImponibleIva: "BEZaren zerga-oinarria",
  cuotaIva: "BEZ kuota",
  baseImponibleTotal: "Zerga-oinarria guztira",
  totalImpuestos: "Zergak guztira",
  avisoZAbierta: "Z itxi gabe: ezin da kontatu",
  avisoZDuracionExcesiva: "Z ohi baino denbora gehiago irekita",
  avisoZConIncidencias: "Z gorabeherekin",
  avisoZSinVentas: "Z salmentarik gabe",

  // --- Horario de disponibilidad Sinqro ---
  configurarHorarioSinqro: "Eskuragarritasun ordutegia konfiguratu",
  horarioSinqroOnAyuda: "Aukeratu ordutegi bat edo sortu berri bat; aktiboa da Sinqrora bidaltzen dena.",
  horarioSinqroOffAyuda: "Ordutegirik konfiguratzen ez baduzu, Sinqron karta 24 orduz egongo da eskuragarri.",
  copiarATodosLosDias: "Kopiatu gainerako egunetara",
  anadirTramo: "Gehitu tartea",
  horarioSinqroSinTramos: "Ordutegia aktibatu duzu baina egun batzuek ez dute tarte baliodunik. Bete orduak edo desaktibatu ordutegia.",
  horarioSinqroRangoInvalido: "Amaiera ordua hasierakoa baino lehenago edo berdina duten tarteak daude.",

  // --- Biblioteca de horarios Sinqro ---
  seleccionaHorario: "Aukeratu ordutegi bat",
  crearNuevoHorario: "Sortu ordutegi berria",
  nombreHorario: "Ordutegiaren izena",
  guardarHorario: "Gorde ordutegia",
  horarioGuardado: "Ordutegia gordeta",
  horarioEliminado: "Ordutegia ezabatuta",
  confirmarEliminarHorario: "Ordutegi hau ezabatu? Ekintza hau ezin da desegin.",
  sinHorarios: "Negozio honek ez du ordutegirik oraindik. Sortu bat.",
  nombreHorarioObligatorio: "Jarri izen bat ordutegiari.",
  horarioActivoAyuda: "Aukeratutako ordutegia da Sinqrora bidaltzen dena.",

  // --- Negozioaren etiketak (pantaila berria) ---
  // TRADUCCION PENDIENTE DE REVISION POR HABLANTE NATIVO.
  etiquetasDelNegocio: "Negozioaren etiketak",
  etiquetasClasifican: "Lehengaiak eta hornitzaileak sailkatzen dituzte.",
  etiquetasDosFamilias: "Bi familia, inoiz nahasten ez direnak: lehengai batek lehengai-etiketak baino ez ditu eramaten.",
  deMateriaPrima: "Lehengaienak",
  deProveedor: "Hornitzaileenak",
  conProblema: "Arazoarekin",
  familiasDeEtiquetas: "Etiketa familiak",
  sinTipo: "Motarik gabe",
  verTodas: "Ikusi denak",
  sinNombre: "(izenik gabe)",
  sinEtiquetaExplica: "etiketarik esleituta ez duten lehengaiak",
  sinEtiquetasEnEstaFamilia: "Negozio honek ez du familia honetako etiketarik.",
  notaEtiquetas: "Etiketak negozioaren TPV zerbitzarian daude, ez bat terminal bakoitzeko. Pantaila honek denak erakusten ditu, panelaren gainerakoak erakusten ez dituenak barne.",
  estadoRaiz: "etiketa nagusia",
  estadoDentroDe: "«{padre}» barruan",
  estadoDeBaja: "bajan emanda",
  estadoNombreRepetido: "izen hau duen etiketa bat baino gehiago dago",
  estadoSinTipo: "ez da lehengaiena ez hornitzaileena",
  estadoBucle: "bere buruaren etiketa gurasoa da",
  estadoHuerfana: "{code} etiketaren mende dago, eta hori ez da existitzen edo ez da familia honetakoa",
  estadoNoSeVe: "ez da ikusten panelaren gainerakoan: bere adarra lehenago eteten da",
  avisoEtiquetasOcultas: "<b>Lehengaien etiketa bat ez da ikusten panelaren gainerakoan</b>, «{nombre}», barruan {m} lehengairekin. Zerrendan agertzen da, baina ezin da aukeratu fitxa bat editatzean. | <b>Lehengaien {n} etiketa ez dira ikusten panelaren gainerakoan</b>, «{nombre}» barne, barruan {m} lehengairekin. Zerrendan agertzen dira, baina ezin dira aukeratu fitxa bat editatzean.",
  avisoMpConEtiquetaProveedor: "<b>Lehengai batek hornitzaile etiketa bat darama.</b> Bi familia desberdin dira: etiketa hori ezin izango litzateke hemen aukeratu. | <b>{n} lehengaik hornitzaile etiketa bat daramate.</b> Bi familia desberdin dira: etiketa horiek ezin izango lirateke hemen aukeratu.",
  avisoMpConEtiquetaSinTipo: "<b>Lehengai batek motarik gabeko etiketa bat darama.</b> Ez da lehengaiena ez hornitzaileena, beraz ez da inon taldekatzen. | <b>{n} lehengaik motarik gabeko etiketa bat daramate.</b> Ez dira lehengaienak ez hornitzaileenak, beraz ez dira inon taldekatzen.",
  avisoMpConEtiquetaDeBaja: "<b>Lehengai batek baja emandako etiketa bat darama.</b> Etiketa badago, baina fitxak jada ez du eskaintzen, beraz paneletik ezin da handik atera. | <b>{n} lehengaik baja emandako etiketa bat daramate.</b> Etiketak badaude, baina fitxak jada ez ditu eskaintzen, beraz paneletik ezin dira handik atera.",
  avisoMpConEtiquetaInexistente: "<b>Lehengai bat existitzen ez den etiketa batera lotuta dago.</b> Erreferentzia hautsita dago: ez da agertzen etiketaren araberako txostenetan. | <b>{n} lehengai existitzen ez diren etiketetara lotuta daude.</b> Erreferentziak hautsita daude: ez dira agertzen etiketaren araberako txostenetan.",
  avisoEtiquetasSinTipo: "<b>Motarik gabeko etiketa bat dago.</b> Ez da inongo zerrendatan agertzen, eta haren mendekoak ere ez. | <b>Motarik gabeko {n} etiketa daude.</b> Ez dira inongo zerrendatan agertzen, eta haien mendekoak ere ez.",
  avisoMpSinEtiqueta: "<b>Lehengai batek ez du etiketarik.</b> Ez da etiketaren araberako txostenetan taldekatuta agertzen. | <b>{n} lehengaik ez dute etiketarik.</b> Ez dira etiketaren araberako txostenetan taldekatuta agertzen.",
  avisoEtiquetaRepetida: "<b>«{nombre}» izeneko {n} etiketa daude</b> {familia} atalean. Bat aukeratzean ez dago jakiterik zein den zein.",

  // --- Etiketa berria ---
  // TRADUCCION PENDIENTE DE REVISION POR HABLANTE NATIVO.
  familia: "Familia",
  queEsCadaFamilia: "Zer da familia bakoitza",
  ayudaFamiliaMateriaPrima: "biltegiko lehengaiak sailkatzen ditu. Lehengai bati esleitu dakiokeen bakarra da, eta erosketa eta inbentario txostenak taldekatzen dituena.",
  ayudaFamiliaProveedor: "hornitzaileak sailkatzen ditu, gastu txostenetan taldekatzeko. Ezin zaio lehengai bati esleitu.",
  ningunaEsPrincipal: "Bat ere ez — etiketa nagusia izango da",
  ayudaEtiquetaPadre: "Familia bereko etiketa aktiboak bakarrik eskaintzen dira: beste familia baten mendeko etiketa bat ez da ikusten panelaren gainerakoan.",
  nombreEtiquetaObligatorio: "Jarri izen bat etiketari.",
  etiquetaCreada: "Etiketa sortuta.",
  noSeHaPodidoGuardar: "Ezin izan da gorde. Saiatu berriro.",

  // --- Etiketa editatu eta baja eman ---
  // TRADUCCION PENDIENTE DE REVISION POR HABLANTE NATIVO.
  editarEtiqueta: "Etiketa editatu",
  reactivar: "Berraktibatu",
  padreCode: "{code} kodea (ez da existitzen)",
  laFamiliaNoSeCambia: "Familia ez da aldatzen: dagoeneko daramaten lehengaiek araua betetzeari utziko liokete. Beste bat behar bada, sortu etiketa berri bat.",
  etiquetaGuardada: "Etiketa gordeta.",
  etiquetaDadaDeBaja: "Etiketari baja emanda.",
  etiquetaReactivada: "Etiketa berraktibatuta.",
  darDeBajaEtiqueta: "«{nombre}» bajan eman",
  bajaConMateriasPrimas: "Lehengai 1 du barruan, eta bajan dagoen etiketa bati begira geratuko da. | {n} lehengai ditu barruan, eta bajan dagoen etiketa bati begira geratuko dira.",
  bajaConHijas: "Etiketa 1 dago haren mende, eta guraso baliodunik gabe geratuko da. | {n} etiketa daude haren mende, eta guraso baliodunik gabe geratuko dira.",
  bajaSinConsecuencias: "Ez du lehengairik ez beste etiketarik barruan. Nahi duzunean berraktibatu ahal izango duzu.",
  aQueEtiquetaVan: "Zein etiketara doaz?",
  bajaHijasSuben: "Etiketa 1 zintzilikatzen da bertatik, eta {padre} pasatuko da. | {n} etiketa zintzilikatzen dira bertatik, eta {padre} pasatuko dira.",
  ningunaSeranPrincipales: "etiketa nagusiak izatera",
  bajaDejarSinEtiqueta: "Etiketarik gabe utzi, berresleitu beharrean | {n} horiek etiketarik gabe utzi, berresleitu beharrean",
  bajaMpReasignadas: "Lehengai 1 berresleitu da. | {n} lehengai berresleitu dira.",
  bajaMpSinEtiqueta: "Lehengai 1 etiketarik gabe geratu da. | {n} lehengai etiketarik gabe geratu dira.",
  bajaHijasMovidas: "Etiketa 1 maila bat igo da. | {n} etiketa maila bat igo dira.",

  // --- Berrikusteko lehengaiak (etiketen pantailaren modala) ---
  verYAsignar: "Ikusi eta esleitu",
  asignarFamilia: "Familia esleitu",
  tituloSinTipo: "Familiarik gabeko etiketak",
  ayudaSinTipo: "Ez dira ez lehengaienak ez hornitzaileenak, beraz ez dira agertzen inongo zerrendan, eta haietatik zintzilikatzen denak ere ez. Markatu nahi dituzunak eta aukeratu dagokien familia.",
  queFamiliaLesCorresponde: "Zein familia dagokie?",
  pistaMateriasPrimas: "lehengai 1 barruan | {n} lehengai barruan",
  pistaHijas: "etiketa 1 barruan, {familia} | {n} etiketa barruan, {familia}",
  pistaNadie: "inork ez du erabiltzen",
  sinTipoNadaQueVer: "Etiketa guztiek dute beren familia.",
  familiaAsignada: "Familia etiketa 1i esleitu zaio. | Familia {n} etiketei esleitu zaie.",
  tituloRevisar_sinEtiqueta: "Etiketarik gabeko lehengaiak",
  tituloRevisar_etiquetaProveedor: "Hornitzaile-etiketa duten lehengaiak",
  tituloRevisar_etiquetaSinTipo: "Motarik gabeko etiketa duten lehengaiak",
  tituloRevisar_etiquetaDeBaja: "Baja emandako etiketa duten lehengaiak",
  tituloRevisar_etiquetaInexistente: "Existitzen ez den etiketa duten lehengaiak",
  ayudaRevisar_sinEtiqueta: "Ez daude etiketaren araberako inongo txostenean multzokatuta. Markatu nahi dituzunak eta aukeratu behean zein etiketara doazen.",
  ayudaRevisar_etiquetaProveedor: "Beste familia bateko etiketa daramate. Markatu nahi dituzunak eta aukeratu behean lehengai-etiketa bat.",
  ayudaRevisar_etiquetaSinTipo: "Haien etiketa ez da ez lehengaiena ez hornitzaileena, beraz ez du inon multzokatzen. Markatu nahi dituzunak eta aukeratu behean lehengai-etiketa bat.",
  ayudaRevisar_etiquetaDeBaja: "Haien etiketak baja emanda dago, beraz lehengaiaren fitxak jada ez du eskaintzen. Markatu nahi dituzunak eta aukeratu behean altan dagoen etiketa bat.",
  ayudaRevisar_etiquetaInexistente: "Jada ez dagoen etiketa batera lotuta daude. Markatu nahi dituzunak eta aukeratu behean zein etiketara doazen.",
  seleccionarNinguna: "Bat ere ez",
  revisarTruncado: "{total}etik lehena erakusten da. Erabili bilatzailea gainerakoetara iristeko. | {total}etik lehen {n} erakusten dira. Erabili bilatzailea gainerakoetara iristeko.",
  revisarSinPermiso: "Zerrenda ikus dezakezu, baina ez duzu lehengaiak editatzeko baimenik, beraz ezin dituzu berresleitu.",
  revisarNadaQueVer: "Ez da bat ere geratzen egoera honetan.",
  asignarEtiqueta: "Esleitu etiketa hau",
  elegirEtiquetaDestino: "Aukeratu lehengai-etiketa bat",
  etiquetasDeMateriaPrima: "Lehengai-etiketak",
  quitarEtiqueta: "Etiketa kendu",
  sinResultados: "Ez dago bat datorren etiketarik",
  dejarSinEtiqueta: "Etiketarik gabe utzi",
  asignarACuantas: "Esleitu | Esleitu {n}(r)i",
  confirmarDejarSinEtiqueta: "Etiketarik gabe geratuko da eta ez da agertuko etiketaren araberako txostenetan multzokatuta. | {n} horiek etiketarik gabe geratuko dira eta ez dira agertuko etiketaren araberako txostenetan multzokatuta.",
  materiasPrimasAsignadas: "Etiketa lehengai 1i esleitu zaio. | Etiketa {n} lehengaiei esleitu zaie.",
  etiquetaSinNombre: "(izenik gabeko etiketa)",
  destinoOculto: "Ez dira ikusten panelaren gainerakoan",
  avisoDestinoOculto: "Etiketa hori ez da ikusten panelaren gainerakoan: bere adarra bertara iritsi aurretik eteten da. Lehengaiak multzokatuta geratuko dira, baina fitxa bat editatzean ezin izango duzu aukeratu.",
  errorInesperado: "Ustekabeko zerbait gertatu da. Saiatu berriro.",
  // Pausas en el informe de turnos (app de gestión de turnos)
  tpPausas: "Etenaldiak",
  tpPorDias: "Egunka",
  tpPorTurnos: "Txandaka",
  tpHorario: "Ordutegia",
  tpDesayuno: "Gosaria",
  tpCigarro: "Zigarroa",
  tpDescanso: "Atsedena",
  tpOtra: "Bestelakoa",
  tpEnCurso: "abian",
  tpTurnoDe: "txanda:",
  tpJornadaPartida: "Lanaldi zatitua",
  tpParon: "Txanden arteko geldialdia",
  tpDias: "egun",
  tpNota: "Sakatu egun bat xehetasunak ikusteko. Etenaldiak informatiboak dira: ez dituzte orduak ez soldata aldatzen.",
  // --- Categorias del negocio (Configuracion > Categorias) ---
  terminales: "Terminalak",
  desiguales: "Desberdinak",
  gruposDeCategorias: "Kategoria taldeak",
  vistaListado: "Zerrenda ikuspegia",
  vistaColumnas: "Zutabe ikuspegia",
  verLos4Grupos: "Ikusi 4 taldeak",
  catDe: "/",
  pantallaDelTerminal: "TPVaren {n}. pantaila",
  reindexar: "Berrindexatu",
  grupoCompleto: "Taldea beteta",
  seGuardaEnTerminales: "Negozioaren terminalean gordeko da. | Negozioaren {n} terminaletan gordeko da.",
  sinCategoriaExplica: "talde honetako produktuak, kategoriarik gabe",
  huecoConBajasExplica: "bajan dauden produktuak baino ez ditu; askatu berrerabiltzeko",
  liberarRanura: "Askatu",
  liberarRanuraTitulo: "Tarte hau askatu?",
  liberarRanuraTexto: "Bajan dauden produktuak kategoriarik gabe geratzen dira eta tartea libre geratzen da kategoria berri baterako edo berrindexatzeko. Altan dauden produktuak ez dira ukitzen.",
  ranuraLiberada: "Tartea askatuta",
  huecoLibreExplica: "hemen kategoria bat zegoen; bere lekua gordeta dago oraindik",
  verProductos: "Ikusi produktuak",
  usarEsteHueco: "Hutsune hau erabili",
  nombreCategoriaNueva: "Kategoria berriaren izena",
  seCrearaAlFinalDelGrupo: "Hutsik sortuko da, {g} taldearen amaieran, negozioaren terminalean. | Hutsik sortuko da, {g} taldearen amaieran, {n} terminaletan.",
  grupoVacio: "Talde hau hutsik dago. Hemen sortzen dituzun kategoriak TPVaren {n}. pantailan agertuko dira.",
  fueraDeLosGrupos: "Lau taldeetatik kanpo",
  fueraDeLosGruposExplica: "terminalak erabiltzen ditu, baina haien tekla ez da ohiko 40etakoa",
  verDeUnoEnUno: "Ikusi taldeak banan-banan",
  mostrarLos4Grupos: "Erakutsi 4 taldeak",
  notaGruposTerminal: "Lau taldeak zerbitzariak terminalean ikusten dituenak dira. Kategoria bat talde baten barruan sortzen da eta han geratzen da; gehitzeak bere taldearen amaieran jartzen du, eta editatzeak edo ezabatzeak ez ditu besteak mugitzen.",
  productosAsignados: "Produktu 1 «{categoria}» kategoriari esleitu zaio. | {n} produktu «{categoria}» kategoriari esleitu zaizkio.",
  reordenar: "Berrordenatu",
  avisoOrdenDistinto: "<b>Terminal batean kategoriak zerbitzarian ez bezalako teklatan daude.</b> Berrordenatu itzazu ezer baino lehen: bitartean, beste abisuak ez dira zertan zuzenak izan. | <b>{n} terminaletan kategoriak zerbitzarian ez bezalako teklatan daude.</b> Berrordenatu itzazu ezer baino lehen: bitartean, beste abisuak ez dira zertan zuzenak izan.",
  avisoOtroNombre: "<b>Terminal batek «{otro}» deitzen dio «{nombre}» kategoriari, {g}. taldekoa.</b> Terminal hori erabiltzen duten zerbitzariek beste izen bat ikusten dute kategoriarentzat.",
  unificar: "Bateratu",
  avisoNombreRepetido: "<b>«{nombre}» izeneko bi kategoria daude</b>, {g1} eta {g2} taldeetan, {p1} eta {p2} produkturekin.",
  avisoDesiguales: "<b>Kategoria bat ez da terminal guztietara iritsi.</b> Negozioan sortuta dago baina izena falta da batzuetan, eta han produktuak ez dira taldekatuta agertzen. | <b>{n} kategoria ez dira terminal guztietara iritsi.</b> Negozioan sortuta daude baina izena falta da batzuetan, eta han produktuak ez dira taldekatuta agertzen.",
  avisoDesigualesSinNinguna: "{terminales} terminalak ez du bat ere ez. | {terminales} terminalek ez dute bat ere ez.",
  aplicarATodos: "Guztiei aplikatu",
  avisoTerminalesSinCategorias: "<b>Terminal batek ez du kategoriarik.</b> Han sortutako produktu bat ez da inon agertuko. | <b>{n} terminalek ez dute kategoriarik.</b> Han sortutako produktu bat ez da inon agertuko.",
  avisoProductosSinCategoria: "<b>Produktu bat ez dago kategoria batean ere.</b> Saltzen da, baina zerbitzariak bilatuz bakarrik iristen dira harengana. | <b>{n} produktu ez daude kategoriarik batean ere.</b> Saltzen dira, baina zerbitzariak bilatuz bakarrik iristen dira haietara.",
  avisoTerminalPendiente: "<b>{terminales} terminala berria da eta oraindik ez du bere karta igo.</b> Abiaraztean zerbitzaritik kopiatu eta igoko du; bitartean ez zaio hemendik ezer idazten eta ez da abisu hauetan kontatzen. | <b>{terminales} terminalak berriak dira eta oraindik ez dute beren karta igo.</b> Abiaraztean zerbitzaritik kopiatu eta igoko dute; bitartean ez zaie hemendik ezer idazten eta ez dira abisu hauetan kontatzen.",
  unTerminalLaLlama: "terminal batek «{otro}» deitzen dio",
  pendienteEnTerminales: "terminal 1ean falta da | {n} terminaletan falta da",
  enOtraTeclaEnTerminal: "terminal batean beste tekla batean dago; berrordenatuz konpontzen da",
  avisoSoloEnClientes: "<b>«{nombre}» ({g}. taldea) {terminales} terminalean bakarrik dago.</b> Zerbitzariak ez du, eta zerbitzariak agintzen du: sortu bertan ona bada, edo kendu terminaletik. | <b>«{nombre}» ({g}. taldea) {terminales} terminaletan bakarrik dago.</b> Zerbitzariak ez du, eta zerbitzariak agintzen du: sortu bertan ona bada, edo kendu terminal horietatik.",
  crearEnServidor: "Zerbitzarian sortu",
  quitarDelTerminal: "Terminaletik kendu | Terminaletatik kendu",
  soloEnTerminalSinServidor: "{terminales} terminalean bakarrik; zerbitzariak ez du",
  crearEnServidorTitulo: "«{nombre}» zerbitzarian sortu?",
  crearEnServidorExplica: "Zerbitzariak ez du. Bertan eta falta den terminaletan sortuko da.",
  bajaSoloEnClientes: "{terminales} terminalak bakarrik du. Zerbitzaria ez da aldatzen.",
  enTodosLosTerminales: "terminal bakarrean | {n} terminaletan",
  nombreVacio: "Izena ezin da hutsik geratu. Kendu nahi baduzu, erabili Ezabatu.",
  categoriaGuardada: "Kategoria terminalean gorde da. | Kategoria {n} terminaletan gorde da.",
  categoriaCreada: "Kategoria terminalean sortu da. | Kategoria {n} terminaletan sortu da.",
  productosMovidos: "Produktu 1 beste kategoriara eraman da. | {n} produktu beste kategoriara eraman dira.",
  productosSinCategoriaAhora: "Produktu 1 kategoriarik gabe geratu da. | {n} produktu kategoriarik gabe geratu dira.",
  categoriaEliminada: "Kategoria terminalean ezabatu da. | Kategoria {n} terminaletan ezabatu da.",
  yaEstabanOrdenadas: "Talde honetako kategoriak jarraian zeuden dagoeneko.",
  categoriasReindexadas: "Kategoria 1 mugitu da. Taldeak ez du hutsunerik. | {n} kategoria mugitu dira. Taldeak ez du hutsunerik.",
  categoriasReordenadas: "Kategoria 1 bere teklan jarri da. | {n} kategoria beren teklan jarri dira.",
  reordenarSaltados: "Ezin izan da berrordenatu hemen: {terminales}.",
  categoriasIgualadas: "Kategoria 1 berdindu da terminal guztietan. | {n} kategoria berdindu dira terminal guztietan.",
  categoriasSaltadas: "Kategoria 1ek izen desberdinak ditu terminalen artean: zuk aukeratu zein den ona. | {n} kategoriak izen desberdinak dituzte terminalen artean: zuk aukeratu zein den ona.",
  huecoConBajas: "Erretena okupatuta",
  huecoLibre: "Hutsune librea",
  eliminarCategoria: "Ezabatu «{nombre}»",
  eliminarConProductos: "Produktu 1 du barruan. Aukeratu nora doan ezabatu aurretik. | {n} produktu ditu barruan. Aukeratu nora doazen ezabatu aurretik.",
  eliminarSinProductos: "Ez du produkturik barruan. Terminalean ezabatuko da. | Ez du produkturik barruan. {n} terminaletan ezabatuko da.",
  eliminarHuecoSeQueda: "Hutsunea bere lekuan geratzen da: ez da beste kategoriarik lekuz aldatzen.",
  eligeDestino: "Aukeratu nora doazen bere produktuak.",
  moverProductosA: "Bere produktuak hona eraman...",
  sinResultadosCategoria: "Ez dago bat datorren kategoriarik",
  grupoNumero: "{g}. taldea",
  dejarlosSinCategoria: "Kategoriarik gabe utzi",
  confirmarSinCategoriaTexto: "Produktu hori ez da taldekatuta agertuko terminalean. Saltzen jarraituko da, baina zerbitzariak bilatuz bakarrik iritsiko dira harengana. | {n} produktu horiek ez dira taldekatuta agertuko terminalean. Saltzen jarraituko dira, baina zerbitzariak bilatuz bakarrik iritsiko dira haietara.",
  productosSinCategoriaTitulo: "Kategoriarik gabeko produktuak",
  productosSinCategoriaAyuda: "Ez dira terminalean multzokatuta agertzen, beraz zerbitzariek bilatuz bakarrik iristen dira haietara. Markatu nahi dituzunak eta aukeratu behean zein kategoriatara doazen.",
  productoSinNombre: "(izenik gabe)",
  enNTerminales: "{t} terminaletik 1ean | {t} terminaletik {n}ean",
  sinProductosSinCategoria: "Ez da kategoriarik gabeko produkturik geratzen.",
  asignarEstaCategoria: "Kategoria hau esleitu",
  elegirCategoriaDestino: "Aukeratu kategoria bat",
  reindexarTitulo: "{g} taldea berrindexatu?",
  reindexarQuitaHuecos: "Hutsune 1 kentzen da: kategoriak taldearen hasieran elkarren ondoan geratzen dira. | {n} hutsune kentzen dira: kategoriak taldearen hasieran elkarren ondoan geratzen dira.",
  reindexarCambiaTecla: "Kategoria 1 teklaz aldatzen da: terminalean beste leku batean agertuko da. | {n} kategoria teklaz aldatzen dira: terminalean beste leku batean agertuko dira.",
  reindexarProductosSeQuedan: "Produktuek ez dute kategoriarik aldatzen: berearekin doaz.",
  reindexarComoQueda: "Nola geratzen den:",
  reindexarSinCambios: "Talde hau jarraian dago jada: ez dago ezer berrindexatzeko.",
  unificarTitulo: "«{nombre}» bateratu?",
  aplicarTodosTitulo: "Kategoriak terminal guztiei aplikatu?",
  unificarTodosLaLlaman: "Terminal guztiek «{nombre}» deituko diote.",
  unificarPorServidor: "Terminal zerbitzariak duen izena geratzen da.",
  unificarPorMayoria: "Terminal gehienek erabiltzen duten izena geratzen da.",
  unificarCambiaEn: "Terminal batean aldatzen da: bertako zerbitzariek izen berria ikusiko dute eta aurrekoa galdu egingo da. | {n} terminaletan aldatzen da: bertako zerbitzariek izen berria ikusiko dute eta aurrekoa galdu egingo da.",
  igualarProductosSeQuedan: "Produktuak ez dira ukitzen: beren kategorian jarraitzen dute.",
  aplicarTodosEscribe: "Kategoria baten izena idatziko da falta den terminaletan. | {n} kategoriaren izena idatziko da falta den terminaletan.",
  aplicarTodosSaltadas: "Terminalen artean izen desberdinak dituen kategoria bat dagoen bezala geratzen da: bateratu bere abisutik. | Terminalen artean izen desberdinak dituzten {n} kategoria dauden bezala geratzen dira: bateratu beren abisutik.",
  igualarQueCambia: "Zer aldatzen da:",
  unificarOtroNombreBueno: "Izen ona beste bat bada, utzi eta aldatu izena arkatzarekin: jartzen duzun izena terminal guztietan gordeko da.",
  aplicarTodosFaltaEn: "falta da: {terminales}",
  aplicarTodosNada: "Ez dago ezer aplikatzeko: zain dauden kategoriek izen desberdinak dituzte terminalen artean eta lehenago bateratu behar dira.",
  igualarSeCrea: "ez du",
  igualarSinNombre: "izenik gabe",
  reordenarTitulo: "Kategoriak zerbitzarian bezala berrordenatu?",
  reordenarMandaServidor: "«{servidor}» zerbitzariaren ordenak agintzen du: beste terminaletan, kategoria bakoitza han duen teklara pasatzen da.",
  reordenarCambianTecla: "Kategoria batek tekla aldatzen du: bere terminalean beste leku batean agertuko da. | {n} kategoriak tekla aldatzen dute: beren terminalean beste leku batean agertuko dira.",
  reordenarApartadas: "Zerbitzariak ez duen kategoria bat beste tekla batera aldentzen da lekua uzteko. | Zerbitzariak ez dituen {n} kategoria beste tekla batera aldentzen dira lekua uzteko.",
  reordenarProductosSeVan: "Produktuak beren kategoriarekin doaz: batek ere ez du kategoriarik aldatzen.",
  reordenarNombresNoSeTocan: "Ez da izenik aldatzen. Gero izen-desberdintasunen bat geratzen bada, Bateratu-rekin konpontzen da.",
  reordenarSinSitio: "Terminal hau ez da berrordenatzen: ez dago tekla librerik trabatzen duten kategoriak aldentzeko.",
  reordenarSeAparta: "aldentzen da",
  reordenarAmbiguos: "Ez dira mugitzen izena errepikatuta dagoelako: {nombres}.",
  reordenarSinCambios: "Kategoriak zerbitzarian bezalako tekla berdinetan daude jada.",
  ordenPrimeroTitulo: "Lehenago berrordenatzea komeni da",
  ordenPrimeroTexto: "Terminal batzuek kategoriak zerbitzarian ez bezalako teklatan dituzte. Hau egin aurretik berrordenatzea komeni da: bestela, aldaketa okerrak gerta daitezke —adibidez, izen bat beste kategoria baten gainean jartzea— eta ez da bermatzen gero dena ondo ibiliko denik.",
  continuarIgualmente: "Jarraitu hala ere",
  reordenarPrimero: "Lehenago berrordenatu",
  // Abisuen "Nola konpondu?". Testu finkoa: v-html-rekin margotzen da.
  comoLoSoluciono: "Nola konpondu?",
  consejoOrdenAvisos: "Konpondu goitik behera: konponketa bakoitzak azpiko abisuak alda edo ken ditzake. Kargatu berriro pantaila bakoitzaren ondoren.",
  consejoOrdenDistinto: "<p>Norbaitek TPVtik bertatik kategoriak sortu edo mugitu dituenean gertatu ohi da: kategoria bera tekla batean dago zerbitzarian eta beste batean terminal horretan.</p><ol><li>Sakatu <b>Berrordenatu</b>. Terminalez terminal erakusten du zein kategoria zein teklatara pasatzen den.</li><li>Berretsi. Produktuak beren kategoriarekin doaz: ez dago berriro kokatu beharrik.</li><li>Itxaron terminala sinkronizatu arte eta egiaztatu bertan tekla bakoitzak bere produktuak dituela.</li><li>Kargatu berriro pantaila eta jarraitu beste abisuekin: orain ondo kontatzen dute.</li></ol><p>Terminal bat «ezin izan da berrordenatu» bezala ateratzen bada, 40 teklak hartuta ditu. Ezabatu bertan soberan dauden kategoriak eta berrordenatu berriro.</p><p>Abisu hau dagoen bitartean, ez bateratu izenik: izena okerreko teklan jarriko zenuke.</p>",
  consejoOtroNombre: "<p>Ia beti, norbaitek TPVan aldatu dio izena. Zerbitzariak agintzen du.</p><ul><li><b>Zerbitzariaren izena ona bada:</b> sakatu <b>Bateratu</b> eta terminal guztiek horrela deituko diote.</li><li><b>Terminalarena ona bada:</b> editatu arkatzarekin eta idatzi izen hori. Terminal guztietan gordetzen da.</li><li><b>Bi izenak kategoria desberdinenak badirudite</b> (adibidez, «BOTILAK» eta «TXUPITOAK»), ez da izen aldaketa, teklak gurutzatuta daude: berrordenatu lehenik.</li></ul><p>Konpondu arte, talde hori ezin da berrindexatu.</p>",
  consejoSoloEnClientes: "<p>Bezero-terminal batean sortu da, eta ez zerbitzarian. Erabaki aurretik, begiratu zenbat produktu dituen eta, zalantzarik baduzu, galdetu lokalean erabiltzen duten.</p><ul><li><b>Erabiltzen badute:</b> sakatu <b>Zerbitzarian sortu</b>. Bertan eta falta den terminaletan sortzen da, tekla berean.</li><li><b>Soberan badago:</b> sakatu <b>Terminaletik kendu</b> eta aukeratu zein kategoriatara pasatzen diren bere produktuak, kategoriarik gabe gera ez daitezen.</li></ul>",
  consejoNombreRepetido: "<p>Izen bereko bi teklak zerbitzaria nahasten dute, eta Berrordenatuk ez ditu mugitzen, ez baitaki zein den zein.</p><ul><li><b>Biak behar badira:</b> editatu bat arkatzarekin eta jarri bereizten duen izen bat (adibidez, «ARDO ZURIAK»).</li><li><b>Bat soberan badago:</b> ezabatu X-arekin eta pasatu bere produktuak besteari.</li></ul><p>Normalean ona produktu gehien dituena da.</p>",
  consejoDesiguales: "<p>Kategoria sortu zenean itzalita edo konexiorik gabe zeuden terminalekin gertatzen da, edo geroago gehitutako terminalekin. Errenkada bakoitzean, egoera horiak zenbat terminaletan falta den esaten du.</p><ol><li>Izen desberdinaren abisu gorriak badaude, konpondu lehenik: kategoria horiek saltatu egiten dira.</li><li>Sakatu <b>Guztiei aplikatu</b>. Idatzi aurretik, zein terminalek zer jasotzen duen erakusten du.</li><li>Berretsi eta itxaron terminalak sinkronizatu arte.</li></ol><p>Sinkronizatu ondoren terminal batean falta bada oraindik, egiaztatu piztuta eta konektatuta dagoela.</p>",
  consejoTerminalesSinCategorias: "<p>Negozioak ez du oraindik eramateko kategoriarik. Sortu itzazu talde bakoitzeko <b>Kategori bat gehitu</b> botoiarekin: terminal guztietan batera sortzen dira.</p><p>Terminal hori jada erabiltzen ez bada, eskatu baja ematea hemen kontatzeari utz diezaion.</p>",
  consejoProductosSinCategoria: "<p>Normalean helmugarik aukeratu gabe ezabatutako kategoria batetik datoz, edo kategoriarik gabe TPVan sortutako produktuetatik. Saltzen jarraitzen dute, baina zerbitzariak bilatuz bakarrik aurkitzen ditu.</p><ol><li>Joan beharko luketen kategoria ez badago, sortu lehenik <b>Kategori bat gehitu</b> botoiarekin.</li><li>Sakatu <b>Ikusi produktuak</b>, markatu elkarrekin doazenak eta aukeratu kategoria.</li><li>Sakatu <b>Kategoria hau esleitu</b>. Terminal guztietan mugitzen dira.</li><li>Errepikatu gainerakoekin.</li></ol><p>Talde jakin batekoak bere «Kategoriarik gabe» errenkadako begitik ere ikus daitezke.</p>",
  consejoTerminalPendiente: "<p>Hemen ez dago ezer egin beharrik. Piztu terminala konexioarekin: zerbitzariaren karta kopiatuko du eta, igotzean, kontu hauetan beste bat bezala sartuko da.</p><p>Denbora pasatzen bada eta oraindik ateratzen bada, egiaztatu terminala piztu dela eta konexioa duela.</p>",
};



// WEBPACK FOOTER //
// ./src/language/euskera.js